import { useState, useEffect, useCallback } from "react";
import BotonMapaProceso from "./BotonMapaProceso";
import { subirDatos, bajarDatos, eliminarDato } from "./syncSupabase";
import { supabase , authHeader} from "./supabase";
import ExcelJS from "exceljs";
import { Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell, HeadingLevel, WidthType, ShadingType } from "docx";


// ─── BASE NORMATIVA HARDCODEADA (siempre presente, sin API) ──────────────
const BASE_NORMATIVA = [
  // NACIONALES SST
  { tipo_requisito:"Ley Nacional", organismo_emisor:"MTESS", norma:"Ley 19.587", titulo:"Higiene y Seguridad en el Trabajo", aspecto:"SST", requisito:"Condiciones generales de higiene y seguridad en el trabajo", area_responsable:"H&S", evidencia:"Programa Anual H&S, registros de inspección", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Decreto", organismo_emisor:"PEN", norma:"Dec. 351/79", titulo:"Reglamentación Ley 19.587", aspecto:"SST", requisito:"Requisitos técnicos específicos por actividad (iluminación, ventilación, ruido, EPP, etc.)", area_responsable:"H&S", evidencia:"Inspecciones periódicas, mediciones ambientales", frecuencia:"Semestral", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Ley Nacional", organismo_emisor:"SRT", norma:"Ley 24.557", titulo:"Riesgos del Trabajo", aspecto:"SST", requisito:"Afiliación a ART, declaración de siniestros, cobertura de accidentes", area_responsable:"H&S", evidencia:"Póliza ART vigente, DDJJ, índices siniestralidad", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Resolución", organismo_emisor:"SRT", norma:"Res. SRT 463/09", titulo:"Registro de Accidentes e Incidentes", aspecto:"SST", requisito:"Registro y notificación de accidentes de trabajo e incidentes", area_responsable:"H&S", evidencia:"Libro de accidentes, notificaciones a ART", frecuencia:"Permanente", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Resolución", organismo_emisor:"SRT", norma:"Res. SRT 523/07", titulo:"Capacitación en H&S", aspecto:"SST", requisito:"Programa anual de capacitación en higiene y seguridad", area_responsable:"H&S", evidencia:"Registros de capacitación firmados, programa anual", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Resolución", organismo_emisor:"SRT", norma:"Res. SRT 299/11", titulo:"Exámenes Médicos", aspecto:"SST", requisito:"Exámenes médicos preocupacionales, periódicos y de egreso", area_responsable:"RRHH", evidencia:"Certificados médicos, fichas de aptitud", frecuencia:"Según vencimiento", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Decreto", organismo_emisor:"PEN", norma:"Dec. 911/96", titulo:"H&S en la Construcción", aspecto:"SST", requisito:"Requisitos específicos para trabajos de construcción y obra civil", area_responsable:"H&S", evidencia:"Programa de seguridad aprobado por ART", frecuencia:"Por obra", estado:"", fecha_evaluacion:"", observaciones:"" },

  // AMBIENTALES
  { tipo_requisito:"Ley Nacional", organismo_emisor:"SAyDS", norma:"Ley 25.675", titulo:"Ley General del Ambiente", aspecto:"Ambiental", requisito:"Gestión ambiental sustentable, prevención de daños", area_responsable:"Ambiental", evidencia:"Sistema de gestión ambiental, auditorías", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Ley Nacional", organismo_emisor:"SAyDS", norma:"Ley 24.051", titulo:"Residuos Peligrosos", aspecto:"Ambiental", requisito:"Gestión, transporte y disposición de residuos peligrosos", area_responsable:"Ambiental", evidencia:"Manifiestos, contratos con operadores habilitados", frecuencia:"Permanente", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Decreto", organismo_emisor:"PEN", norma:"Dec. 831/93", titulo:"Reglamentación Ley 24.051 — Residuos Peligrosos", aspecto:"Ambiental", requisito:"Requisitos técnicos para generadores, transportistas y operadores de residuos peligrosos", area_responsable:"Ambiental", evidencia:"Inscripción en Registro de Generadores, manifiestos de traslado", frecuencia:"Permanente", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Ley Nacional", organismo_emisor:"SAyDS", norma:"Ley 25.612", titulo:"Gestión Integral de Residuos Industriales y de Actividades de Servicio", aspecto:"Ambiental", requisito:"Gestión integral de residuos industriales: generación, transporte, tratamiento y disposición final", area_responsable:"Ambiental", evidencia:"Declaración jurada anual de residuos, contratos con operadores habilitados", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Ley Nacional", organismo_emisor:"SAyDS", norma:"Ley 26.331", titulo:"Presupuestos Mínimos de Protección Ambiental de Bosques Nativos", aspecto:"Ambiental", requisito:"Restricciones al desmonte y uso de madera con trazabilidad certificada (aplica en compras de papel/cartón con origen forestal)", area_responsable:"Ambiental", evidencia:"Certificación FSC/PEFC en materiales de origen forestal, política de compras responsables", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },

  // NORMAS DE GESTIÓN
  { tipo_requisito:"Norma Internacional", organismo_emisor:"ISO", norma:"ISO 45001:2018", titulo:"Sistemas de Gestión de SST", aspecto:"SST", requisito:"Sistema de gestión de seguridad y salud en el trabajo", area_responsable:"H&S", evidencia:"Certificado ISO 45001, auditorías internas", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Norma Internacional", organismo_emisor:"ISO", norma:"ISO 14001:2015", titulo:"Sistemas de Gestión Ambiental", aspecto:"Ambiental", requisito:"Sistema de gestión ambiental, mejora continua", area_responsable:"Ambiental", evidencia:"Certificado ISO 14001, auditorías ambientales", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Norma Internacional", organismo_emisor:"ISO", norma:"ISO 9001:2015", titulo:"Sistemas de Gestión de Calidad", aspecto:"Calidad", requisito:"Sistema de gestión de calidad, satisfacción del cliente", area_responsable:"Calidad", evidencia:"Certificado ISO 9001, auditorías internas", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Norma Internacional", organismo_emisor:"ISO", norma:"ISO 22000:2018", titulo:"Gestión de Inocuidad Alimentaria", aspecto:"Inocuidad", requisito:"Sistema de gestión de inocuidad alimentaria", area_responsable:"Calidad", evidencia:"Certificado ISO 22000, registros HACCP", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Norma Internacional", organismo_emisor:"FSSC", norma:"FSSC 22000", titulo:"Seguridad Alimentaria", aspecto:"Inocuidad", requisito:"Certificación de seguridad alimentaria en toda la cadena", area_responsable:"Calidad", evidencia:"Certificado FSSC, auditorías de tercera parte", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Norma Internacional", organismo_emisor:"Codex Alimentarius", norma:"HACCP", titulo:"Análisis de Peligros y Puntos Críticos de Control", aspecto:"Inocuidad", requisito:"Identificación y control de peligros en producción alimentaria", area_responsable:"Calidad", evidencia:"Plan HACCP documentado, registros de monitoreo PCC", frecuencia:"Permanente", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Norma Internacional", organismo_emisor:"FSC", norma:"FSC CoC", titulo:"Cadena de Custodia FSC", aspecto:"Ambiental", requisito:"Trazabilidad de materiales certificados FSC en la cadena de custodia", area_responsable:"Calidad", evidencia:"Certificado FSC CoC, registros de balance de masa", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
  { tipo_requisito:"Norma Internacional", organismo_emisor:"BRCGS", norma:"BRC Packaging", titulo:"Estándar BRC para Packaging", aspecto:"Calidad", requisito:"Requisitos de calidad e inocuidad para envases y embalajes", area_responsable:"Calidad", evidencia:"Certificado BRC, auditorías de tercera parte", frecuencia:"Anual", estado:"", fecha_evaluacion:"", observaciones:"" },
];
// ─────────────────────────────────────────────────────────────────────────────


const COLORES_STICKER = ['#fef3c7','#dcfce7','#dbeafe','#f3e8ff','#ffe4e6','#e0f2fe'];
const COLUMNAS_KANBAN = [
  { key:'pendiente',  label:'Pendiente',  color:'#6B7280', bg:'#F3F4F6', emoji:'📌' },
  { key:'en_proceso', label:'En proceso', color:'#2A7FFF', bg:'#dbeafe', emoji:'⚙️' },
  { key:'bloqueado',  label:'Bloqueado',  color:'#dc2626', bg:'#fee2e2', emoji:'🚫' },
  { key:'listo',      label:'Listo',      color:'#16a34a', bg:'#dcfce7', emoji:'✅' },
];

const STORAGE_EMPRESAS  = "alqos_consultor_empresas";
const STORAGE_VISITAS   = "alqos_consultor_visitas";
const STORAGE_HALLAZGOS = "alqos_consultor_hallazgos";
const STORAGE_STICKERS  = "alqos_consultor_stickers";
const STORAGE_TAREAS    = "alqos_consultor_tareas";
// eslint-disable-next-line no-unused-vars
const STORAGE_ASPECTOS  = "alqos_consultor_aspectos";

// eslint-disable-next-line no-unused-vars
const ESCALA_PC = [
  { valor:1, label:"Muy baja" },
  { valor:2, label:"Baja" },
  { valor:3, label:"Moderada" },
  { valor:4, label:"Alta" },
  { valor:5, label:"Muy alta" },
];

const TOOLTIPS_PC = {
  probabilidad: {
    1: "Muy improbable: nunca ocurrió, condiciones muy controladas",
    2: "Improbable: ocurrió alguna vez en años anteriores",
    3: "Probable: ocurre algunas veces al año",
    4: "Muy probable: ocurre mensualmente o con frecuencia",
    5: "Certeza: ocurre en cada turno / proceso continuo",
  },
  consecuencia: {
    1: "Despreciable: impacto mínimo, reversible de inmediato",
    2: "Baja: impacto local menor, reversible a corto plazo",
    3: "Moderada: impacto local significativo, requiere control",
    4: "Alta: impacto extendido, difícil reversión, requiere acción",
    5: "Muy alta: impacto grave o irreversible, riesgo legal",
  },
};

// eslint-disable-next-line no-unused-vars
const ETAPAS_CICLO_VIDA = [
  "Recepción de materiales","Pre-prensa","Impresión offset","Impresión digital",
  "Impresión flexográfica","Acabados / Terminación","Encuadernación",
  "Control de calidad","Almacenamiento","Despacho / Distribución",
  "Mantenimiento de equipos","Limpieza y saneamiento","Oficinas / Administración",
  "Tratamiento de residuos","Emergencias",
];

// eslint-disable-next-line no-unused-vars
const RECURSOS_AFECTADOS = [
  "Agua superficial","Agua subterránea","Aire","Suelo","Flora","Fauna",
  "Salud humana","Recursos naturales (energía / materias primas)","Paisaje / entorno visual",
];

const rubros = ["Gráfica / Imprenta","Alimentaria","Química","Metalmecánica","Textil","Construcción","Logística","Comercio","Salud","Otro"];

// Checkboxes de riesgo del perfil de empresa (Fase 3 del plan del motor regulatorio).
// Cada uno activa uno o más aspectos físicos (los que clasificamos hoy en hs_normativa_base).
// Misma taxonomía que ASPECTOS_RIESGO en LegalMatrixEngine.js — no desincronizar entre los dos módulos.
const ASPECTOS_RIESGO = [
  { key: "efluentes",         label: "💧 Efluentes líquidos (vertidos, desagües)",         ambiental: ["Efluentes Líquidos"] },
  { key: "emisiones",         label: "🌫 Emisiones atmosféricas (gases, calderas)",         ambiental: ["Emisiones Atmosféricas"] },
  { key: "residuosPeligrosos",label: "☣️ Residuos peligrosos / especiales",                 ambiental: ["Residuos Peligrosos/Especiales"] },
  { key: "residuosPatogenicos",label:"🩸 Residuos patogénicos",                             ambiental: ["Residuos Patogénicos"] },
  { key: "ruido",              label:"🔊 Ruido / vibraciones",                              ambiental: ["Ruido y Vibraciones"], sst: ["Ruido y Vibraciones (ocupacional)"] },
  { key: "agua",               label:"🚰 Consumo alto de agua",                             ambiental: ["Consumo de Agua"] },
  { key: "energia",            label:"⚡ Consumo alto de energía",                          ambiental: ["Consumo de Energía"] },
  { key: "quimicos",           label:"🧪 Sustancias químicas peligrosas / solventes",       ambiental: ["Sustancias Químicas Peligrosas"], sst: ["Sustancias Peligrosas (exposición laboral)"] },
  { key: "suelo",              label:"🏔 Riesgo de contaminación de suelo",                 ambiental: ["Contaminación de Suelo"] },
  { key: "transporteMerc",     label:"🚚 Transporte de mercancías peligrosas",              ambiental: ["Transporte de Mercancías Peligrosas"] },
  { key: "electrico",          label:"🔌 Instalación / riesgo eléctrico relevante",         sst: ["Riesgo Eléctrico"] },
  { key: "altura",             label:"🪜 Trabajo en altura",                                sst: ["Trabajo en Altura"] },
  { key: "confinados",         label:"🕳 Espacios confinados",                              sst: ["Espacios Confinados"] },
  { key: "incendio",           label:"🔥 Riesgo de incendio/explosión (calderas, presión)", sst: ["Incendios y Explosiones"] },
  { key: "maquinaria",         label:"⚙️ Maquinaria pesada / herramientas de riesgo",       sst: ["Máquinas y Herramientas"] },
];

const normativas = [
  { key:"ley19587",  label:"Ley 19.587",        desc:"Higiene y Seguridad en el Trabajo" },
  { key:"dec351",    label:"Decreto 351/79",     desc:"Reglamento Ley 19.587" },
  { key:"ley24557",  label:"Ley 24.557 (ART)",   desc:"Riesgos del Trabajo" },
  { key:"dec911",    label:"Decreto 911/96",     desc:"Construcción" },
  { key:"res905",    label:"Res. SRT 905/15",    desc:"Programa de Reducción de Siniestralidad" },
  { key:"iso9001",   label:"ISO 9001:2015",       desc:"Sistemas de Gestión de Calidad" },
  { key:"iso14001",  label:"ISO 14001:2015",     desc:"Sistemas de Gestión Ambiental" },
  { key:"iso45001",  label:"ISO 45001:2018",     desc:"Sistemas de Gestión de S&SO" },
  { key:"ley2214",   label:"Ley CABA 2214",      desc:"Higiene y Seguridad CABA" },
  { key:"dec739",    label:"Decreto CABA 739/06",desc:"Reglamento Ley CABA 2214" },
  { key:"res51",     label:"Res. SRT 51/97",     desc:"Capacitación en H&S" },
  { key:"res523",    label:"Res. SRT 523/07",    desc:"Estrategia Nacional para la Prevención" },
];


const NORMA_CATEGORIAS = {
  ley19587:   ["Documentación","EPP","Emergencias","Instalaciones","Riesgos"],
  dec351:     ["Documentación","EPP","Emergencias","Instalaciones","Riesgos"],
  ley24557:   ["Documentación"],
  dec911:     ["Instalaciones","Riesgos"],
  res905:     ["Documentación","Riesgos"],
  res51:      ["Documentación"],
  res523:     ["Documentación"],
  iso45001:   ["Documentación","EPP","Emergencias","Instalaciones","Riesgos"],
  ley2214:    ["CABA"],
  dec739:     ["CABA"],
  iso9001:    ["ISO 9001:2015"],
  iso14001:   ["ISO 14001:2015"],
};
const itemsChecklist = [
  { id:"c01", categoria:"Documentación", texto:"Programa Anual H&S vigente y aprobado por dirección", ref:"Ley 19.587 Art. 5", norma_base:"Ley 19.587" },
  { id:"c02", categoria:"Documentación", texto:"Registro de accidentes e incidentes actualizado", ref:"Ley 24.557 Art. 31", norma_base:"Ley 24.557" },
  { id:"c03", categoria:"Documentación", texto:"Nómina de empleados con exámenes médicos al día", ref:"Dec. 351/79 Art. 37", norma_base:"Decreto 351/79" },
  { id:"c04", categoria:"Documentación", texto:"Certificados de capacitación H&S (mín. 8hs anuales)", ref:"Res. SRT 51/97", norma_base:"Resolución SRT 51/97" },
  { id:"c05", categoria:"Documentación", texto:"Contrato ART vigente y publicado", ref:"Ley 24.557 Art. 26", norma_base:"Ley 24.557" },
  { id:"c06", categoria:"EPP", texto:"Registro de entrega de EPP firmado por cada empleado", ref:"Dec. 351/79 Art. 190", norma_base:"Decreto 351/79" },
  { id:"c07", categoria:"EPP", texto:"EPP en buen estado y dentro de vida útil", ref:"Dec. 351/79 Art. 191", norma_base:"Decreto 351/79" },
  { id:"c08", categoria:"EPP", texto:"EPP adecuado al riesgo de cada puesto", ref:"Dec. 351/79 Art. 188", norma_base:"Decreto 351/79" },
  { id:"c09", categoria:"Emergencias", texto:"Plan de emergencias y evacuación documentado", ref:"Dec. 351/79 Art. 172", norma_base:"Decreto 351/79" },
  { id:"c10", categoria:"Emergencias", texto:"Simulacro realizado en los últimos 12 meses", ref:"Dec. 351/79 Art. 172", norma_base:"Decreto 351/79" },
  { id:"c11", categoria:"Emergencias", texto:"Matafuegos vigentes (carga y vencimiento)", ref:"Dec. 351/79 Art. 176", norma_base:"Decreto 351/79" },
  { id:"c12", categoria:"Emergencias", texto:"Salidas de emergencia señalizadas y libres", ref:"Dec. 351/79 Art. 160", norma_base:"Decreto 351/79" },
  { id:"c13", categoria:"Instalaciones", texto:"Iluminación adecuada en todos los puestos", ref:"Dec. 351/79 Art. 71", norma_base:"Decreto 351/79" },
  { id:"c14", categoria:"Instalaciones", texto:"Ventilación suficiente en áreas de trabajo", ref:"Dec. 351/79 Art. 64", norma_base:"Decreto 351/79" },
  { id:"c15", categoria:"Instalaciones", texto:"Orden y limpieza general de planta", ref:"Dec. 351/79 Art. 42", norma_base:"Decreto 351/79" },
  { id:"c16", categoria:"Instalaciones", texto:"Señalización de riesgos y vías de circulación", ref:"Dec. 351/79 Art. 160", norma_base:"Decreto 351/79" },
  { id:"c17", categoria:"Instalaciones", texto:"Instalación eléctrica en buen estado y certificada", ref:"Dec. 351/79 Art. 95", norma_base:"Decreto 351/79" },
  { id:"c18", categoria:"Instalaciones", texto:"Baños y vestuarios en condiciones reglamentarias", ref:"Dec. 351/79 Art. 46", norma_base:"Decreto 351/79" },
  { id:"c19", categoria:"Riesgos", texto:"Identificación y evaluación de riesgos por puesto", ref:"ISO 45001 §6.1.2", norma_base:"ISO 45001:2018" },
  { id:"c20", categoria:"Riesgos", texto:"Mediciones de ruido en puestos críticos", ref:"Dec. 351/79 Anexo V", norma_base:"Decreto 351/79" },
  { id:"c21", categoria:"Riesgos", texto:"Manipulación manual de cargas controlada", ref:"Dec. 351/79 Art. 115", norma_base:"Decreto 351/79" },
  { id:"c22", categoria:"Riesgos", texto:"Sustancias peligrosas identificadas con hojas de seguridad", ref:"Dec. 351/79 Art. 145", norma_base:"Decreto 351/79" },
  { id:"c23", categoria:"CABA", texto:"Habilitación municipal vigente", ref:"Ley CABA 2214", norma_base:"Ley CABA 2214" },
  { id:"c24", categoria:"CABA", texto:"Responsable H&S designado y registrado ante GCBA", ref:"Ley CABA 2214 Art. 12", norma_base:"Ley CABA 2214" },
  { id:"q01", categoria:"ISO 9001:2015", texto:"Política de calidad documentada, comunicada y disponible", ref:"ISO 9001:2015 §5.2", norma_base:"ISO 9001:2015" },
  { id:"q02", categoria:"ISO 9001:2015", texto:"Objetivos de calidad medibles y con seguimiento", ref:"ISO 9001:2015 §6.2", norma_base:"ISO 9001:2015" },
  { id:"q03", categoria:"ISO 9001:2015", texto:"Procedimientos documentados para procesos críticos", ref:"ISO 9001:2015 §4.4", norma_base:"ISO 9001:2015" },
  { id:"q04", categoria:"ISO 9001:2015", texto:"Registro y seguimiento de no conformidades", ref:"ISO 9001:2015 §10.2", norma_base:"ISO 9001:2015" },
  { id:"q05", categoria:"ISO 9001:2015", texto:"Acciones correctivas implementadas y verificadas", ref:"ISO 9001:2015 §10.2.1", norma_base:"ISO 9001:2015" },
  { id:"q06", categoria:"ISO 9001:2015", texto:"Programa de auditorías internas vigente", ref:"ISO 9001:2015 §9.2", norma_base:"ISO 9001:2015" },
  { id:"q07", categoria:"ISO 9001:2015", texto:"Revisión por la dirección realizada en el último año", ref:"ISO 9001:2015 §9.3", norma_base:"ISO 9001:2015" },
  { id:"q08", categoria:"ISO 9001:2015", texto:"Control de documentos y registros actualizado", ref:"ISO 9001:2015 §7.5", norma_base:"ISO 9001:2015" },
  { id:"q09", categoria:"ISO 9001:2015", texto:"Evaluación y seguimiento de proveedores críticos", ref:"ISO 9001:2015 §8.4", norma_base:"ISO 9001:2015" },
  { id:"q10", categoria:"ISO 9001:2015", texto:"Competencias del personal definidas y verificadas", ref:"ISO 9001:2015 §7.2", norma_base:"ISO 9001:2015" },
  { id:"a01", categoria:"ISO 14001:2015", texto:"Política ambiental documentada y comunicada", ref:"ISO 14001:2015 §5.2", norma_base:"ISO 14001:2015" },
  { id:"a02", categoria:"ISO 14001:2015", texto:"Aspectos e impactos ambientales identificados y evaluados", ref:"ISO 14001:2015 §6.1.2", norma_base:"ISO 14001:2015" },
  { id:"a03", categoria:"ISO 14001:2015", texto:"Objetivos ambientales con planes de acción definidos", ref:"ISO 14001:2015 §6.2", norma_base:"ISO 14001:2015" },
  { id:"a04", categoria:"ISO 14001:2015", texto:"Gestión y disposición adecuada de residuos", ref:"ISO 14001:2015 §8.1", norma_base:"ISO 14001:2015" },
  { id:"a05", categoria:"ISO 14001:2015", texto:"Control de emisiones y efluentes documentado", ref:"ISO 14001:2015 §8.1", norma_base:"ISO 14001:2015" },
  { id:"a06", categoria:"ISO 14001:2015", texto:"Plan de emergencia ambiental documentado y practicado", ref:"ISO 14001:2015 §8.2", norma_base:"ISO 14001:2015" },
  { id:"a07", categoria:"ISO 14001:2015", texto:"Cumplimiento de requisitos legales ambientales verificado", ref:"ISO 14001:2015 §9.1.2", norma_base:"ISO 14001:2015" },
  { id:"a08", categoria:"ISO 14001:2015", texto:"Monitoreo y medición de desempeño ambiental activo", ref:"ISO 14001:2015 §9.1", norma_base:"ISO 14001:2015" },
];

const estadosHallazgo = {
  critico:  { label:"🚨 Crítico",   color:"#e63946", bg:"#fee2e2" },
  mayor:    { label:"⚠️ Mayor",     color:"#f97316", bg:"#ffedd5" },
  menor:    { label:"🔵 Menor",     color:"#3b82f6", bg:"#dbeafe" },
  ok:       { label:"✅ Conforme",  color:"#22c55e", bg:"#dcfce7" },
};

const estadosVisita = {
  planificada: { label:"📅 Planificada", color:"#6b7280" },
  en_curso:    { label:"🔄 En curso",    color:"#3b82f6" },
  cerrada:     { label:"✅ Cerrada",     color:"#22c55e" },
};

function generarCod(pref, lista) {
  return `${pref}-${new Date().getFullYear()}-${String(lista.length+1).padStart(3,"0")}`;
}
function fechaHoy() { return new Date().toISOString().slice(0,10); }

// "Documental / Transversal" y "General SST" siempre quedan activos: son obligaciones
// administrativas que no dependen de un aspecto físico puntual, aplican siempre.
// A diferencia de calcularAspectosActivos en LegalMatrixEngine.js (usa empresaSel de state),
// esta recibe la empresa como parámetro.
function calcularAspectosActivosEmpresa(empresa) {
  const ambiental = new Set(["Documental / Transversal"]);
  const sst = new Set(["General SST", "Accidentes y Enfermedades del Trabajo"]);
  const marcados = empresa?.aspectosRiesgo || {};
  ASPECTOS_RIESGO.forEach(a => {
    if (!marcados[a.key]) return;
    (a.ambiental || []).forEach(t => ambiental.add(t));
    (a.sst || []).forEach(t => sst.add(t));
  });
  return { ambiental, sst };
}

// Filtro fino por aspecto físico: una norma Ambiental o SST solo pasa si algún aspecto que
// declara coincide con lo que la empresa marcó. Si la norma no tiene aspecto clasificado
// (columna vacía), no se descarta por las dudas (fail-open).
function filtrarNormasPorAspecto(normas, empresa) {
  const { ambiental: aspAmbActivos, sst: aspSstActivos } = calcularAspectosActivosEmpresa(empresa);
  return (normas || []).filter(n => {
    if (n.categoria === "Ambiental") {
      const tags = n.aspectos_ambientales || [];
      if (tags.length === 0) return true;
      return tags.some(t => aspAmbActivos.has(t));
    }
    if (n.categoria === "SST") {
      const tags = n.aspectos_sst || [];
      if (tags.length === 0) return true;
      return tags.some(t => aspSstActivos.has(t));
    }
    return true;
  });
}

function repararJSONGenerico(texto) {
  let resultado = texto || "";
  try {
    let clean = resultado;
    const first = clean.indexOf("{");
    const last = clean.lastIndexOf("}");
    if (first === -1 || last === -1 || last <= first) return null;
    clean = clean.slice(first, last + 1);
    try {
      return JSON.parse(clean);
    } catch (e1) {
      let fixed = clean;
      const lastCompleteObj = fixed.lastIndexOf("},");
      const lastCompleteObj2 = fixed.lastIndexOf("}\n");
      const cutAt = Math.max(lastCompleteObj, lastCompleteObj2);
      if (cutAt > 0) fixed = fixed.slice(0, cutAt + 1);
      let braces = 0, brackets = 0, inStr = false, escape = false;
      for (const ch of fixed) {
        if (escape) { escape = false; continue; }
        if (ch === "\\" && inStr) { escape = true; continue; }
        if (ch === '"') { inStr = !inStr; continue; }
        if (inStr) continue;
        if (ch === "{") braces++;
        if (ch === "}") braces--;
        if (ch === "[") brackets++;
        if (ch === "]") brackets--;
      }
      while (brackets > 0) { fixed += "]"; brackets--; }
      while (braces > 0)   { fixed += "}"; braces--; }
      try { return JSON.parse(fixed); }
      catch (e2) { console.error("repararJSONGenerico: parse falló", e2); return null; }
    }
  } catch (e) { console.error("repararJSONGenerico:", e); return null; }
}

export default function ConsultorHS({ onVolver, oscuro, usuario }) {
  const [empresas,   setEmpresas]   = useState([]);
  const [visitas,    setVisitas]    = useState([]);
  const [hallazgos,  setHallazgos]  = useState([]);
  const [vista,      setVista]      = useState("dashboard");
  const [empresaSel, setEmpresaSel] = useState(null);
  const [visitaSel,  setVisitaSel]  = useState(null);
  const [tabEmpresa, setTabEmpresa] = useState("visitas");
  const [formEmpresa,setFormEmpresa]= useState({ rubro:"Gráfica / Imprenta", sitios:[] });
  const [editandoEmpresa, setEditandoEmpresa] = useState(null);
  const [formVisita, setFormVisita] = useState({ fecha:fechaHoy(), estado:"planificada" });
  const [checkItems, setCheckItems] = useState({});
  const [ariaCargando,setAriaCargando]=useState(false);
  const [ariaItemCargando,setAriaItemCargando]=useState(null);
  const [ariaRespuesta,setAriaRespuesta]=useState("");
  const [ncMatrizAbierto, setNcMatrizAbierto] = useState(null);
  const [ncMatrizForm, setNcMatrizForm] = useState({ visitaId:"", severidad:"mayor", observacion:"" });
  const [ncMatrizCargando, setNcMatrizCargando] = useState(false);
  const [normativaAria, setNormativaAria] = useState("");
  const [normativaCargando, setNormativaCargando] = useState(false);
  const [normativaHistorial, setNormativaHistorial] = useState([]);
  const [matrizEstado, setMatrizEstado] = useState([]);
  const [normasBaseVerif, setNormasBaseVerif] = useState([]);
  const [normaVerificando, setNormaVerificando] = useState(null);
  const [guardandoAnalisis, setGuardandoAnalisis] = useState(false);
  const [syncing,    setSyncing]    = useState(false);
  const [stickers,   setStickers]   = useState([]);
  const [tareas,     setTareas]     = useState([]);
  const [stickerTexto,setStickerTexto]=useState('');
  const [stickerColor,setStickerColor]=useState(COLORES_STICKER[0]);
  const [showFormSticker,setShowFormSticker]=useState(false);
  const [showFormTarea,setShowFormTarea]=useState(false);
  const [formTarea,  setFormTarea]  = useState({ columna:'pendiente', prioridad:'media' });
  const [dragId,     setDragId]     = useState(null);
  const [dragOver,   setDragOver]   = useState(null);
  const [tabPanel,   setTabPanel]   = useState('notas');
  const [orgIdsUsuario, setOrgIdsUsuario] = useState(null); // null = sin cargar, [] = sin orgs, [1,2] = ids
  const [usoAriaMes, setUsoAriaMes] = useState(0);
  const [busquedaEmp, setBusquedaEmp] = useState("");
  const [agendaData, setAgendaData] = useState({});
  const [agendaCargando, setAgendaCargando] = useState(false);
  const [agendaVisible, setAgendaVisible] = useState(false);
  const [enriqueciendoBase, setEnriqueciendoBase] = useState(false);
  const [progresoEnriquecer, setProgresoEnriquecer] = useState(null);
  const [generandoMatrizAgente, setGenerandoMatrizAgente] = useState(false);
  const [progresoAgente, setProgresoAgente] = useState("");
  const [actualizandoMatriz, setActualizandoMatriz] = useState(false);
  const [programaAnualData, setProgramaAnualData] = useState(null);
  const [programaAnualTexto, setProgramaAnualTexto] = useState("");
  const [programaCargando, setProgramaCargando] = useState(false);
  const [programaAnualLoadedFor, setProgramaAnualLoadedFor] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [aspectos,            setAspectosState]       = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [objetivos,           setObjetivos]           = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [aspectoForm,         setAspectoForm]          = useState({ etapa:"", aspecto:"", impacto:"", tipo:"Negativo", recurso:"", probabilidad:1, consecuencia:1, flag_lp:false, flag_pi:false, flag_en:false, condicion:"Normal", descripcion_control:"" });
  // eslint-disable-next-line no-unused-vars
  const [filtroSignificancia, setFiltroSignificancia]  = useState("todos");
  // eslint-disable-next-line no-unused-vars
  const [aspectoCargando,     setAspectoCargando]      = useState(false);
  const [showAspectoForm,     setShowAspectoForm]       = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [normativasAmbientales,    setNormativasAmbientales]    = useState("");
  // eslint-disable-next-line no-unused-vars
  const [normativaAmbientalCargando, setNormativaAmbientalCargando] = useState(false);
  const [normativaAmbientalHistorial, setNormativaAmbientalHistorial] = useState([]);
  const [guardandoAnalisisAmb,        setGuardandoAnalisisAmb]        = useState(false);

  const [planAccionAbierto, setPlanAccionAbierto] = useState(null);
  const [planAccionForm,    setPlanAccionForm]    = useState({});
  const [dashboardAmbData,     setDashboardAmbData]     = useState([]);
  const [dashboardAmbCargando, setDashboardAmbCargando] = useState(false);
  const [accionesUrgPanel, setAccionesUrgPanel] = useState(true);
  const [objFormAbierto,   setObjFormAbierto]   = useState(false);
  const [objEditId,        setObjEditId]        = useState(null);
  const [objForm,          setObjForm]          = useState({});
  const [objMedAbierto,    setObjMedAbierto]    = useState(null);
  const [objMedForm,       setObjMedForm]       = useState({ fecha:"", valor:"", observaciones:"" });
  const [customItemTexto,  setCustomItemTexto]  = useState('');
  const [customItemRef,    setCustomItemRef]    = useState('');
  const [customItemCat,    setCustomItemCat]    = useState('');

  const bg      = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg  = oscuro ? "#0d2160" : "white";
  const texto   = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde   = oscuro ? "#1e3a8a" : "#eee";
  const navBg   = oscuro ? "#060f30" : "#09184D";
  const subtexto= oscuro ? "#9aabd4" : "#808085";
  // const esAdmin = usuario?.rol === "Administrador";

  const inp = { width:"100%", padding:"8px 12px", borderRadius:"8px", border:`1px solid ${borde}`, fontSize:"13px", boxSizing:"border-box", marginTop:"4px", background:cardBg, color:texto };
  const lbl = { fontSize:"12px", color:subtexto, fontWeight:"600", display:"block", marginTop:"12px" };
  const card= { background:cardBg, borderRadius:"12px", padding:"1.2rem 1.5rem", border:`1px solid ${borde}`, marginBottom:"12px" };

  const cargarLocal = useCallback(() => {
    try {
      setEmpresas(JSON.parse(localStorage.getItem(STORAGE_EMPRESAS)  || "[]"));
      setVisitas( JSON.parse(localStorage.getItem(STORAGE_VISITAS)   || "[]"));
      setHallazgos(JSON.parse(localStorage.getItem(STORAGE_HALLAZGOS)|| "[]"));
      setStickers(JSON.parse(localStorage.getItem(STORAGE_STICKERS)  || "[]"));
      setTareas(  JSON.parse(localStorage.getItem(STORAGE_TAREAS)    || "[]"));
      setAspectosState(JSON.parse(localStorage.getItem(STORAGE_ASPECTOS) || "[]"));
      setObjetivos(JSON.parse(localStorage.getItem("alqos_consultor_objetivos") || "[]"));
    } catch {}
  }, []);

  // Se reusa tanto en sincronizar() (sync general al abrir el módulo) como en
  // cargarDashboardAmbiental() (recarga puntual de aspectos) — cualquier lectura de estas tablas
  // tiene que pasar por acá, nunca por bajarDatos() suelto (que trae la tabla entera sin WHERE).
  const sincronizarScoped = useCallback(async (tabla, storageKey, campoEmpresa, idsEmpresasVisibles) => {
    const esAdministrador = usuario?.rol === "Administrador";
    let q = supabase.from(tabla).select("data");
    if (!esAdministrador) q = q.in(`data->>${campoEmpresa}`, idsEmpresasVisibles);
    const { data, error } = await q;
    if (error) { console.error(`Error sincronizando ${storageKey}:`, error); return; }
    localStorage.setItem(storageKey, JSON.stringify((data || []).map(r => r.data)));
  }, [usuario]);

  // Filtra server-side por organizacion_id (empresas) y por empresaId/empresa_id (visitas,
  // hallazgos, aspectos, objetivos) para usuarios no-Administrador — antes traían las 7 tablas
  // enteras (bajarDatos, sin WHERE) y el recorte a "lo mío" pasaba recién en el render
  // (ver empresasVisibles más abajo). stickers y tareas NO tienen ningún campo de empresa ni
  // organización en su modelo de datos (se crean solo con {id, texto/campos, fecha, usuario}) —
  // no hay ningún campo real para filtrar sin agregar una columna nueva, así que quedan
  // compartidas entre todos los asesores como ya estaban (esto es una decisión de producto
  // pendiente, no algo que se pueda resolver acotando una query).
  const sincronizar = useCallback(async () => {
    const esAdministrador = usuario?.rol === "Administrador";
    if (!esAdministrador && orgIdsUsuario === null) return; // esperar a conocer las organizaciones del usuario
    setSyncing(true);
    try {
      let queryEmpresas = supabase.from("hs_consultor_empresas").select("data");
      if (!esAdministrador) queryEmpresas = queryEmpresas.in("data->>organizacion_id", (orgIdsUsuario || []).map(String));
      const { data: empresasData, error: errEmp } = await queryEmpresas;
      if (errEmp) throw errEmp;
      const listaEmpresas = (empresasData || []).map(r => r.data);
      localStorage.setItem(STORAGE_EMPRESAS, JSON.stringify(listaEmpresas));
      const idsEmpresasVisibles = listaEmpresas.map(e => String(e.id));

      await Promise.allSettled([
        sincronizarScoped("hs_consultor_visitas", STORAGE_VISITAS, "empresaId", idsEmpresasVisibles),
        sincronizarScoped("hs_consultor_hallazgos", STORAGE_HALLAZGOS, "empresaId", idsEmpresasVisibles),
        sincronizarScoped("hs_consultor_aspectos", STORAGE_ASPECTOS, "empresa_id", idsEmpresasVisibles),
        sincronizarScoped("hs_consultor_objetivos", "alqos_consultor_objetivos", "empresa_id", idsEmpresasVisibles),
        bajarDatos(STORAGE_STICKERS),
        bajarDatos(STORAGE_TAREAS),
      ]);
    } catch (e) {
      console.error("Error sincronizando datos de Consultor HS:", e);
    }
    cargarLocal();
    setSyncing(false);
  }, [cargarLocal, usuario, orgIdsUsuario, sincronizarScoped]);

  useEffect(() => {
    if (usuario?.rol === "Administrador") { setOrgIdsUsuario([]); return; }
    supabase.from("usuario_organizaciones").select("organizacion_id").eq("usuario_id", usuario?.id)
      .then(({ data }) => setOrgIdsUsuario((data||[]).map(r => r.organizacion_id)));
  }, [usuario]);

  // Este efecto también se re-dispara cuando cambia orgIdsUsuario, indirectamente: sincronizar
  // (useCallback de la línea 352) tiene orgIdsUsuario en su propio array de dependencias, así que
  // al cambiar cambia de identidad y eso re-dispara este efecto. No sacar orgIdsUsuario del array
  // de deps de sincronizar sin reemplazar este mecanismo de reintento — si se saca, un usuario
  // no-Administrador puede quedarse con la app vacía en el primer render tras el login.
  useEffect(() => { cargarLocal(); sincronizar(); }, [cargarLocal, sincronizar]);

  const guardarEmpresas  = (lista) => { localStorage.setItem(STORAGE_EMPRESAS,  JSON.stringify(lista)); setEmpresas(lista);  subirDatos(STORAGE_EMPRESAS); };
  const guardarVisitas   = (lista) => { localStorage.setItem(STORAGE_VISITAS,   JSON.stringify(lista)); setVisitas(lista);   subirDatos(STORAGE_VISITAS); };
  const guardarHallazgos = (lista) => { localStorage.setItem(STORAGE_HALLAZGOS, JSON.stringify(lista)); setHallazgos(lista); subirDatos(STORAGE_HALLAZGOS); };
  const guardarStickers  = (lista) => { localStorage.setItem(STORAGE_STICKERS,  JSON.stringify(lista)); setStickers(lista);  subirDatos(STORAGE_STICKERS); };
  const guardarTareas    = (lista) => { localStorage.setItem(STORAGE_TAREAS,    JSON.stringify(lista)); setTareas(lista);    subirDatos(STORAGE_TAREAS); };

  const agregarSticker = () => {
    if (!stickerTexto.trim()) return;
    guardarStickers([{ id:Math.floor(Date.now()), texto:stickerTexto, color:stickerColor, fecha:new Date().toISOString().slice(0,10), usuario:usuario?.nombre||'Sistema' }, ...stickers]);
    setStickerTexto(''); setShowFormSticker(false);
  };

  const moverTarea = (tareaId, nuevaColumna) => {
    guardarTareas(tareas.map(t => t.id===tareaId ? {...t, columna:nuevaColumna} : t));
  };

  const agregarTarea = () => {
    if (!formTarea.titulo?.trim()) return;
    guardarTareas([...tareas, { ...formTarea, id:Math.floor(Date.now()), fecha:new Date().toISOString().slice(0,10), usuario:usuario?.nombre||'Sistema' }]);
    setFormTarea({ columna:'pendiente', prioridad:'media' });
    setShowFormTarea(false);
  };

  // ── KPIs dashboard ──
  const visitasEmpresa = (eId) => visitas.filter(v => v.empresaId === eId);
  const hallazgosVisita = (vId) => hallazgos.filter(h => h.visitaId === vId);
  const puntajeVisita = (vId) => {
    const hv = hallazgosVisita(vId);
    if (!hv.length) return null;
    const total = hv.length;
    const ok = hv.filter(h => h.estado === "ok").length;
    return Math.round((ok / total) * 100);
  };

  // ── ARIA ──
  const marcarItem = (itemId, estado, obs) => {
    if (!visitaSel) return;
    const nuevo = { ...checkItems, [itemId]: { estado, observacion:obs||"" } };
    setCheckItems(nuevo);
    const visitaAct = visitas.map(v => v.id===visitaSel.id ? { ...v, checkItems:nuevo } : v);
    guardarVisitas(visitaAct);
    setVisitaSel(prev => ({ ...prev, checkItems:nuevo }));
    const existente = hallazgos.find(h => h.itemId === itemId && h.visitaId === visitaSel.id);
    const itemData = [...itemsChecklist, ...(empresas.find(e=>e.id===visitaSel.empresaId)?.itemsCustom||[])].find(i => i.id === itemId);
    let nuevosHallazgos = hallazgos;
    if (estado !== "ok") {
      const hallazgo = {
        id: existente?.id || Math.floor(Date.now()),
        itemId, visitaId:visitaSel.id, empresaId:visitaSel.empresaId,
        estado, observacion:obs||itemData?.texto||"",
        referencia:itemData?.ref||"", categoria:itemData?.categoria||"",
        norma_base:itemData?.norma_base||"",
        fecha:visitaSel.fecha, creadoPor:usuario?.nombre||"Sistema",
      };
      nuevosHallazgos = existente
        ? hallazgos.map(h => h.id===existente.id ? hallazgo : h)
        : [...hallazgos, hallazgo];
      guardarHallazgos(nuevosHallazgos);
    } else if (existente) {
      nuevosHallazgos = hallazgos.filter(h => h.id !== existente.id);
      guardarHallazgos(nuevosHallazgos);
      eliminarDato(STORAGE_HALLAZGOS, existente.id);
    }

    // ── Vincular con matriz legal (checklist ↔ matriz) ──
    if (itemData?.norma_base && matrizEstado.length > 0) {
      const empresaId = visitaSel.empresaId;
      const normaBase = itemData.norma_base;
      // ¿quedan hallazgos abiertos (no "ok") para esta norma, en cualquier visita de esta empresa?
      const hayAbiertos = nuevosHallazgos.some(h =>
        h.empresaId === empresaId && h.norma_base === normaBase && h.estado !== "ok"
      );
      const matrizNueva = matrizEstado.map(fila => {
        if (fila.norma !== normaBase) return fila;
        if (hayAbiertos) {
          return {
            ...fila,
            estado: "NC",
            observaciones: `${itemData.texto} — ${obs || estadosHallazgo[estado]?.label || estado} (Visita ${visitaSel.codigo})`,
            fecha_evaluacion: new Date().toLocaleDateString("es-AR"),
          };
        } else {
          return { ...fila, estado: "C", observaciones: "-", fecha_evaluacion: new Date().toLocaleDateString("es-AR") };
        }
      });
      setMatrizEstado(matrizNueva);
      guardarMatrizEstado(empresaId, matrizNueva);
    }
  };

  const ariaRedactarObservacion = async (item, estadoHallazgo) => {
    if (!estadoHallazgo || estadoHallazgo === "ok") return;
    setAriaItemCargando(item.id);
    try {
      const resp = await fetch("/api/aria", {
        method:"POST",
        headers:{ ...(await authHeader()), "Content-Type":"application/json", "anthropic-version":"2023-06-01", },
        body: JSON.stringify({
          model:"claude-sonnet-4-6",
          max_tokens:300,
          messages:[{ role:"user", content:`Sos un inspector de Higiene y Seguridad en Argentina. Redactá una observación técnica breve (2-3 líneas) para un hallazgo de tipo "${estadoHallazgo}" sobre el siguiente ítem: "${item.texto}". Normativa de referencia: ${item.ref}. La observación debe ser en tono formal, mencionar la normativa incumplida y sugerir la acción correctiva concreta. Sin introducción, ir directo a la observación.` }]
        })
      });
      const data = await resp.json();
      const texto = data.content?.[0]?.text || "";
      marcarItem(item.id, estadoHallazgo, texto);
    } catch(e) { console.error(e); }
    setAriaItemCargando(null);
  };

  // ── GENERAR NC DESDE LA MATRIZ LEGAL ──
  const riesgoToSeveridad = (riesgo) => {
    if (riesgo === "CRITICO") return "critico";
    if (riesgo === "ALTO") return "mayor";
    return "menor";
  };

  const abrirFormNCMatriz = (fila) => {
    setNcMatrizAbierto(fila.norma);
    setNcMatrizForm({ visitaId:"", severidad:riesgoToSeveridad(fila.riesgo), observacion:"" });
  };

  const ariaProponeObservacionMatriz = async (fila) => {
    setNcMatrizCargando(true);
    try {
      const resp = await fetch("/api/aria", {
        method:"POST",
        headers:{ ...(await authHeader()), "Content-Type":"application/json", "anthropic-version":"2023-06-01", },
        body: JSON.stringify({
          model:"claude-sonnet-4-6",
          max_tokens:300,
          messages:[{ role:"user", content:`Sos un inspector de Higiene y Seguridad en Argentina. Redactá una observación técnica breve (2-3 líneas) para un hallazgo de incumplimiento de la norma "${fila.norma}" (${fila.titulo}). Artículo aplicable: ${fila.articulo_aplicable||"sin dato"}. Evidencia que debería existir y no se verificó: ${fila.evidencia||"sin dato"}. Sanciones posibles: ${fila.sanciones||"sin dato"}. La observación debe ser en tono formal, mencionar la normativa incumplida y sugerir la acción correctiva concreta. Sin introducción, ir directo a la observación.` }]
        })
      });
      const data = await resp.json();
      const texto = data.content?.[0]?.text || "";
      setNcMatrizForm(f => ({ ...f, observacion: texto }));
    } catch(e) { console.error(e); }
    setNcMatrizCargando(false);
  };

  const guardarNCDesdeMatriz = (fila) => {
    if (!empresaSel || !ncMatrizForm.observacion.trim()) return;
    const visita = ncMatrizForm.visitaId ? visitas.find(v => String(v.id) === String(ncMatrizForm.visitaId)) : null;
    const nuevoHallazgo = {
      id: Math.floor(Date.now()),
      itemId: null,
      visitaId: visita ? visita.id : null,
      empresaId: empresaSel.id,
      estado: ncMatrizForm.severidad,
      observacion: ncMatrizForm.observacion,
      referencia: (fila.articulo_aplicable && fila.articulo_aplicable !== "-") ? `${fila.norma} ${fila.articulo_aplicable}` : fila.norma,
      categoria: fila.aspecto || "",
      norma_base: fila.norma,
      fecha: visita ? visita.fecha : fechaHoy(),
      creadoPor: usuario?.nombre || "Sistema",
      origen: "matriz",
    };
    guardarHallazgos([...hallazgos, nuevoHallazgo]);

    const matrizNueva = matrizEstado.map(m => m.norma === fila.norma
      ? { ...m, estado:"NC", observaciones: ncMatrizForm.observacion, fecha_evaluacion: new Date().toLocaleDateString("es-AR") }
      : m
    );
    setMatrizEstado(matrizNueva);
    guardarMatrizEstado(empresaSel.id, matrizNueva);

    setNcMatrizAbierto(null);
    setNcMatrizForm({ visitaId:"", severidad:"mayor", observacion:"" });
  };

  const resolverHallazgo = (hallazgoId) => {
    const hallazgo = hallazgos.find(h => h.id === hallazgoId);
    if (!hallazgo) return;
    const nuevosHallazgos = hallazgos.map(h => h.id === hallazgoId ? { ...h, estado:"ok" } : h);
    guardarHallazgos(nuevosHallazgos);

    if (hallazgo.norma_base && matrizEstado.length > 0) {
      const hayAbiertos = nuevosHallazgos.some(h =>
        h.empresaId === hallazgo.empresaId && h.norma_base === hallazgo.norma_base && h.estado !== "ok"
      );
      if (!hayAbiertos) {
        const matrizNueva = matrizEstado.map(m => m.norma === hallazgo.norma_base
          ? { ...m, estado:"C", observaciones:"-", fecha_evaluacion: new Date().toLocaleDateString("es-AR") }
          : m
        );
        setMatrizEstado(matrizNueva);
        guardarMatrizEstado(hallazgo.empresaId, matrizNueva);
      }
    }
  };

  const generarInforme = async () => {
    if (!visitaSel) return;
    setAriaCargando(true);
    setAriaRespuesta("");
    const empresa = empresas.find(e => e.id === visitaSel.empresaId);
    const hv = hallazgosVisita(visitaSel.id);
    const criticos = hv.filter(h => h.estado === "critico");
    const mayores  = hv.filter(h => h.estado === "mayor");
    const menores  = hv.filter(h => h.estado === "menor");
    const conformes= hv.filter(h => h.estado === "ok");
    const puntaje  = puntajeVisita(visitaSel.id);
    try {
      const resp = await fetch("/api/aria", {
        method:"POST",
        headers:{ ...(await authHeader()), "Content-Type":"application/json", "anthropic-version":"2023-06-01", },
        body: JSON.stringify({
          model:"claude-sonnet-4-6",
          max_tokens:1500,
          messages:[{ role:"user", content:`Sos un consultor senior de Higiene y Seguridad en Argentina. Generá un informe de visita profesional para la empresa "${empresa?.nombre}" (rubro: ${empresa?.rubro}) basado en la siguiente inspección.

Fecha: ${visitaSel.fecha}
Puntaje de cumplimiento: ${puntaje}%
Hallazgos críticos (${criticos.length}): ${criticos.map(h=>h.observacion).join(" | ")}
Hallazgos mayores (${mayores.length}): ${mayores.map(h=>h.observacion).join(" | ")}
Hallazgos menores (${menores.length}): ${menores.map(h=>h.observacion).join(" | ")}
Ítems conformes: ${conformes.length}

Normativas aplicables: Ley 19.587, Decreto 351/79, Ley 24.557, ${empresa?.caba?"Ley CABA 2214,":""} ISO 45001:2018.

El informe debe incluir:
1. Resumen ejecutivo (2-3 párrafos)
2. Hallazgos críticos con artículo normativo específico y plazo de subsanación
3. Plan de acción priorizado (ordenado por urgencia)
4. Conclusión y recomendación para dirección

Tono profesional, listo para entregar al cliente.` }]
        })
      });
      const data = await resp.json();
      setAriaRespuesta(data.content?.[0]?.text || "Sin respuesta");
    } catch { setAriaRespuesta("Error al conectar con ARIA."); }
    setAriaCargando(false);
  };

  const contarUsoAriaMes = async (empresaId) => {
    const inicioMes = new Date();
    inicioMes.setDate(1);
    inicioMes.setHours(0,0,0,0);
    const { count } = await supabase
      .from("hs_consultor_uso_aria")
      .select("id", { count:"exact", head:true })
      .eq("empresa_id", empresaId)
      .gte("creado_at", inicioMes.toISOString());
    return count || 0;
  };

  const registrarUsoAria = async (empresaId) => {
    try {
      await supabase.from("hs_consultor_uso_aria").insert({
        empresa_id: empresaId,
        usuario_id: usuario?.id || null,
        tipo: "analisis_legal",
        tenant_id: Number(localStorage.getItem("alqos_tenant_id")) || null,
      });
    } catch(e) { console.error("Error registrando uso ARIA:", e); }
  };

  const cargarHistorialNormativa = async (empresaId) => {
    try {
      const { data } = await supabase.from("hs_normativa_analisis").select("*").eq("empresa_id", empresaId).order("fecha_analisis", { ascending:false }).limit(5);
      setNormativaHistorial(data || []);
      if (data && data.length > 0 && data[0].matriz_estado?.length) {
        setMatrizEstado(data[0].matriz_estado);
      }
    } catch { setNormativaHistorial([]); }
  };

  const guardarMatrizEstado = async (empresaId, matriz) => {
    try {
      const { data: rows } = await supabase
        .from("hs_normativa_analisis")
        .select("id")
        .eq("empresa_id", empresaId)
        .order("fecha_analisis", { ascending: false })
        .limit(1);
      const id = rows?.[0]?.id;
      if (!id) return;
      await supabase.from("hs_normativa_analisis")
        .update({ matriz_estado: matriz })
        .eq("id", id);
    } catch(e) { console.error("Error guardando matriz_estado:", e); }
  };

  const guardarAnalisis = async (empresa, texto) => {
    setGuardandoAnalisis(true);
    try {
      let dataObj = null;
      try { dataObj = JSON.parse(texto); } catch {}
      const matrizARIA = dataObj ? derivarMatriz(dataObj) : [];
      // Merge: base hardcodeada siempre presente + ARIA encima (sin duplicados por norma)
      const normasARIA = new Set(matrizARIA.map(r => r.norma));
      const baseFiltrada = BASE_NORMATIVA.filter(r => !normasARIA.has(r.norma));
      const matrizInicial = [...baseFiltrada, ...matrizARIA].map((r, i) => ({ ...r, n: i + 1 }));
      setMatrizEstado(matrizInicial);
      await supabase.from("hs_normativa_analisis").insert({ empresa_id: empresa.id, empresa_nombre: empresa.nombre, provincia: empresa.provincia||"", municipio: empresa.municipio||empresa.localidad||"", rubro: empresa.rubro||"", analisis: texto, matriz_estado: matrizInicial });
      await cargarHistorialNormativa(empresa.id);
    } catch(e) { console.error("Error guardando análisis:", e); }
    setGuardandoAnalisis(false);
  };

  const cargarProgramaAnual = async (empresaId) => {
    setProgramaAnualLoadedFor(empresaId);
    setProgramaAnualData(null);
    const anio = new Date().getFullYear();
    try {
      const { data, error } = await supabase
        .from('hs_programas_anuales')
        .select('data')
        .eq('empresa_id', empresaId)
        .eq('anio', anio)
        .maybeSingle();
      if (!error && data?.data) setProgramaAnualData(data.data);
    } catch(e) { console.error('Error cargando programa anual:', e); }
  };

  const cargarHistorialNormativaAmbiental = async (empresaId) => {
    try {
      const { data } = await supabase.from("hs_normativa_ambiental")
        .select("*").eq("empresa_id", empresaId)
        .order("fecha_analisis", { ascending: false }).limit(5);
      setNormativaAmbientalHistorial(data || []);
      if (data?.length) setNormativasAmbientales(data[0].analisis || "");
    } catch { setNormativaAmbientalHistorial([]); }
  };

  const guardarAnalisisAmbiental = async (empresa, texto) => {
    setGuardandoAnalisisAmb(true);
    try {
      await supabase.from("hs_normativa_ambiental").insert({
        empresa_id: empresa.id,
        empresa_nombre: empresa.nombre,
        provincia: empresa.provincia || "",
        municipio: empresa.municipio || empresa.localidad || "",
        rubro: empresa.rubro || "",
        analisis: texto,
      });
      await cargarHistorialNormativaAmbiental(empresa.id);
    } catch (e) { console.error("Error guardando análisis ambiental:", e); }
    setGuardandoAnalisisAmb(false);
  };

  const cargarDashboardAmbiental = async () => {
    setDashboardAmbCargando(true);
    await sincronizarScoped("hs_consultor_aspectos", STORAGE_ASPECTOS, "empresa_id", empresas.map(e => String(e.id)));
    cargarLocal();
    const ids = empresas.map(e => e.id);
    let ultimoAnalisis = {};
    try {
      const { data } = await supabase
        .from("hs_normativa_ambiental")
        .select("empresa_id, fecha_analisis")
        .in("empresa_id", ids)
        .order("fecha_analisis", { ascending: false });
      (data || []).forEach(r => {
        if (!ultimoAnalisis[r.empresa_id]) ultimoAnalisis[r.empresa_id] = r.fecha_analisis;
      });
    } catch (e) { console.error("Error cargando dashboard ambiental:", e); }
    const rows = empresas.map(e => {
      const aspEmp    = aspectos.filter(a => a.empresa_id === e.id);
      const sigCount  = aspEmp.filter(a =>
        calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi).es_significativo
      ).length;
      const sinControl = aspEmp.filter(a =>
        calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi).es_significativo &&
        !a.descripcion_control?.trim() && !a.plan_accion?.accion
      ).length;
      const lastVisita = visitas.filter(v => v.empresaId === e.id).sort((a,b) => new Date(b.fecha)-new Date(a.fecha))[0]?.fecha || null;
      const lastAnal   = ultimoAnalisis[e.id] || null;
      const mesesAnal  = lastAnal ? (Date.now() - new Date(lastAnal)) / (1000*60*60*24*30) : Infinity;
      const semaforo   = sinControl > 0 ? "🔴" : mesesAnal > 6 ? "🟡" : "🟢";
      return { empresa: e, sigCount, sinControl, lastVisita, lastAnal, semaforo };
    });
    setDashboardAmbData(rows.sort((a,b) => ["🔴","🟡","🟢"].indexOf(a.semaforo) - ["🔴","🟡","🟢"].indexOf(b.semaforo)));
    setDashboardAmbCargando(false);
  };

  const analizarNormativa = async (empresa) => {
  const limite = empresa.limite_mensual_aria ?? 5;
  if (limite !== -1) {
    const usados = await contarUsoAriaMes(empresa.id);
    if (usados >= limite) {
      alert("Llegaste al limite mensual de analisis ARIA para " + empresa.nombre + " (" + usados + "/" + limite + "). Para ampliarlo, cambia el limite en la pestana Analisis Legal.");
      return;
    }
  }
    setNormativaCargando(true);
    setNormativaAria("");


    const datosEmpresa = `Datos de la empresa:
Razón social: ${empresa.nombre}
Rubro: ${empresa.rubro}
Empleados: ${empresa.empleados||"sin dato"}
Localidad: ${empresa.localidad||"sin dato"}
Municipio/Partido: ${empresa.municipio||"sin dato"}
Provincia: ${empresa.provincia||"sin dato"}
Normativas ya marcadas en el perfil: ${normativas.filter(n=>empresa[n.key]).map(n=>n.label).join(", ")||"ninguna"}`;

    const systemPrompt = "Sos un consultor experto en Higiene y Seguridad laboral en Argentina, especializado en el sector industrial específico de cada cliente. Conocés en profundidad las normativas SRT, decretos, leyes provinciales y municipales, y sabés qué resoluciones técnicas aplican según el RUBRO de cada empresa (ej: industria gráfica → tintas/solventes/ruido de guillotinas; alimentaria → HACCP/bromatología; metalmecánica → soldadura/proyección de partículas). Respondés SIEMPRE y ÚNICAMENTE con JSON válido, sin texto adicional, sin markdown, sin explicaciones. Si no podés completar una búsqueda, completás el JSON con la información disponible.";

    const reglasComunes = `PRECISIÓN ISO 45001:2018 e ISO 14001:2015 (CRÍTICO):
- La empresa ya certifica o aplica ISO 45001:2018 (gestión de S&SO) e ISO 14001:2015 (gestión ambiental). Para CADA norma legal (ley/decreto/resolución) que listes, agregá en la descripción a qué cláusula específica de ISO 45001:2018 o ISO 14001:2015 corresponde como evidencia de cumplimiento (ej: "Esta resolución de medición de ruido aporta evidencia para ISO 45001:2018 cláusula 6.1.2 Identificación de peligros y evaluación de riesgos" o "Esta normativa de residuos peligrosos corresponde a ISO 14001:2015 cláusula 8.1 Control operacional").
- Distinguí explícitamente: las leyes/decretos/resoluciones SRT son OBLIGACIÓN LEGAL (categoria="OBLIGATORIA"); ISO 45001/14001 son SISTEMA DE GESTIÓN (categoria="RECOMENDADA" salvo que la empresa ya las tenga certificadas, en cuyo caso son OBLIGATORIA contractual/comercial).
- No mezcles ISO 9001 (calidad) en este análisis salvo que sea estrictamente necesario para algún requisito de trazabilidad ambiental o de S&SO; el foco es 45001 y 14001.

CLASIFICACIÓN DE "aspecto" Y "area_responsable" (CRÍTICO, para cada item de normativa):
- "SST" + "Higiene y Seguridad": el requisito protege la SALUD/SEGURIDAD del TRABAJADOR (ruido, iluminación, ergonomía, agentes químicos en el puesto de trabajo, EPP, capacitación, comités mixtos, servicio de H&S, ART, espacios confinados, matriculación de profesionales H&S). Esto incluye protocolos SRT de medición aunque mencionen "contaminantes" o "ventilación", si el sujeto de protección es el trabajador.
- "Ambiental" + "Medio Ambiente": el requisito protege el ENTORNO/COMUNIDAD (residuos peligrosos hacia afuera de la planta, efluentes, emisiones a la atmósfera externa, certificado de aptitud ambiental, evaluación de impacto ambiental, gestión de recursos naturales, biodiversidad).
- "Calidad" + "Calidad": solo si es estrictamente de sistema de gestión de calidad (ISO 9001), trazabilidad de producto, o registros que alimenten un SGC.
- "Habilitaciones" + "Administración": habilitaciones municipales/comerciales, zonificación, código de edificación, registros societarios.
- Pensá la pregunta: "¿a quién protege directamente este requisito: al trabajador adentro de la planta, o al ambiente/comunidad afuera de la planta?" Esa es la clave para SST vs Ambiental.

CAMPOS OBLIGATORIOS POR CADA NORMA (CRÍTICO, nivel matriz legal profesional):
Además de codigo/nombre/categoria/aspecto/area_responsable/descripcion/link/actualizacion, cada norma debe incluir:
- "autoridad_aplicacion": organismo que controla y fiscaliza (ej: "SRT", "OPDS", "Municipalidad de X - Dirección de Habilitaciones").
- "articulo_aplicable": artículo(s) específico(s) que genera la obligación (ej: "Art. 5, Art. 42").
- "obligaciones_concretas": qué debe hacer/tener la empresa en términos operativos, no jurídicos (ej: "mantener registro de mediciones de ruido cada 6 meses").
- "evidencia_objetiva": qué documento/registro debe conservar como prueba de cumplimiento.
- "frecuencia": "Permanente", "Mensual", "Trimestral", "Semestral", "Anual" o "Por evento".
- "vencimiento": fecha o periodicidad de vencimiento, o "No aplica" si es permanente.
- "responsable_sugerido": área o rol interno que debería gestionar esta obligación (ej: "Jefe de H&S", "RRHH", "Mantenimiento").
- "sanciones": consecuencia de incumplimiento (multas, clausura, inhabilitación) en una frase breve.
- "aplicabilidad": "APLICA", "NO APLICA" o "APLICA PARCIALMENTE", según el rubro/tamaño/ubicación REAL de esta empresa puntual. No completes por las dudas: si una norma típica del sector no aplica a este caso, marcala como "NO APLICA" o "APLICA PARCIALMENTE" y explicá por qué en el campo siguiente.
- "justificacion_aplicabilidad": 1 frase técnica explicando por qué aplica (o no) a ESTA empresa puntual, no en general.
- "riesgo": "CRITICO", "ALTO", "MEDIO" o "BAJO", según el impacto de un incumplimiento (riesgo de vida, clausura o multas graves = CRITICO; sanciones moderadas = ALTO; administrativo = MEDIO o BAJO).
- "iso_clausula": cláusula específica de ISO 45001:2018 o ISO 14001:2015 a la que esta norma aporta evidencia, como campo separado (ej: "ISO 45001:2018 §6.1.2"), además de mencionarlo en la descripción.

- Buscá en InfoLEG (infoleg.gob.ar), argentina.gob.ar/normativa, Boletín Oficial, SRT, normas.gba.gob.ar (o el portal provincial correspondiente) y sitios municipales.
- Solo JSON válido, sin markdown, sin explicaciones, sin texto antes ni después.`;

    let dataA = null, dataB = null;

    // ── RAG: consultar hs_normativa_base antes de llamar a ARIA ──
    let corpusNormativo = '';
    try {
      const { data: normasBase, error: errorBase } = await supabase
        .from('hs_normativa_base')
        .select('codigo, descripcion, tipo, aplicacion, jurisdiccion, provincia, categoria')
        .eq('vigente', true)
        .eq('documento_cliente', false)
        .neq('categoria', 'Ambiental')
        .in('jurisdiccion', ['nacional', 'provincial', 'internacional', 'norma_tecnica'])
        .order('categoria', { ascending: true });

      if (!errorBase && normasBase && normasBase.length > 0) {
        const nacionales = normasBase.filter(n => n.jurisdiccion === 'nacional');
        const provinciales = normasBase.filter(n => n.jurisdiccion === 'provincial' && n.provincia === empresa.provincia);
        const internacionales = normasBase.filter(n => n.jurisdiccion === 'internacional');
        corpusNormativo = `
CORPUS NORMATIVO VERIFICADO — BASE DE DATOS ALQOS (actualizado 31/12/2025)
Este corpus proviene de una matriz legal verificada. Usalo como fuente principal.
NO inventes normas que no esten aqui. Si necesitas buscar algo adicional, usa web_search.

=== NORMAS NACIONALES (${nacionales.length}) ===
${nacionales.map(n => '- ' + n.codigo + ' | ' + n.descripcion + ' | Aplicacion: ' + n.aplicacion + ' | Categoria: ' + n.categoria).join('\n')}

=== NORMAS PROVINCIA DE ${(empresa.provincia||"SIN DATO").toUpperCase()} (${provinciales.length}) ===
${provinciales.map(n => '- ' + n.codigo + ' | ' + n.descripcion + ' | Aplicacion: ' + n.aplicacion).join('\n')}

=== NORMAS INTERNACIONALES/TRATADOS (${internacionales.length}) ===
${internacionales.map(n => '- ' + n.codigo + ' | ' + n.descripcion).join('\n')}

INSTRUCCION CRITICA:
1. Para cada norma que incluyas en el JSON, verifica con web_search si sigue vigente y sus articulos exactos.
2. Si la norma esta en este corpus, usa el codigo exacto como aparece arriba.
3. Si web_search encontrara una modificacion posterior a 2025, mencionalo en actualizacion.
4. NUNCA incluyas normas que no esten en este corpus O que no puedas verificar con web_search.
5. En articulo_aplicable escribe el numero real del articulo (ej: Art. 8 Ley 19.587), nunca generico.
6. En obligaciones_concretas transcribi la obligacion textual del articulo, no la parafrasees.
`;
        console.log('[ARIA Legal] Corpus RAG cargado:', normasBase.length, 'normas');
      }
    } catch(eRag) {
      console.warn('[ARIA Legal] No se pudo cargar corpus RAG, continuando sin el:', eRag);
    }

    // ── LLAMADA A: resumen + normativa nacional + provincial ──
    try {
      const respA = await fetch("/api/aria", {
        method:"POST",
        headers:{ ...(await authHeader()), "Content-Type":"application/json", "anthropic-version":"2023-06-01", },
        body: JSON.stringify({
          model:"claude-sonnet-4-6",
          max_tokens:16000,
          system: systemPrompt,
          tools:[{ type:"web_search_20250305", name:"web_search", max_uses:12 }],
          messages:[{ role:"user", content:`Analizá el marco normativo de Higiene y Seguridad NACIONAL Y PROVINCIAL aplicable a esta empresa y respondé ÚNICAMENTE con un JSON válido con esta estructura exacta:

{
  "empresa": "nombre",
  "fecha": "fecha actual",
  "resumen_ejecutivo": "párrafo de 4-6 líneas mencionando rubro, ubicación, tramo de empleados y los puntos normativos más críticos específicos del sector, con referencias a cláusulas ISO 45001/14001 y mención a transición ISO 14001:2026",
  "normativa_nacional": [
    { "codigo": "Ley 19.587", "nombre": "Higiene y Seguridad en el Trabajo", "categoria": "OBLIGATORIA", "aspecto": "SST", "area_responsable": "Higiene y Seguridad", "descripcion": "qué exige, por qué aplica a ESTE rubro puntualmente", "autoridad_aplicacion": "...", "articulo_aplicable": "...", "obligaciones_concretas": "...", "evidencia_objetiva": "...", "frecuencia": "Anual", "vencimiento": "...", "responsable_sugerido": "...", "sanciones": "...", "aplicabilidad": "APLICA", "justificacion_aplicabilidad": "...", "riesgo": "ALTO", "iso_clausula": "...", "link": "url infoleg/argentina.gob.ar", "actualizacion": "fecha sanción/última modificación" }
  ],
  "normativa_provincial": [
    { "codigo": "Ley 14.408", "nombre": "...", "categoria": "OBLIGATORIA", "aspecto": "SST", "area_responsable": "Higiene y Seguridad", "descripcion": "...", "autoridad_aplicacion": "...", "articulo_aplicable": "...", "obligaciones_concretas": "...", "evidencia_objetiva": "...", "frecuencia": "...", "vencimiento": "...", "responsable_sugerido": "...", "sanciones": "...", "aplicabilidad": "APLICA", "justificacion_aplicabilidad": "...", "riesgo": "MEDIO", "iso_clausula": "...", "link": "...", "actualizacion": "..." }
  ]
}

CORPUS NORMATIVO BASE VERIFICADO:
${corpusNormativo}

REGLAS DE ESPECIFICIDAD SECTORIAL (CRÍTICO):
- Las descripciones NO pueden ser genéricas. Cada norma debe explicar POR QUÉ aplica al rubro "${empresa.rubro}" con ejemplos concretos de la actividad (maquinaria, sustancias, procesos típicos de ese rubro).
- Buscá específicamente protocolos SRT de medición (ruido, iluminación, ergonomía, contaminantes químicos) y evaluá si aplican según los procesos típicos del rubro.
- Si el rubro maneja sustancias químicas (tintas, solventes, productos de limpieza industrial, etc.), incluí normativa de registro de sustancias/cancerígenos si corresponde.

${reglasComunes}

- normativa_nacional: mínimo 8, máximo 15 normas relevantes (leyes, decretos, resoluciones SRT).
- normativa_provincial: TODAS las leyes/decretos de la provincia "${empresa.provincia||"sin dato"}" relacionadas a H&S laboral (comités mixtos, colegiatura profesional, leyes de seguridad industrial provincial, residuos peligrosos provinciales).

${datosEmpresa}` }]
        })
      });
      const respDataA = await respA.json();
      const textoA = (respDataA.content||[]).filter(b=>b.type==="text").map(b=>b.text).join("\n");
      dataA = repararJSONGenerico(textoA);
    } catch(e) { console.error("Error llamada A:", e); }

    const municipiosSitios = (empresa.sitios||[]).map(s => s.municipio).filter(Boolean);
    const municipiosSitiosTexto = municipiosSitios.length ? ` y de los municipios de sus sitios: ${municipiosSitios.join(", ")}` : "";

    // ── LLAMADA B: normativa municipal + actualizaciones + obligaciones + checklist ──
    try {
      const respB = await fetch("/api/aria", {
        method:"POST",
        headers:{ ...(await authHeader()), "Content-Type":"application/json", "anthropic-version":"2023-06-01", },
        body: JSON.stringify({
          model:"claude-sonnet-4-6",
          max_tokens:8000,
          system: systemPrompt,
          tools:[{ type:"web_search_20250305", name:"web_search", max_uses:6 }],
          messages:[{ role:"user", content:`Analizá la normativa MUNICIPAL, las actualizaciones recientes, las obligaciones por tramo de empleados y el checklist prioritario de Higiene y Seguridad para esta empresa. Respondé ÚNICAMENTE con un JSON válido con esta estructura exacta:

{
  "normativa_municipal": [
    { "codigo": "...", "nombre": "...", "categoria": "OBLIGATORIA", "aspecto": "SST", "area_responsable": "Higiene y Seguridad", "descripcion": "...", "autoridad_aplicacion": "...", "articulo_aplicable": "...", "obligaciones_concretas": "...", "evidencia_objetiva": "...", "frecuencia": "...", "vencimiento": "...", "responsable_sugerido": "...", "sanciones": "...", "aplicabilidad": "APLICA", "justificacion_aplicabilidad": "...", "riesgo": "MEDIO", "iso_clausula": "...", "link": "...", "actualizacion": "..." }
  ],
  "actualizaciones_recientes": [
    { "norma": "...", "descripcion": "...", "fecha": "...", "impacto": "alto|medio|bajo" }
  ],
  "obligaciones_por_tramo": [
    { "rango_empleados": "Más de 150 empleados", "obligacion": "descripción concreta", "normativa": "Decreto X" }
  ],
  "checklist_prioritario": [
    { "prioridad": "ALTA|MEDIA|BAJA", "item": "qué verificar, en lenguaje de inspector", "normativa": "referencia" }
  ]
}

${reglasComunes}

- normativa_municipal: normativa de habilitación y ambiental del municipio "${empresa.municipio||empresa.localidad||"sin dato"}"${municipiosSitiosTexto}; mínimo 2 items por cada municipio (sede + sitios), si no encontrás específica indicá que aplica subsidiariamente el código de edificación de referencia.
- actualizaciones_recientes: mínimo 1 ítem, incluyendo SIEMPRE la actualización de ISO 14001:2026 (publicada abril 2026, periodo de coexistencia 3 años con ISO 14001:2015, impacto "medio").
- obligaciones_por_tramo: OBLIGATORIO tener contenido. Calculá según "${empresa.empleados||"sin dato"}" empleados qué obligaciones de servicios de H&S/medicina laboral, comités mixtos, etc. corresponden (Decreto 1338/96, Ley 14.408 si es PBA, etc.). Mínimo 3 items.
- checklist_prioritario: OBLIGATORIO tener contenido. Mínimo 12 ítems, ordenados por prioridad, en lenguaje de "verificar/elaborar/registrar", accionables para una visita de inspección.

${datosEmpresa}` }]
        })
      });
      const respDataB = await respB.json();
      const textoB = (respDataB.content||[]).filter(b=>b.type==="text").map(b=>b.text).join("\n");
      dataB = repararJSONGenerico(textoB);
    } catch(e) { console.error("Error llamada B:", e); }

    if (!dataA && !dataB) {
      setNormativaAria("Error al conectar con ARIA.");
      setNormativaCargando(false);
      return;
    }

    // ── LLAMADA C: checklist prioritario (síntesis de A+B, sin web search) ──
    let dataC = null;
    try {
      const normasResumen = [
        ...(dataA?.normativa_nacional||[]),
        ...(dataA?.normativa_provincial||[]),
        ...(dataB?.normativa_municipal||[]),
      ].map(n => `${n.codigo}: ${n.nombre}`).join("\n");

      const respC = await fetch("/api/aria", {
        method:"POST",
        headers:{ ...(await authHeader()), "Content-Type":"application/json", "anthropic-version":"2023-06-01", },
        body: JSON.stringify({
          model:"claude-sonnet-4-6",
          max_tokens:4000,
          system: systemPrompt,
          messages:[{ role:"user", content:`A partir de esta lista de normativa de Higiene y Seguridad aplicable a la empresa "${empresa.nombre}" (rubro: ${empresa.rubro}, ${empresa.empleados||"sin dato"} empleados, ${empresa.municipio||empresa.localidad||"sin dato"}, ${empresa.provincia||"sin dato"}), generá un checklist priorizado para una visita de inspección. Respondé ÚNICAMENTE con un JSON válido:

{
  "checklist_prioritario": [
    { "prioridad": "ALTA|MEDIA|BAJA", "item": "qué verificar, en lenguaje de inspector (verificar/elaborar/registrar)", "normativa": "código de norma de referencia" }
  ]
}

Mínimo 12 ítems, ordenados por prioridad (ALTA primero). Basate en esta normativa:
${normasResumen}

Solo JSON válido, sin markdown, sin explicaciones.` }]
        })
      });
      const respDataC = await respC.json();
      const textoC = (respDataC.content||[]).filter(b=>b.type==="text").map(b=>b.text).join("\n");
      dataC = repararJSONGenerico(textoC);
    } catch(e) { console.error("Error llamada C:", e); }

    const combinado = {
      empresa: dataA?.empresa || empresa.nombre,
      fecha: dataA?.fecha || new Date().toLocaleDateString("es-AR"),
      resumen_ejecutivo: dataA?.resumen_ejecutivo || "",
      normativa_nacional: dataA?.normativa_nacional || [],
      normativa_provincial: dataA?.normativa_provincial || [],
      normativa_municipal: dataB?.normativa_municipal || [],
      actualizaciones_recientes: dataB?.actualizaciones_recientes || [],
      obligaciones_por_tramo: dataB?.obligaciones_por_tramo || [],
      checklist_prioritario: dataC?.checklist_prioritario || dataB?.checklist_prioritario || [],
    };

    const resultado = JSON.stringify(combinado);
    setNormativaAria(resultado);
    await guardarAnalisis(empresa, resultado);
    await registrarUsoAria(empresa.id);
    setUsoAriaMes(await contarUsoAriaMes(empresa.id));
    setNormativaCargando(false);
  };

  // eslint-disable-next-line no-unused-vars
  const analizarNormativaAmbiental = async (empresa) => {
    if (!empresa.iso14001 && !empresa.iso14001_2026) return;
    const limite = empresa.limite_mensual_aria ?? 5;
    if (limite !== -1) {
      const usados = await contarUsoAriaMes(empresa.id);
      if (usados >= limite) {
        alert(`Llegaste al límite mensual de análisis ARIA para ${empresa.nombre} (${usados}/${limite}).`);
        return;
      }
    }
    setNormativaAmbientalCargando(true);
    setNormativasAmbientales("");

    const datosEmpresa = `Empresa: ${empresa.nombre}
Rubro: ${empresa.rubro || "Gráfica / Imprenta"}
Empleados: ${empresa.empleados || "sin dato"}
Localidad: ${empresa.localidad || "sin dato"}
Municipio/Partido: ${empresa.municipio || "sin dato"}
Provincia: ${empresa.provincia || "sin dato"}`;

    const systemAmb = "Sos un consultor experto en gestión ambiental y derecho ambiental argentino, especializado en el sector industrial. Conocés la Ley 25.675, Ley 24.051, Dec. 831/93, Ley 25.612, Ley 26.331, leyes provinciales y ordenanzas municipales, y los requisitos de ISO 14001:2015 e ISO 14001:2026. Respondés SIEMPRE y ÚNICAMENTE con JSON válido, sin texto adicional, sin markdown.";

    const reglas = `CAMPOS OBLIGATORIOS POR NORMA: codigo, nombre, categoria (OBLIGATORIA/RECOMENDADA), aspecto (siempre "Ambiental"), area_responsable, descripcion, autoridad_aplicacion, articulo_aplicable, obligaciones_concretas, evidencia_objetiva, frecuencia, vencimiento, responsable_sugerido, sanciones, aplicabilidad (APLICA/NO APLICA/APLICA PARCIALMENTE), justificacion_aplicabilidad, riesgo (CRITICO/ALTO/MEDIO/BAJO), iso_clausula (cláusula ISO 14001:2015 o ISO 14001:2026), link, actualizacion. Solo JSON válido.`;

    let dataA = null, dataB = null;

    const municipiosSitios = (empresa.sitios||[]).map(s => s.municipio).filter(Boolean);
    const municipiosTodos = [empresa.municipio, ...municipiosSitios].filter(Boolean);

    // ── RAG: consultar hs_normativa_base (nacional + provincial) antes de ARIA ──
    let corpusAmbiental = '';
    try {
      const { data: normasBase, error: errorBase } = await supabase
        .from('hs_normativa_base')
        .select('codigo, descripcion, tipo, aplicacion, jurisdiccion, provincia, categoria')
        .eq('vigente', true)
        .eq('documento_cliente', false)
        .in('categoria', ['Ambiental', 'General'])
        .in('jurisdiccion', ['nacional', 'provincial', 'internacional', 'norma_tecnica'])
        .order('jurisdiccion', { ascending: true });

      if (!errorBase && normasBase && normasBase.length > 0) {
        const nacionales   = normasBase.filter(n => n.jurisdiccion === 'nacional');
        const provinciales = normasBase.filter(n => n.jurisdiccion === 'provincial' && n.provincia === empresa.provincia);
        const intl         = normasBase.filter(n => n.jurisdiccion === 'internacional');
        corpusAmbiental = [
          'CORPUS NORMATIVO AMBIENTAL VERIFICADO - BASE DE DATOS ALQOS (actualizado junio 2025)',
          'Este corpus proviene de una matriz legal verificada. Es la fuente ÚNICA — no incluyas normas que no esten aqui.',
          '',
          '=== NORMAS NACIONALES AMBIENTALES (' + nacionales.length + ') ===',
          nacionales.map(n => '- ' + n.codigo + ' | ' + n.descripcion + ' | Aplicacion: ' + n.aplicacion).join('\n'),
          '',
          '=== NORMAS PROVINCIALES (' + provinciales.length + ') ===',
          provinciales.map(n => '- ' + n.codigo + ' | ' + n.descripcion + ' | ' + n.provincia).join('\n'),
          '',
          '=== NORMAS INTERNACIONALES/TRATADOS (' + intl.length + ') ===',
          intl.map(n => '- ' + n.codigo + ' | ' + n.descripcion).join('\n'),
          '',
          'INSTRUCCION CRITICA:',
          '1. Para CADA norma de este corpus verificá con web_search: (a) si sigue vigente, (b) si hubo modificaciones posteriores a 2025, (c) si aplica al rubro real de esta empresa ("' + (empresa.rubro || "gráfica") + '").',
          '2. Usa el codigo exacto como aparece en este corpus.',
          '3. Si web_search detecta modificacion post-2025, mencionalo en actualizacion.',
          '4. NUNCA incluyas normas que no esten en este corpus. Si una jurisdiccion (nacional/provincial) no tiene normas en el corpus, devolvé el array vacío para esa jurisdiccion en vez de inventar.',
          '5. En articulo_aplicable escribe el numero real (ej: Art. 5 Ley 25.675).',
          '6. En obligaciones_concretas transcribi textual, no parafrasees.',
          '7. Completá aplicabilidad y justificacion_aplicabilidad según el rubro real de esta empresa, no genéricamente.',
        ].join('\n');
        console.log('[ARIA Ambiental] Corpus RAG cargado:', normasBase.length, 'normas ambientales');
      }
    } catch(eRag) {
      console.warn('[ARIA Ambiental] No se pudo cargar corpus RAG:', eRag);
    }

    // ── LLAMADA A: normativa ambiental nacional + provincial (verificada contra el corpus) ──
    try {
      const respA = await fetch("/api/aria", {
        method: "POST", headers: { ...(await authHeader()), "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-6", max_tokens: 8000, system: systemAmb,
          tools: [{ type: "web_search_20250305", name: "web_search", max_uses: 6 }],
          messages: [{ role: "user", content: `Verificá el marco normativo AMBIENTAL NACIONAL Y PROVINCIAL aplicable a esta empresa a partir del corpus verificado (no inventes normas). Respondé ÚNICAMENTE con JSON válido:

{
  "empresa": "nombre",
  "fecha": "fecha actual",
  "resumen_ejecutivo": "párrafo de 4-6 líneas con aspectos ambientales críticos del rubro, obligaciones legales más importantes y estado ISO 14001:2015/2026",
  "normativa_nacional": [ { "codigo": "Ley 25.675", "nombre": "...", ... } ],
  "normativa_provincial": [ { "codigo": "...", "nombre": "...", ... } ]
}

CORPUS NORMATIVO AMBIENTAL BASE:
${corpusAmbiental}

- normativa_nacional: TODAS las normas nacionales del corpus que apliquen al rubro "${empresa.rubro || "gráfica"}".
- normativa_provincial: TODAS las normas del corpus para la provincia "${empresa.provincia || "sin dato"}".
- iso_clausula: cláusula ISO 14001:2015 o ISO 14001:2026 que cada norma evidencia.

${reglas}
${datosEmpresa}` }],
        }),
      });
      const rd = await respA.json();
      dataA = repararJSONGenerico((rd.content || []).filter(b => b.type === "text").map(b => b.text).join("\n"));
    } catch (e) { console.error("Error llamada A ambiental:", e); }

    // ── LLAMADA B: normativa municipal (web_search) + actualizaciones + obligaciones + checklist ──
    try {
      const respB = await fetch("/api/aria", {
        method: "POST", headers: { ...(await authHeader()), "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-6", max_tokens: 4000, system: systemAmb,
          tools: [{ type: "web_search_20250305", name: "web_search", max_uses: 3 }],
          messages: [{ role: "user", content: `Analizá la normativa ambiental MUNICIPAL, las actualizaciones recientes, las obligaciones operativas y el checklist de auditoría ISO 14001 para esta empresa. Respondé ÚNICAMENTE con JSON válido:

{
  "normativa_municipal": [ { "codigo": "...", "nombre": "...", ... } ],
  "actualizaciones_recientes": [ { "norma": "...", "descripcion": "...", "fecha": "...", "impacto": "alto|medio|bajo" } ],
  "obligaciones_operativas": [ { "aspecto": "...", "obligacion": "...", "normativa": "...", "frecuencia": "..." } ],
  "checklist_ambiental": [ { "prioridad": "ALTA|MEDIA|BAJA", "item": "...", "normativa": "..." } ]
}

- normativa_municipal: buscá con web_search ordenanzas de habilitación ambiental para CADA uno de estos municipios: "${municipiosTodos.join(", ") || empresa.localidad || "sin dato"}" (sede y sitios); mínimo 1 item por municipio, si no encontrás específica indicá que aplica subsidiariamente el código de edificación de referencia.
- actualizaciones_recientes: incluir SIEMPRE ISO 14001:2026 (publicada abril 2026, coexistencia 3 años; cambios en cláusula 6.1.2 aspectos ambientales con enfoque ACV ampliado).
- obligaciones_operativas: mínimo 5 items por aspecto (residuos, efluentes, emisiones, energía, compras sostenibles).
- checklist_ambiental: mínimo 12 ítems en lenguaje de auditor ISO 14001, ALTA primero.

${reglas}
${datosEmpresa}` }],
        }),
      });
      const rd = await respB.json();
      dataB = repararJSONGenerico((rd.content || []).filter(b => b.type === "text").map(b => b.text).join("\n"));
    } catch (e) { console.error("Error llamada B ambiental:", e); }

    if (!dataA && !dataB) {
      setNormativasAmbientales("Error al conectar con ARIA.");
      setNormativaAmbientalCargando(false);
      return;
    }

    // ── LLAMADA C: checklist síntesis (sin web search) ──
    let dataC = null;
    try {
      const normasRes = [
        ...(dataA?.normativa_nacional || []),
        ...(dataA?.normativa_provincial || []),
        ...(dataB?.normativa_municipal || []),
      ].map(n => `${n.codigo}: ${n.nombre}`).join("\n");
      const respC = await fetch("/api/aria", {
        method: "POST", headers: { ...(await authHeader()), "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-6", max_tokens: 2000, system: systemAmb,
          messages: [{ role: "user", content: `A partir de esta normativa ambiental aplicable a "${empresa.nombre}" (rubro: ${empresa.rubro}), generá un checklist de auditoría ISO 14001. Respondé ÚNICAMENTE con JSON válido:

{"checklist_ambiental":[{"prioridad":"ALTA|MEDIA|BAJA","item":"qué verificar (lenguaje de auditor)","normativa":"referencia"}]}

Mínimo 12 ítems, ALTA primero. Normativa:
${normasRes}

Solo JSON válido.` }],
        }),
      });
      const rd = await respC.json();
      dataC = repararJSONGenerico((rd.content || []).filter(b => b.type === "text").map(b => b.text).join("\n"));
    } catch (e) { console.error("Error llamada C ambiental:", e); }

    const combinado = {
      empresa: dataA?.empresa || empresa.nombre,
      fecha: dataA?.fecha || new Date().toLocaleDateString("es-AR"),
      resumen_ejecutivo: dataA?.resumen_ejecutivo || "",
      normativa_nacional: dataA?.normativa_nacional || [],
      normativa_provincial: dataA?.normativa_provincial || [],
      normativa_municipal: dataB?.normativa_municipal || [],
      actualizaciones_recientes: dataB?.actualizaciones_recientes || [],
      obligaciones_operativas: dataB?.obligaciones_operativas || [],
      checklist_ambiental: dataC?.checklist_ambiental || dataB?.checklist_ambiental || [],
    };

    const resultado = JSON.stringify(combinado);
    setNormativasAmbientales(resultado);
    await guardarAnalisisAmbiental(empresa, resultado);
    await registrarUsoAria(empresa.id);
    setUsoAriaMes(await contarUsoAriaMes(empresa.id));
    setNormativaAmbientalCargando(false);
  };

  // ── MATRIZ DERIVADA (sin pedirla a ARIA, evita truncamiento) ──
  const derivarMatriz = (data) => {
    const filas = [];
    const areaPorAspecto = {
      Ambiental: "Medio Ambiente",
      Calidad: "Calidad",
      Habilitaciones: "Administración",
      SST: "Higiene y Seguridad",
    };
    const fromList = (lista, organismo) => (lista||[]).forEach(n => {
      const aspecto = n.aspecto || "SST";
      filas.push({
        tipo_requisito: n.categoria === "RECOMENDADA" ? "Normativo" : "Legal",
        organismo_emisor: organismo,
        autoridad_aplicacion: n.autoridad_aplicacion || "-",
        norma: n.codigo,
        titulo: n.nombre,
        articulo_aplicable: n.articulo_aplicable || "-",
        aspecto: aspecto,
        aplicabilidad: n.aplicabilidad || "APLICA",
        justificacion_aplicabilidad: n.justificacion_aplicabilidad || "-",
        requisito: n.descripcion,
        area_responsable: n.area_responsable || areaPorAspecto[aspecto] || "Higiene y Seguridad",
        responsable_sugerido: n.responsable_sugerido || "-",
        evidencia: n.evidencia_objetiva || "Según corresponda",
        frecuencia: n.frecuencia || "Continua",
        vencimiento: n.vencimiento || "No aplica",
        riesgo: n.riesgo || "MEDIO",
        sanciones: n.sanciones || "-",
        iso_clausula: n.iso_clausula || "-",
        estado: n.estado || "C",
        fecha_evaluacion: n.fecha_evaluacion || new Date().toLocaleDateString("es-AR"),
        observaciones: n.observaciones || "-",
        link: n.link
      });
    });
    fromList(data.normativa_nacional, "Nacional");
    fromList(data.normativa_provincial, "Provincial");
    fromList(data.normativa_municipal, "Municipal");
    return filas;
  };

  // ── EXPORT EXCEL ──
  const exportarMatrizExcel = async (data, empresa) => {
    const wb = new ExcelJS.Workbook();
    wb.creator = "ALQOS™";
    wb.created = new Date();

    const AZUL        = "FF1C3FAA";

    const AZUL_CLARO  = "FFE8E9F6";
    const BLANCO      = "FFFFFFFF";
    const GRIS_CLARO  = "FFF9FAFB";
    const VERDE_BG    = "FFD1FAE5";
    const ROJO_BG     = "FFFEE2E2";
    const AMARILLO_BG = "FFFEF3C7";
    const VERDE_TXT   = "FF065F46";
    const ROJO_TXT    = "FFB91C1C";
    const GRIS_BG     = "FFE5E7EB";
    const GRIS_TXT    = "FF374151";
    const NARANJA_BG  = "FFFFEDD5";
    const NARANJA_TXT = "FF9A3412";

    const borderThin = {
      top:    { style: "thin",  color: { argb: "FFD1D5DB" } },
      bottom: { style: "thin",  color: { argb: "FFD1D5DB" } },
      left:   { style: "thin",  color: { argb: "FFD1D5DB" } },
      right:  { style: "thin",  color: { argb: "FFD1D5DB" } },
    };
    const borderHair = {
      top:    { style: "hair", color: { argb: "FFE5E7EB" } },
      bottom: { style: "hair", color: { argb: "FFE5E7EB" } },
      left:   { style: "hair", color: { argb: "FFE5E7EB" } },
      right:  { style: "hair", color: { argb: "FFE5E7EB" } },
    };

    const setHeader = (cell, txt) => {
      cell.value = txt;
      cell.font  = { bold: true, color: { argb: BLANCO }, size: 10 };
      cell.fill  = { type: "pattern", pattern: "solid", fgColor: { argb: AZUL } };
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.border = borderThin;
    };

    const setCell = (cell, val, bg, bold, color) => {
      cell.value = val ?? "";
      cell.font  = { size: 9, bold: !!bold, color: { argb: color || "FF111827" } };
      cell.fill  = { type: "pattern", pattern: "solid", fgColor: { argb: bg || BLANCO } };
      cell.alignment = { vertical: "middle", wrapText: true };
      cell.border = borderHair;
    };

    const filaLogoEmpresa = (ws) => {
      // Fila 1: LOGO placeholder | nombre empresa
      const r1 = ws.getRow(1);
      r1.height = 42;
      const logoCell = r1.getCell(1);
      logoCell.value = "□  [LOGO EMPRESA]";
      logoCell.font  = { size: 9, italic: true, color: { argb: "FF9CA3AF" } };
      logoCell.fill  = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F4F6" } };
      logoCell.alignment = { vertical: "middle", horizontal: "center" };
      logoCell.border = borderThin;

      const empCell = r1.getCell(2);
      empCell.value = empresa.nombre || "";
      empCell.font  = { bold: true, size: 14, color: { argb: AZUL } };
      empCell.fill  = { type: "pattern", pattern: "solid", fgColor: { argb: AZUL_CLARO } };
      empCell.alignment = { vertical: "middle", horizontal: "left" };
      empCell.border = borderThin;

      // Fila 2: título | subtítulo
      const r2 = ws.getRow(2);
      r2.height = 24;
      const titCell = r2.getCell(1);
      titCell.value = "MATRIZ DE REQUISITOS LEGALES · ALQOS™";
      titCell.font  = { bold: true, size: 11, color: { argb: BLANCO } };
      titCell.fill  = { type: "pattern", pattern: "solid", fgColor: { argb: AZUL } };
      titCell.alignment = { vertical: "middle", horizontal: "center" };
      titCell.border = borderThin;

      const subCell = r2.getCell(2);
      subCell.value = `Rubro: ${empresa.rubro || ""} · ${empresa.municipio || empresa.localidad || ""}, ${empresa.provincia || ""} · ${new Date().toLocaleDateString("es-AR")}`;
      subCell.font  = { size: 9, italic: true, color: { argb: "FF4B5563" } };
      subCell.fill  = { type: "pattern", pattern: "solid", fgColor: { argb: AZUL_CLARO } };
      subCell.alignment = { vertical: "middle" };
      subCell.border = borderThin;
    };

    // ── HOJA RESUMEN EJECUTIVO ──
    const wsRes = wb.addWorksheet("Resumen ejecutivo");
    wsRes.columns = [{ width: 20 }, { width: 80 }];
    filaLogoEmpresa(wsRes);
    const hRes = wsRes.getRow(3);
    hRes.height = 24;
    setHeader(hRes.getCell(1), "Dato");
    setHeader(hRes.getCell(2), "Información");
    [
      ["Empresa",    empresa.nombre || ""],
      ["Rubro",      empresa.rubro  || ""],
      ["Provincia",  empresa.provincia || ""],
      ["Localidad",  empresa.municipio || empresa.localidad || ""],
      ["Sitios",     (empresa.sitios||[]).map(s => s.nombre).join(", ")],
      ["Empleados",  empresa.empleados || ""],
      ["Fecha",      data.fecha || new Date().toLocaleDateString("es-AR")],
      ["Total requisitos", String(derivarMatriz(data).length)],
    ].forEach(([k, v], idx) => {
      const row = wsRes.getRow(idx + 4);
      row.height = 20;
      setCell(row.getCell(1), k, idx % 2 === 0 ? BLANCO : GRIS_CLARO, true, "FF1C3FAA");
      setCell(row.getCell(2), v, idx % 2 === 0 ? BLANCO : GRIS_CLARO, false);
    });
    const rowRE = wsRes.getRow(12);
    rowRE.height = 22;
    setHeader(rowRE.getCell(1), "Resumen ejecutivo");
    wsRes.mergeCells("A12:B12");
    const rowTxt = wsRes.getRow(13);
    wsRes.mergeCells("A13:B13");
    rowTxt.getCell(1).value = data.resumen_ejecutivo || "";
    rowTxt.getCell(1).alignment = { wrapText: true, vertical: "top" };
    rowTxt.getCell(1).font = { size: 10 };
    rowTxt.height = 100;

    // ── HOJA PRINCIPAL: MATRIZ COMPLETA ──
    const ws = wb.addWorksheet("Matriz Legal");
    const COLS = [
      { header: "N°",                            key: "n",            width: 5  },
      { header: "Tipo de requisito",              key: "tipo",         width: 14 },
      { header: "Organismo emisor",               key: "organismo",    width: 16 },
      { header: "Autoridad de aplicación",        key: "autoridad",    width: 24 },
      { header: "Norma / Ley / Decreto / Res.",   key: "norma",        width: 22 },
      { header: "Título de la norma",             key: "titulo",       width: 32 },
      { header: "Artículo aplicable",             key: "articulo",     width: 18 },
      { header: "Aspecto aplicable",              key: "aspecto",      width: 14 },
      { header: "Aplicabilidad",                  key: "aplicabilidad",width: 18 },
      { header: "Justificación aplicabilidad",    key: "justif",       width: 34 },
      { header: "Requisito legal aplicable",      key: "requisito",    width: 40 },
      { header: "Área responsable",               key: "area",         width: 16 },
      { header: "Responsable sugerido",           key: "responsable",  width: 18 },
      { header: "Evidencia de cumplimiento",      key: "evidencia",    width: 32 },
      { header: "Frecuencia",                     key: "frecuencia",   width: 14 },
      { header: "Vencimiento",                    key: "vencimiento",  width: 16 },
      { header: "Nivel de riesgo",                key: "riesgo",       width: 14 },
      { header: "Sanciones",                      key: "sanciones",    width: 30 },
      { header: "Cláusula ISO",                   key: "iso",          width: 26 },
      { header: "Estado (C/NC)",                  key: "estado",       width: 12 },
      { header: "Fecha última evaluación",        key: "fecha",        width: 16 },
      { header: "Observaciones / Plan de acción", key: "obs",          width: 32 },
    ];
    ws.columns = COLS.map(c => ({ width: c.width }));

    filaLogoEmpresa(ws);

    // Fila 3: headers columnas
    const hRow = ws.getRow(3);
    hRow.height = 32;
    COLS.forEach((col, i) => setHeader(hRow.getCell(i + 1), col.header));

    // Filas datos (derivadas de normativa_nacional/provincial/municipal)
    const matriz = derivarMatriz(data);
    matriz.forEach((item, idx) => {
      const row = ws.getRow(idx + 4);
      row.height = 34;
      const bgAlt = idx % 2 === 0 ? BLANCO : GRIS_CLARO;
      const esNC  = item.estado === "NC";
      const bgEstado = esNC ? ROJO_BG : VERDE_BG;
      const txtEstado = esNC ? ROJO_TXT : VERDE_TXT;

      const apl = item.aplicabilidad || "APLICA";
      const bgApl = apl === "NO APLICA" ? GRIS_BG : apl === "APLICA PARCIALMENTE" ? AMARILLO_BG : VERDE_BG;
      const txtApl = apl === "NO APLICA" ? GRIS_TXT : apl === "APLICA PARCIALMENTE" ? "FF92400E" : VERDE_TXT;

      const riesgo = item.riesgo || "MEDIO";
      const bgRiesgo = riesgo === "CRITICO" ? ROJO_BG : riesgo === "ALTO" ? NARANJA_BG : riesgo === "BAJO" ? VERDE_BG : AMARILLO_BG;
      const txtRiesgo = riesgo === "CRITICO" ? ROJO_TXT : riesgo === "ALTO" ? NARANJA_TXT : riesgo === "BAJO" ? VERDE_TXT : "FF92400E";

      setCell(row.getCell(1),  idx + 1,                          bgAlt, false);
      setCell(row.getCell(2),  item.tipo_requisito,               bgAlt, false);
      setCell(row.getCell(3),  item.organismo_emisor,             bgAlt, false);
      setCell(row.getCell(4),  item.autoridad_aplicacion,         bgAlt, false);
      setCell(row.getCell(5),  item.norma,                        bgAlt, true,  "FF1C3FAA");
      setCell(row.getCell(6),  item.titulo,                       bgAlt, false);
      setCell(row.getCell(7),  item.articulo_aplicable,           bgAlt, false);
      setCell(row.getCell(8),  item.aspecto,                      bgAlt, false);
      setCell(row.getCell(9),  apl,                               bgApl, true, txtApl);
      setCell(row.getCell(10), item.justificacion_aplicabilidad,  bgAlt, false);
      setCell(row.getCell(11), item.requisito,                    bgAlt, false);
      setCell(row.getCell(12), item.area_responsable,             bgAlt, false);
      setCell(row.getCell(13), item.responsable_sugerido,         bgAlt, false);
      setCell(row.getCell(14), item.evidencia,                    bgAlt, false);
      setCell(row.getCell(15), item.frecuencia,                   bgAlt, false);
      setCell(row.getCell(16), item.vencimiento,                  bgAlt, false);
      setCell(row.getCell(17), riesgo,                            bgRiesgo, true, txtRiesgo);
      setCell(row.getCell(18), item.sanciones,                    bgAlt, false);
      setCell(row.getCell(19), item.iso_clausula,                 bgAlt, false);
      setCell(row.getCell(20), item.estado || "C",                bgEstado, true, txtEstado);
      setCell(row.getCell(21), item.fecha_evaluacion,             bgAlt, false);
      setCell(row.getCell(22), item.observaciones,                bgAlt, false);
    });

    // Freeze: fijar filas 1-3 y col 1
    ws.views = [{ state: "frozen", xSplit: 1, ySplit: 3, topLeftCell: "B4" }];

    // ── HOJA ACTUALIZACIONES RECIENTES ──
    if (data.actualizaciones_recientes?.length) {
      const wsAct = wb.addWorksheet("Actualizaciones");
      wsAct.columns = [{ width: 28 }, { width: 65 }, { width: 16 }, { width: 14 }];
      filaLogoEmpresa(wsAct);
      const hA = wsAct.getRow(3);
      hA.height = 24;
      ["Norma", "Descripción", "Fecha", "Impacto"].forEach((h, i) => setHeader(hA.getCell(i + 1), h));
      data.actualizaciones_recientes.forEach((a, idx) => {
        const bg = a.impacto === "alto" ? ROJO_BG : a.impacto === "medio" ? AMARILLO_BG : VERDE_BG;
        const row = wsAct.getRow(idx + 4);
        row.height = 28;
        setCell(row.getCell(1), a.norma,       bg, true);
        setCell(row.getCell(2), a.descripcion, bg, false);
        setCell(row.getCell(3), a.fecha,       bg, false);
        setCell(row.getCell(4), (a.impacto||"").toUpperCase(), bg, true);
      });
    }

    // ── HOJA NORMATIVA NACIONAL ──
    if (data.normativa_nacional?.length) {
      const wsNac = wb.addWorksheet("Normativa Nacional");
      wsNac.columns = [{ width: 16 }, { width: 30 }, { width: 12 }, { width: 60 }, { width: 14 }, { width: 30 }];
      filaLogoEmpresa(wsNac);
      const h = wsNac.getRow(3);
      h.height = 24;
      ["Código","Nombre","Categoría","Descripción","Actualización","Link"].forEach((t,i)=>setHeader(h.getCell(i+1), t));
      data.normativa_nacional.forEach((n, idx) => {
        const bgAlt = idx % 2 === 0 ? BLANCO : GRIS_CLARO;
        const esObl = n.categoria === "OBLIGATORIA";
        const bgCat = esObl ? ROJO_BG : VERDE_BG;
        const txtCat = esObl ? ROJO_TXT : VERDE_TXT;
        const row = wsNac.getRow(idx + 4);
        row.height = 60;
        setCell(row.getCell(1), n.codigo, bgAlt, true, "FF1C3FAA");
        setCell(row.getCell(2), n.nombre, bgAlt, false);
        setCell(row.getCell(3), n.categoria, bgCat, true, txtCat);
        setCell(row.getCell(4), n.descripcion, bgAlt, false);
        setCell(row.getCell(5), n.actualizacion, bgAlt, false);
        setCell(row.getCell(6), n.link, bgAlt, false);
      });
      wsNac.views = [{ state: "frozen", ySplit: 3 }];
    }

    // ── HOJA NORMATIVA PROVINCIAL ──
    if (data.normativa_provincial?.length) {
      const wsProv = wb.addWorksheet("Normativa Provincial");
      wsProv.columns = [{ width: 16 }, { width: 30 }, { width: 12 }, { width: 60 }, { width: 14 }, { width: 30 }];
      filaLogoEmpresa(wsProv);
      const h = wsProv.getRow(3);
      h.height = 24;
      ["Código","Nombre","Categoría","Descripción","Actualización","Link"].forEach((t,i)=>setHeader(h.getCell(i+1), t));
      data.normativa_provincial.forEach((n, idx) => {
        const bgAlt = idx % 2 === 0 ? BLANCO : GRIS_CLARO;
        const esObl = n.categoria === "OBLIGATORIA";
        const bgCat = esObl ? ROJO_BG : VERDE_BG;
        const txtCat = esObl ? ROJO_TXT : VERDE_TXT;
        const row = wsProv.getRow(idx + 4);
        row.height = 60;
        setCell(row.getCell(1), n.codigo, bgAlt, true, "FF1C3FAA");
        setCell(row.getCell(2), n.nombre, bgAlt, false);
        setCell(row.getCell(3), n.categoria, bgCat, true, txtCat);
        setCell(row.getCell(4), n.descripcion, bgAlt, false);
        setCell(row.getCell(5), n.actualizacion, bgAlt, false);
        setCell(row.getCell(6), n.link, bgAlt, false);
      });
      wsProv.views = [{ state: "frozen", ySplit: 3 }];
    }

    // ── HOJA NORMATIVA MUNICIPAL ──
    if (data.normativa_municipal?.length) {
      const wsMun = wb.addWorksheet("Normativa Municipal");
      wsMun.columns = [{ width: 16 }, { width: 30 }, { width: 12 }, { width: 60 }, { width: 14 }, { width: 30 }];
      filaLogoEmpresa(wsMun);
      const h = wsMun.getRow(3);
      h.height = 24;
      ["Código","Nombre","Categoría","Descripción","Actualización","Link"].forEach((t,i)=>setHeader(h.getCell(i+1), t));
      data.normativa_municipal.forEach((n, idx) => {
        const bgAlt = idx % 2 === 0 ? BLANCO : GRIS_CLARO;
        const esObl = n.categoria === "OBLIGATORIA";
        const bgCat = esObl ? ROJO_BG : VERDE_BG;
        const txtCat = esObl ? ROJO_TXT : VERDE_TXT;
        const row = wsMun.getRow(idx + 4);
        row.height = 60;
        setCell(row.getCell(1), n.codigo, bgAlt, true, "FF1C3FAA");
        setCell(row.getCell(2), n.nombre, bgAlt, false);
        setCell(row.getCell(3), n.categoria, bgCat, true, txtCat);
        setCell(row.getCell(4), n.descripcion, bgAlt, false);
        setCell(row.getCell(5), n.actualizacion, bgAlt, false);
        setCell(row.getCell(6), n.link, bgAlt, false);
      });
      wsMun.views = [{ state: "frozen", ySplit: 3 }];
    }

    // ── HOJA OBLIGACIONES POR TRAMO ──
    if (data.obligaciones_por_tramo?.length) {
      const wsObl = wb.addWorksheet("Obligaciones por Tramo");
      wsObl.columns = [{ width: 26 }, { width: 60 }, { width: 24 }];
      filaLogoEmpresa(wsObl);
      const h = wsObl.getRow(3);
      h.height = 24;
      ["Rango de empleados","Obligación","Normativa"].forEach((t,i)=>setHeader(h.getCell(i+1), t));
      data.obligaciones_por_tramo.forEach((o, idx) => {
        const bgAlt = idx % 2 === 0 ? BLANCO : GRIS_CLARO;
        const row = wsObl.getRow(idx + 4);
        row.height = 50;
        setCell(row.getCell(1), o.rango_empleados, bgAlt, true, "FF1C3FAA");
        setCell(row.getCell(2), o.obligacion, bgAlt, false);
        setCell(row.getCell(3), o.normativa, bgAlt, false);
      });
      wsObl.views = [{ state: "frozen", ySplit: 3 }];
    }

    // ── HOJA CHECKLIST PRIORITARIO ──
    if (data.checklist_prioritario?.length) {
      const wsChk = wb.addWorksheet("Checklist Prioritario");
      wsChk.columns = [{ width: 12 }, { width: 70 }, { width: 26 }];
      filaLogoEmpresa(wsChk);
      const h = wsChk.getRow(3);
      h.height = 24;
      ["Prioridad","Ítem a verificar","Normativa"].forEach((t,i)=>setHeader(h.getCell(i+1), t));
      // Ordenar por prioridad: ALTA, MEDIA, BAJA
      const orden = { ALTA: 0, MEDIA: 1, BAJA: 2 };
      const items = [...data.checklist_prioritario].sort((a,b) => (orden[a.prioridad]??3) - (orden[b.prioridad]??3));
      items.forEach((c, idx) => {
        const bgPrio = c.prioridad === "ALTA" ? ROJO_BG : c.prioridad === "MEDIA" ? AMARILLO_BG : VERDE_BG;
        const txtPrio = c.prioridad === "ALTA" ? ROJO_TXT : c.prioridad === "MEDIA" ? "FF92400E" : VERDE_TXT;
        const bgAlt = idx % 2 === 0 ? BLANCO : GRIS_CLARO;
        const row = wsChk.getRow(idx + 4);
        row.height = 40;
        setCell(row.getCell(1), c.prioridad, bgPrio, true, txtPrio);
        setCell(row.getCell(2), c.item, bgAlt, false);
        setCell(row.getCell(3), c.normativa, bgAlt, false);
      });
      wsChk.views = [{ state: "frozen", ySplit: 3 }];
    }

    // ── DESCARGAR ──
    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `ALQOS_MatrizLegal_${(empresa.nombre||"empresa").replace(/\s+/g,"_")}_${new Date().toLocaleDateString("es-AR").replace(/\//g,"-")}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // ── MATRIZ DIRECTA DESDE LA BASE (sin gastar crédito de ARIA) ──
  const generarMatrizDesdeBase = async (empresa) => {
    const municipiosTodos = [empresa.municipio, ...(empresa.sitios||[]).map(s => s.municipio)].filter(Boolean);
    try {
      const SELECT_NORMAS = 'id, codigo, descripcion, tipo, aplicacion, jurisdiccion, provincia, municipio, categoria, rubros_aplicables, aspectos_ambientales, aspectos_sst, vigente, ultima_verificacion';
      const [porRubro, porTodos] = await Promise.all([
        supabase.from('hs_normativa_base').select(SELECT_NORMAS)
          .eq('vigente', true)
          .eq('documento_cliente', false)
          .in('jurisdiccion', ['nacional', 'provincial', 'municipal'])
          .filter('rubros_aplicables', 'cs', `{"${empresa.rubro}"}`),
        supabase.from('hs_normativa_base').select(SELECT_NORMAS)
          .eq('vigente', true)
          .eq('documento_cliente', false)
          .in('jurisdiccion', ['nacional', 'provincial', 'municipal'])
          .filter('rubros_aplicables', 'cs', `{"Todos"}`),
      ]);

      if (porRubro.error || porTodos.error) {
        console.error("Error generarMatrizDesdeBase:", porRubro.error || porTodos.error);
        alert("Error al consultar la base normativa.");
        return;
      }

      const normasBaseSinFiltrar = Array.from(
        new Map([...(porRubro.data||[]), ...(porTodos.data||[])].map(n => [n.id, n])).values()
      );
      const normasBase = filtrarNormasPorAspecto(normasBaseSinFiltrar, empresa);
      setNormasBaseVerif(normasBase);

      const mapNorma = n => ({ ...n, nombre: n.descripcion });
      const data = {
        empresa: empresa.nombre,
        fecha: new Date().toLocaleDateString("es-AR"),
        resumen_ejecutivo: "",
        normativa_nacional: (normasBase||[]).filter(n => n.jurisdiccion === 'nacional').map(mapNorma),
        normativa_provincial: (normasBase||[]).filter(n => n.jurisdiccion === 'provincial' && n.provincia === empresa.provincia).map(mapNorma),
        normativa_municipal: (normasBase||[]).filter(n => n.jurisdiccion === 'municipal' && municipiosTodos.includes(n.municipio)).map(mapNorma),
      };

      await exportarMatrizExcel(data, empresa);
    } catch (e) {
      console.error("Error generarMatrizDesdeBase:", e);
      alert("Error al generar la matriz desde la base.");
    }
  };

  // ── Cierra el loop del reporte mensual (api/notificar-normativa.js): marca
  // una norma de hs_normativa_base como verificada hoy, para que deje de
  // contar como "a verificar" en el próximo envío ──
  const marcarNormaVerificada = async (idNorma) => {
    setNormaVerificando(idNorma);
    const ahora = new Date().toISOString();
    const { error } = await supabase.from('hs_normativa_base').update({ ultima_verificacion: ahora }).eq('id', idNorma);
    setNormaVerificando(null);
    if (error) {
      console.error("Error marcarNormaVerificada:", error);
      alert("No se pudo marcar la norma como verificada: " + error.message);
      return;
    }
    setNormasBaseVerif(prev => prev.map(n => n.id === idNorma ? { ...n, ultima_verificacion: ahora } : n));
  };

  // ── AGENTE NORMATIVO: normas filtradas por rubro/ubicación + 1 sola llamada ARIA ──
  const generarMatrizAgente = async (empresa) => {
    const municipiosSitios = (empresa.sitios||[]).map(s => s.municipio).filter(Boolean);
    const municipiosTodos = [empresa.municipio, ...municipiosSitios].filter(Boolean);

    setGenerandoMatrizAgente(true);
    setProgresoAgente("Consultando base normativa...");
    try {
      const SELECT_NORMAS = 'codigo, descripcion, tipo, aplicacion, jurisdiccion, provincia, municipio, categoria, rubros_aplicables, aspectos_ambientales, aspectos_sst';
      const [porRubro, porTodos] = await Promise.all([
        supabase.from('hs_normativa_base').select(SELECT_NORMAS)
          .eq('vigente', true)
          .eq('documento_cliente', false)
          .in('jurisdiccion', ['nacional', 'provincial', 'municipal'])
          .filter('rubros_aplicables', 'cs', `{"${empresa.rubro}"}`),
        supabase.from('hs_normativa_base').select(SELECT_NORMAS)
          .eq('vigente', true)
          .eq('documento_cliente', false)
          .in('jurisdiccion', ['nacional', 'provincial', 'municipal'])
          .filter('rubros_aplicables', 'cs', `{"Todos"}`),
      ]);

      if (porRubro.error || porTodos.error) {
        console.error("Error generarMatrizAgente:", porRubro.error || porTodos.error);
        alert("Error al consultar la base normativa.");
        return;
      }

      const normasBaseSinFiltrar = Array.from(
        new Map([...(porRubro.data||[]), ...(porTodos.data||[])].map(n => [n.codigo, n])).values()
      );
      // Filtrar por aspecto acá también reduce el corpus que se manda a ARIA (menos tokens).
      const normasBase = filtrarNormasPorAspecto(normasBaseSinFiltrar, empresa);

      const nacionales   = (normasBase||[]).filter(n => n.jurisdiccion === 'nacional');
      const provinciales = (normasBase||[]).filter(n => n.jurisdiccion === 'provincial' && n.provincia === empresa.provincia);
      const municipales  = (normasBase||[]).filter(n => n.jurisdiccion === 'municipal' && municipiosTodos.includes(n.municipio));
      const totalNormas = nacionales.length + provinciales.length + municipales.length;

      if (totalNormas === 0) {
        alert("No se encontraron normas en la base para el rubro/ubicación de esta empresa.");
        return;
      }

      setProgresoAgente(`Procesando ${totalNormas} normas con ARIA...`);

      const corpusTexto = [
        `=== NACIONALES (${nacionales.length}) ===`,
        nacionales.map(n => `${n.codigo} | ${n.descripcion} | tipo:${n.tipo||"-"} | aplicacion:${n.aplicacion||"-"}`).join('\n'),
        `=== PROVINCIALES ${empresa.provincia||"sin dato"} (${provinciales.length}) ===`,
        provinciales.map(n => `${n.codigo} | ${n.descripcion} | tipo:${n.tipo||"-"} | aplicacion:${n.aplicacion||"-"}`).join('\n'),
        `=== MUNICIPALES ${municipiosTodos.join(", ")||"sin dato"} (${municipales.length}) ===`,
        municipales.map(n => `${n.codigo} | ${n.descripcion} | municipio:${n.municipio} | tipo:${n.tipo||"-"} | aplicacion:${n.aplicacion||"-"}`).join('\n'),
      ].join('\n');

      const datosEmpresa = `Empresa: ${empresa.nombre}
Rubro: ${empresa.rubro || "sin dato"}
Empleados: ${empresa.empleados || "sin dato"}
Localidad: ${empresa.localidad || "sin dato"}
Municipio/Partido: ${empresa.municipio || "sin dato"}
Provincia: ${empresa.provincia || "sin dato"}`;

      const respAgente = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()), "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-6",
          max_tokens: 12000,
          system: "Sos un consultor experto en Higiene y Seguridad y gestión ambiental argentina, especializado en el sector industrial. Respondés SIEMPRE y ÚNICAMENTE con JSON válido, sin texto adicional, sin markdown.",
          tools: [{ type: "web_search_20250305", name: "web_search", max_uses: 10 }],
          messages: [{ role: "user", content: `Para la empresa "${empresa.nombre}" (rubro: ${empresa.rubro}), verificá con web_search cada una de estas normas (¿sigue vigente?, ¿modificaciones posteriores a 2025?) y completá los campos faltantes según corresponda a ESTA empresa puntual. No inventes normas adicionales, usá SOLO las que están abajo. Respondé ÚNICAMENTE con JSON válido con esta estructura exacta:

{
  "empresa": "nombre",
  "fecha": "fecha actual",
  "resumen_ejecutivo": "párrafo de 4-6 líneas con los puntos normativos más críticos para esta empresa",
  "normativa_nacional": [ { "codigo":"...", "nombre":"...", "categoria":"OBLIGATORIA|RECOMENDADA", "aspecto":"SST|Ambiental|Calidad|Habilitaciones", "area_responsable":"...", "descripcion":"...", "autoridad_aplicacion":"...", "articulo_aplicable":"...", "obligaciones_concretas":"...", "evidencia_objetiva":"...", "frecuencia":"...", "vencimiento":"...", "responsable_sugerido":"...", "sanciones":"...", "aplicabilidad":"APLICA|NO APLICA|APLICA PARCIALMENTE", "justificacion_aplicabilidad":"...", "riesgo":"CRITICO|ALTO|MEDIO|BAJO", "iso_clausula":"...", "link":"...", "actualizacion":"..." } ],
  "normativa_provincial": [ { ...mismos campos... } ],
  "normativa_municipal": [ { ...mismos campos... } ]
}

NORMAS A VERIFICAR Y COMPLETAR:
${corpusTexto}

${datosEmpresa}` }],
        }),
      });
      const respData = await respAgente.json();
      const texto = (respData.content||[]).filter(b=>b.type==="text").map(b=>b.text).join("\n");
      const data = repararJSONGenerico(texto);

      if (!data) { alert("ARIA no devolvió un JSON válido para la matriz."); return; }

      await exportarMatrizExcel(data, empresa);
    } catch (e) {
      console.error("Error generarMatrizAgente:", e);
      alert("Error al generar la matriz con el agente normativo.");
    } finally {
      setGenerandoMatrizAgente(false);
      setProgresoAgente("");
    }
  };

  // ── ACTUALIZAR MATRIZ EXISTENTE: lee un .xlsx ya exportado, verifica vigencia y preserva Estado/Observaciones ──
  const actualizarMatrizDesdeArchivo = async (empresa, archivo) => {
    setActualizandoMatriz(true);
    try {
      const buffer = await archivo.arrayBuffer();
      const wb = new ExcelJS.Workbook();
      await wb.xlsx.load(buffer);
      const ws = wb.getWorksheet("Matriz Legal");
      if (!ws) { alert('El archivo no tiene una hoja "Matriz Legal" — subí un Excel exportado por ALQOS.'); return; }

      const HEADERS_KEYS = [
        ["Organismo emisor","organismo"], ["Autoridad de aplicación","autoridad"],
        ["Norma / Ley / Decreto / Res.","norma"], ["Título de la norma","titulo"],
        ["Artículo aplicable","articulo"], ["Aspecto aplicable","aspecto"],
        ["Aplicabilidad","aplicabilidad"], ["Justificación aplicabilidad","justif"],
        ["Requisito legal aplicable","requisito"], ["Área responsable","area"],
        ["Responsable sugerido","responsable"], ["Evidencia de cumplimiento","evidencia"],
        ["Frecuencia","frecuencia"], ["Vencimiento","vencimiento"], ["Nivel de riesgo","riesgo"],
        ["Sanciones","sanciones"], ["Cláusula ISO","iso"], ["Estado (C/NC)","estado"],
        ["Fecha última evaluación","fecha"], ["Observaciones / Plan de acción","obs"],
      ];

      const headerRow = ws.getRow(3);
      const colPorKey = {};
      HEADERS_KEYS.forEach(([header, key]) => {
        for (let c = 1; c <= headerRow.cellCount; c++) {
          if (String(headerRow.getCell(c).value||"").trim() === header) { colPorKey[key] = c; break; }
        }
      });

      if (!colPorKey.norma || !colPorKey.requisito) {
        alert('El archivo no tiene el formato esperado de matriz ALQOS (faltan columnas clave en "Matriz Legal").');
        return;
      }

      const filas = [];
      ws.eachRow((row, rowNumber) => {
        if (rowNumber <= 3) return;
        const codigo = row.getCell(colPorKey.norma).value;
        if (!codigo) return;
        const fila = {};
        Object.entries(colPorKey).forEach(([key, c]) => { fila[key] = row.getCell(c).value; });
        filas.push(fila);
      });

      if (filas.length === 0) { alert("No se encontraron normas en el archivo subido."); return; }

      const listaTexto = filas.map(f => `${f.norma} | ${f.requisito||f.titulo||""}`).join('\n');

      const respAgente = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()), "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-6",
          max_tokens: 8000,
          system: "Sos un consultor experto en Higiene y Seguridad y gestión ambiental argentina. Respondés SIEMPRE y ÚNICAMENTE con JSON válido, sin texto adicional, sin markdown.",
          tools: [{ type: "web_search_20250305", name: "web_search", max_uses: 10 }],
          messages: [{ role: "user", content: `Verificá con web_search si cada una de estas normas sigue vigente y si hubo modificaciones o actualizaciones posteriores a 2025. Respondé ÚNICAMENTE con JSON válido:

{"normas":[{"codigo":"...","vigente":true,"actualizacion":"texto o vacío si no hay novedades"}]}

Normas a verificar:
${listaTexto}` }],
        }),
      });
      const respData = await respAgente.json();
      const texto = (respData.content||[]).filter(b=>b.type==="text").map(b=>b.text).join("\n");
      const verificacion = repararJSONGenerico(texto);

      if (!verificacion || !Array.isArray(verificacion.normas)) {
        alert("ARIA no devolvió un JSON válido para la verificación.");
        return;
      }
      const porCodigo = new Map(verificacion.normas.map(n => [String(n.codigo), n]));

      const armarNorma = f => {
        const v = porCodigo.get(String(f.norma));
        const obsOriginal = f.obs || "-";
        const obsFinal = v && v.vigente === false ? `⚠️ NO VIGENTE (verificado) — ${obsOriginal}` : obsOriginal;
        return {
          codigo: f.norma, nombre: f.titulo,
          categoria: f.tipo === "Normativo" ? "RECOMENDADA" : "OBLIGATORIA",
          aspecto: f.aspecto, area_responsable: f.area, descripcion: f.requisito,
          autoridad_aplicacion: f.autoridad, articulo_aplicable: f.articulo,
          obligaciones_concretas: f.requisito, evidencia_objetiva: f.evidencia,
          frecuencia: f.frecuencia, vencimiento: f.vencimiento, responsable_sugerido: f.responsable,
          sanciones: f.sanciones, aplicabilidad: f.aplicabilidad, justificacion_aplicabilidad: f.justif,
          riesgo: f.riesgo, iso_clausula: f.iso,
          actualizacion: (v && v.actualizacion) || "",
          estado: f.estado, observaciones: obsFinal, fecha_evaluacion: f.fecha,
        };
      };

      const data = {
        empresa: empresa.nombre,
        fecha: new Date().toLocaleDateString("es-AR"),
        resumen_ejecutivo: "",
        normativa_nacional: filas.filter(f => f.organismo === "Nacional").map(armarNorma),
        normativa_provincial: filas.filter(f => f.organismo === "Provincial").map(armarNorma),
        normativa_municipal: filas.filter(f => f.organismo === "Municipal").map(armarNorma),
      };

      await exportarMatrizExcel(data, empresa);
    } catch (e) {
      console.error("Error actualizarMatrizDesdeArchivo:", e);
      alert("Error al actualizar la matriz desde el archivo.");
    } finally {
      setActualizandoMatriz(false);
    }
  };

  // ── ENRIQUECER BASE NORMATIVA (rubros_aplicables vía /api/enriquecer-rubros) ──
  const enriquecerBaseNormativa = async () => {
    setEnriqueciendoBase(true);
    setProgresoEnriquecer({ procesadas: 0, total: null });
    let acumulado = 0;
    let total = null;
    try {
      while (true) {
        const resp = await fetch(`/api/enriquecer-rubros?offset=${acumulado}`);
        const data = await resp.json();
        if (!resp.ok) { alert("Error enriqueciendo base normativa: " + (data.error || resp.status)); break; }
        if (total === null) total = data.procesadas + (data.pendientes ?? 0);
        acumulado += data.procesadas;
        setProgresoEnriquecer({ procesadas: acumulado, total });
        if (data.procesadas === 0 || !data.pendientes) break;
      }
    } catch (e) {
      console.error("Error enriquecerBaseNormativa:", e);
      alert("Error de conexión enriqueciendo la base normativa.");
    } finally {
      setEnriqueciendoBase(false);
    }
  };

  // ── AGENDA DE COMPLIANCE ──
  const cargarAgenda = async () => {
    setAgendaCargando(true);
    const agenda = {};
    for (const empresa of empresas) {
      try {
        const { data } = await supabase
          .from("hs_normativa_analisis")
          .select("matriz_estado")
          .eq("empresa_id", empresa.id)
          .order("fecha_analisis", { ascending: false })
          .limit(1);
        if (data && data.length > 0 && data[0].matriz_estado?.length) {
          const hoy = new Date();
          const vencimientos = [];
          data[0].matriz_estado.forEach(fila => {
            if (!fila.frecuencia || !fila.fecha_evaluacion) return;
            const fechaEval = new Date(fila.fecha_evaluacion.split("/").reverse().join("-"));
            if (isNaN(fechaEval)) return;
            let diasFrec = 365;
            if (fila.frecuencia === "Semestral") diasFrec = 180;
            if (fila.frecuencia === "Mensual") diasFrec = 30;
            if (fila.frecuencia === "Permanente") return;
            const fechaVence = new Date(fechaEval.getTime() + diasFrec * 86400000);
            const diasRestantes = Math.floor((fechaVence - hoy) / 86400000);
            if (diasRestantes <= 60) {
              vencimientos.push({
                norma: fila.norma,
                titulo: fila.titulo,
                frecuencia: fila.frecuencia,
                fechaVence: fechaVence.toLocaleDateString("es-AR"),
                diasRestantes,
                estado: fila.estado,
              });
            }
          });
          if (vencimientos.length > 0) {
            agenda[empresa.id] = {
              nombre: empresa.nombre,
              vencimientos: vencimientos.sort((a, b) => a.diasRestantes - b.diasRestantes),
            };
          }
        }
      } catch(e) { console.error("agenda:", e); }
    }
    setAgendaData(agenda);
    setAgendaCargando(false);
    setAgendaVisible(true);
  };

  // ── SEMÁFORO ──
  const calcularSemaforo = (empresa) => {
    const criticos = hallazgos.filter(h => h.empresaId === empresa.id && h.estado === "critico").length;
    const mayores  = hallazgos.filter(h => h.empresaId === empresa.id && h.estado === "mayor").length;
    const vemp = visitasEmpresa(empresa.id);
    const ultima = vemp.sort((a,b) => new Date(b.fecha)-new Date(a.fecha))[0];
    const pts = ultima ? puntajeVisita(ultima.id) : null;
    const diasSinVisita = ultima ? Math.floor((new Date() - new Date(ultima.fecha)) / 86400000) : 999;

    if (criticos > 0 || (pts !== null && pts < 60) || diasSinVisita > 45) {
      return { color:"#e63946", bg:"#fee2e2", label:"Crítico", emoji:"🔴" };
    }
    if (mayores > 0 || (pts !== null && pts < 80) || diasSinVisita > 25) {
      return { color:"#f59e0b", bg:"#fef3c7", label:"Atención", emoji:"🟡" };
    }
    if (pts === null || !ultima) {
      return { color:"#6b7280", bg:"#f3f4f6", label:"Sin datos", emoji:"⚪" };
    }
    return { color:"#22c55e", bg:"#dcfce7", label:"OK", emoji:"🟢" };
  };

  // ── PROGRAMA ANUAL H&S — generación estructurada + exports ──
  const generarProgramaAnual = async (empresa) => {
    const limite = empresa.limite_mensual_aria ?? 5;
    if (limite !== -1) {
      const usados = await contarUsoAriaMes(empresa.id);
      if (usados >= limite) {
        alert("Llegaste al limite mensual de analisis ARIA para " + empresa.nombre + " (" + usados + "/" + limite + "). Para ampliarlo, cambia el limite en la pestana Analisis Legal.");
        return;
      }
    }
    setProgramaCargando(true);
    setProgramaAnualData(null);
    setProgramaAnualTexto("");
    const anioActual = new Date().getFullYear();
    const hEmp = hallazgos.filter(h => h.empresaId === empresa.id);
    const vemp = visitasEmpresa(empresa.id);
    const criticosTxt = hEmp.filter(h=>h.estado==="critico").map(h=>h.observacion||h.referencia).join(" | ") || "ninguno";
    const mayoresTxt  = hEmp.filter(h=>h.estado==="mayor").map(h=>h.observacion||h.referencia).join(" | ") || "ninguno";

    const datosEmpresaTxt = `Empresa: ${empresa.nombre}
Rubro: ${empresa.rubro}
Empleados: ${empresa.empleados||"sin dato"}
Localidad: ${empresa.localidad||empresa.municipio||"sin dato"}, ${empresa.provincia||"sin dato"}
ART: ${empresa.art||"sin dato"}
Visitas realizadas: ${vemp.length}
Hallazgos críticos pendientes: ${hEmp.filter(h=>h.estado==="critico").length} (${criticosTxt})
Hallazgos mayores pendientes: ${hEmp.filter(h=>h.estado==="mayor").length} (${mayoresTxt})`;

    const systemPrompt = "Sos un consultor senior de Higiene y Seguridad en Argentina. Respondés SIEMPRE y ÚNICAMENTE con JSON válido, sin texto adicional, sin markdown, sin explicaciones.";

    let dataA = null, dataB = null;

    try {
      const respA = await fetch("/api/aria", {
        method:"POST",
        headers:{ ...(await authHeader()), "Content-Type":"application/json", "anthropic-version":"2023-06-01" },
        body: JSON.stringify({
          model:"claude-sonnet-4-6",
          max_tokens:4000,
          system: systemPrompt,
          messages:[{ role:"user", content:`Generá los objetivos y el cronograma mensual completo del Programa Anual de Higiene y Seguridad ${anioActual} para esta empresa. Respondé ÚNICAMENTE con un JSON válido con esta estructura exacta:

{
  "empresa": "${empresa.nombre}",
  "anio": ${anioActual},
  "objetivos_generales": ["objetivo 1", "objetivo 2", "objetivo 3"],
  "objetivos_especificos": ["objetivo específico 1", "..."],
  "cronograma": [
    { "mes": "Enero", "actividad": "...", "tipo": "Capacitación", "responsable": "..." }
  ]
}

El cronograma debe cubrir los 12 meses (Enero a Diciembre), con 2 a 4 actividades concretas por mes (capacitaciones, inspecciones, mediciones, simulacros, revisión de EPP, auditorías internas, exámenes médicos periódicos). "tipo" debe ser uno de: Capacitación, Inspección, Medición, Simulacro, Revisión EPP, Documentación, Auditoría, Examen Médico. Las actividades deben ser específicas al rubro "${empresa.rubro}" y considerar los hallazgos críticos/mayores pendientes si los hay.

${datosEmpresaTxt}

Solo JSON válido, sin markdown, sin explicaciones.` }]
        })
      });
      const respDataA = await respA.json();
      const textoA = (respDataA.content||[]).filter(b=>b.type==="text").map(b=>b.text).join("\n");
      dataA = repararJSONGenerico(textoA);
    } catch(e) { console.error("Programa anual - llamada A:", e); }

    try {
      const respB = await fetch("/api/aria", {
        method:"POST",
        headers:{ ...(await authHeader()), "Content-Type":"application/json", "anthropic-version":"2023-06-01" },
        body: JSON.stringify({
          model:"claude-sonnet-4-6",
          max_tokens:2500,
          system: systemPrompt,
          messages:[{ role:"user", content:`Generá los responsables, indicadores de seguimiento, presupuesto estimado y plan de acción para hallazgos críticos del Programa Anual de Higiene y Seguridad ${anioActual} de esta empresa. Respondé ÚNICAMENTE con un JSON válido con esta estructura exacta:

{
  "responsables": [
    { "area": "Dirección", "responsable": "...", "funcion": "..." }
  ],
  "indicadores": [
    { "indicador": "...", "meta": "...", "frecuencia": "Mensual|Trimestral|Semestral|Anual" }
  ],
  "presupuesto": [
    { "item": "...", "rango_estimado_ars": "...", "categoria": "Capacitación|EPP|Mediciones|Infraestructura|Otro" }
  ],
  "plan_accion_criticos": [
    { "hallazgo": "...", "accion_correctiva": "...", "plazo": "...", "responsable": "..." }
  ]
}

responsables: mínimo 4 áreas (Dirección, Jefe de Calidad/H&S, Producción, RRHH).
indicadores: mínimo 5 indicadores cuantificables (% cumplimiento capacitaciones, índice de frecuencia de accidentes, % EPP entregado, días sin accidentes, etc.).
presupuesto: mínimo 6 ítems con rangos aproximados en pesos argentinos.
plan_accion_criticos: si hay hallazgos críticos o mayores pendientes generá un plan para cada uno; si no hay ninguno, devolvé [].

${datosEmpresaTxt}

Solo JSON válido, sin markdown, sin explicaciones.` }]
        })
      });
      const respDataB = await respB.json();
      const textoB = (respDataB.content||[]).filter(b=>b.type==="text").map(b=>b.text).join("\n");
      dataB = repararJSONGenerico(textoB);
    } catch(e) { console.error("Programa anual - llamada B:", e); }

    if (!dataA && !dataB) {
      setProgramaAnualTexto("Error al conectar con ARIA.");
      setProgramaCargando(false);
      return;
    }

    const programaGenerado = {
      empresa: dataA?.empresa || empresa.nombre,
      anio: dataA?.anio || anioActual,
      objetivos_generales: dataA?.objetivos_generales || [],
      objetivos_especificos: dataA?.objetivos_especificos || [],
      cronograma: dataA?.cronograma || [],
      responsables: dataB?.responsables || [],
      indicadores: dataB?.indicadores || [],
      presupuesto: dataB?.presupuesto || [],
      plan_accion_criticos: dataB?.plan_accion_criticos || [],
    };
    setProgramaAnualData(programaGenerado);
    setProgramaAnualLoadedFor(empresa.id);
    supabase.from('hs_programas_anuales')
      .upsert({ empresa_id: empresa.id, anio: anioActual, data: programaGenerado, tenant_id: Number(localStorage.getItem("alqos_tenant_id")) || null }, { onConflict: 'empresa_id,anio' })
      .then(({ error }) => { if (error) console.error('Error guardando programa anual:', error); });
    await registrarUsoAria(empresa.id);
    setProgramaCargando(false);
  };

  const exportarProgramaExcel = async (data, empresa) => {
    const wb = new ExcelJS.Workbook();
    wb.creator = "ALQOS™";
    wb.created = new Date();
    const AZUL = "FF1C3FAA", AZUL_CLARO = "FFE8E9F6", BLANCO = "FFFFFFFF", GRIS_CLARO = "FFF9FAFB";
    const borderHair = { top:{style:"hair",color:{argb:"FFE5E7EB"}}, bottom:{style:"hair",color:{argb:"FFE5E7EB"}}, left:{style:"hair",color:{argb:"FFE5E7EB"}}, right:{style:"hair",color:{argb:"FFE5E7EB"}} };
    const borderThin = { top:{style:"thin",color:{argb:"FFD1D5DB"}}, bottom:{style:"thin",color:{argb:"FFD1D5DB"}}, left:{style:"thin",color:{argb:"FFD1D5DB"}}, right:{style:"thin",color:{argb:"FFD1D5DB"}} };
    const setHeader = (cell, txt) => { cell.value = txt; cell.font = { bold:true, color:{argb:BLANCO}, size:10 }; cell.fill = { type:"pattern", pattern:"solid", fgColor:{argb:AZUL} }; cell.alignment = { vertical:"middle", horizontal:"center", wrapText:true }; cell.border = borderThin; };
    const setCell = (cell, val, bg, bold, color) => { cell.value = val ?? ""; cell.font = { size:9, bold:!!bold, color:{argb:color||"FF111827"} }; cell.fill = { type:"pattern", pattern:"solid", fgColor:{argb:bg||BLANCO} }; cell.alignment = { vertical:"middle", wrapText:true }; cell.border = borderHair; };
    const portada = (ws, titulo) => {
      const r1 = ws.getRow(1); r1.height = 36;
      const c1 = r1.getCell(1);
      c1.value = `PROGRAMA ANUAL H&S ${data.anio||""} · ALQOS™`;
      c1.font = { bold:true, size:12, color:{argb:BLANCO} };
      c1.fill = { type:"pattern", pattern:"solid", fgColor:{argb:AZUL} };
      c1.alignment = { vertical:"middle" };
      const r2 = ws.getRow(2); r2.height = 22;
      const c2 = r2.getCell(1);
      c2.value = `${empresa.nombre||""} · ${titulo}`;
      c2.font = { bold:true, size:10, color:{argb:"FF1C3FAA"} };
      c2.fill = { type:"pattern", pattern:"solid", fgColor:{argb:AZUL_CLARO} };
      c2.alignment = { vertical:"middle" };
    };

    const wsRes = wb.addWorksheet("Resumen");
    wsRes.columns = [{width:24},{width:80}];
    portada(wsRes, "Resumen ejecutivo");
    const hR = wsRes.getRow(3); hR.height = 22;
    setHeader(hR.getCell(1), "Dato"); setHeader(hR.getCell(2), "Información");
    [["Empresa", empresa.nombre||""], ["Rubro", empresa.rubro||""], ["Año", data.anio||""],
     ["Objetivos generales", (data.objetivos_generales||[]).join(" · ")],
     ["Objetivos específicos", (data.objetivos_especificos||[]).join(" · ")]].forEach(([k,v],i)=>{
      const row = wsRes.getRow(i+4); row.height = 30;
      setCell(row.getCell(1), k, i%2===0?BLANCO:GRIS_CLARO, true, "FF1C3FAA");
      setCell(row.getCell(2), v, i%2===0?BLANCO:GRIS_CLARO, false);
    });

    const wsCron = wb.addWorksheet("Cronograma Mensual");
    wsCron.columns = [{width:14},{width:50},{width:18},{width:24}];
    portada(wsCron, "Cronograma mensual de actividades");
    const hC = wsCron.getRow(3); hC.height = 22;
    ["Mes","Actividad","Tipo","Responsable"].forEach((t,i)=>setHeader(hC.getCell(i+1), t));
    (data.cronograma||[]).forEach((c,idx)=>{
      const bg = idx%2===0?BLANCO:GRIS_CLARO;
      const row = wsCron.getRow(idx+4); row.height = 26;
      setCell(row.getCell(1), c.mes, bg, true, "FF1C3FAA");
      setCell(row.getCell(2), c.actividad, bg, false);
      setCell(row.getCell(3), c.tipo, bg, false);
      setCell(row.getCell(4), c.responsable, bg, false);
    });
    wsCron.views = [{ state:"frozen", ySplit:3 }];

    const wsResp = wb.addWorksheet("Responsables");
    wsResp.columns = [{width:22},{width:30},{width:50}];
    portada(wsResp, "Responsables por área");
    const hRe = wsResp.getRow(3); hRe.height = 22;
    ["Área","Responsable","Función"].forEach((t,i)=>setHeader(hRe.getCell(i+1), t));
    (data.responsables||[]).forEach((r,idx)=>{
      const bg = idx%2===0?BLANCO:GRIS_CLARO;
      const row = wsResp.getRow(idx+4); row.height = 26;
      setCell(row.getCell(1), r.area, bg, true, "FF1C3FAA");
      setCell(row.getCell(2), r.responsable, bg, false);
      setCell(row.getCell(3), r.funcion, bg, false);
    });

    const wsInd = wb.addWorksheet("Indicadores");
    wsInd.columns = [{width:40},{width:30},{width:18}];
    portada(wsInd, "Indicadores de seguimiento");
    const hI = wsInd.getRow(3); hI.height = 22;
    ["Indicador","Meta","Frecuencia"].forEach((t,i)=>setHeader(hI.getCell(i+1), t));
    (data.indicadores||[]).forEach((ind,idx)=>{
      const bg = idx%2===0?BLANCO:GRIS_CLARO;
      const row = wsInd.getRow(idx+4); row.height = 26;
      setCell(row.getCell(1), ind.indicador, bg, true, "FF1C3FAA");
      setCell(row.getCell(2), ind.meta, bg, false);
      setCell(row.getCell(3), ind.frecuencia, bg, false);
    });

    const wsPre = wb.addWorksheet("Presupuesto");
    wsPre.columns = [{width:36},{width:22},{width:22}];
    portada(wsPre, "Presupuesto estimado");
    const hP = wsPre.getRow(3); hP.height = 22;
    ["Ítem","Rango estimado (ARS)","Categoría"].forEach((t,i)=>setHeader(hP.getCell(i+1), t));
    (data.presupuesto||[]).forEach((p,idx)=>{
      const bg = idx%2===0?BLANCO:GRIS_CLARO;
      const row = wsPre.getRow(idx+4); row.height = 26;
      setCell(row.getCell(1), p.item, bg, true, "FF1C3FAA");
      setCell(row.getCell(2), p.rango_estimado_ars, bg, false);
      setCell(row.getCell(3), p.categoria, bg, false);
    });

    if ((data.plan_accion_criticos||[]).length) {
      const wsPlan = wb.addWorksheet("Plan de Acción Críticos");
      wsPlan.columns = [{width:40},{width:40},{width:18},{width:22}];
      portada(wsPlan, "Plan de acción - hallazgos críticos");
      const hPl = wsPlan.getRow(3); hPl.height = 22;
      ["Hallazgo","Acción correctiva","Plazo","Responsable"].forEach((t,i)=>setHeader(hPl.getCell(i+1), t));
      data.plan_accion_criticos.forEach((pl,idx)=>{
        const bg = idx%2===0?BLANCO:GRIS_CLARO;
        const row = wsPlan.getRow(idx+4); row.height = 30;
        setCell(row.getCell(1), pl.hallazgo, bg, true, "FFB91C1C");
        setCell(row.getCell(2), pl.accion_correctiva, bg, false);
        setCell(row.getCell(3), pl.plazo, bg, false);
        setCell(row.getCell(4), pl.responsable, bg, false);
      });
    }

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ALQOS_ProgramaAnualHS_${(empresa.nombre||"empresa").replace(/\s+/g,"_")}_${data.anio||new Date().getFullYear()}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const exportarProgramaWord = async (data, empresa) => {
    const AZUL = "1C3FAA";
    const tituloHeading = (texto) => new Paragraph({ text:texto, heading:HeadingLevel.HEADING_1, spacing:{before:300,after:150} });
    const subHeading = (texto) => new Paragraph({ text:texto, heading:HeadingLevel.HEADING_2, spacing:{before:200,after:100} });
    const celdaHeader = (texto) => new TableCell({ children:[new Paragraph({ children:[new TextRun({ text:texto, bold:true, color:"FFFFFF" })] })], shading:{ fill:AZUL, type:ShadingType.CLEAR, color:"auto" } });
    const celda = (texto) => new TableCell({ children:[new Paragraph({ text:String(texto??"") })] });
    const tablaDesde = (headers, filas) => new Table({
      width:{ size:100, type:WidthType.PERCENTAGE },
      rows:[ new TableRow({ children:headers.map(celdaHeader) }), ...filas.map(f => new TableRow({ children:f.map(celda) })) ],
    });

    const children = [];
    children.push(new Paragraph({ children:[new TextRun({ text:`PROGRAMA ANUAL DE HIGIENE Y SEGURIDAD ${data.anio||""}`, bold:true, size:32, color:AZUL })], spacing:{after:100} }));
    children.push(new Paragraph({ children:[new TextRun({ text:`${empresa.nombre||""} · ${empresa.rubro||""}`, size:24 })], spacing:{after:300} }));

    children.push(subHeading("Objetivos generales"));
    (data.objetivos_generales||[]).forEach(o => children.push(new Paragraph({ text:`• ${o}` })));
    children.push(subHeading("Objetivos específicos"));
    (data.objetivos_especificos||[]).forEach(o => children.push(new Paragraph({ text:`• ${o}` })));

    children.push(tituloHeading("Cronograma mensual de actividades"));
    children.push(tablaDesde(["Mes","Actividad","Tipo","Responsable"], (data.cronograma||[]).map(c => [c.mes, c.actividad, c.tipo, c.responsable])));

    children.push(tituloHeading("Responsables por área"));
    children.push(tablaDesde(["Área","Responsable","Función"], (data.responsables||[]).map(r => [r.area, r.responsable, r.funcion])));

    children.push(tituloHeading("Indicadores de seguimiento"));
    children.push(tablaDesde(["Indicador","Meta","Frecuencia"], (data.indicadores||[]).map(i => [i.indicador, i.meta, i.frecuencia])));

    children.push(tituloHeading("Presupuesto estimado"));
    children.push(tablaDesde(["Ítem","Rango estimado (ARS)","Categoría"], (data.presupuesto||[]).map(p => [p.item, p.rango_estimado_ars, p.categoria])));

    if ((data.plan_accion_criticos||[]).length) {
      children.push(tituloHeading("Plan de acción — hallazgos críticos"));
      children.push(tablaDesde(["Hallazgo","Acción correctiva","Plazo","Responsable"], data.plan_accion_criticos.map(p => [p.hallazgo, p.accion_correctiva, p.plazo, p.responsable])));
    }

    children.push(new Paragraph({ text:"", spacing:{before:400} }));
    children.push(new Paragraph({ text:"Firma Responsable H&S: ______________________   Fecha: ______________" }));
    children.push(new Paragraph({ text:"Aprobado por Dirección: ______________________   Fecha: ______________", spacing:{before:200} }));

    const doc = new Document({ sections:[{ children }] });
    const blob = await Packer.toBlob(doc);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ALQOS_ProgramaAnualHS_${(empresa.nombre||"empresa").replace(/\s+/g,"_")}_${data.anio||new Date().getFullYear()}.docx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // ── ASPECTOS AMBIENTALES — funciones ────────────────────────────────────────

  const calcularSignificancia = (p, c, flag_lp, flag_pi) => {
    const valor = p * c;
    let nivel, es_significativo;
    if (valor <= 6)       { nivel = "Tolerable";    es_significativo = false; }
    else if (valor <= 14) { nivel = "Moderado";     es_significativo = false; }
    else                  { nivel = "Significativo"; es_significativo = true; }
    if (!es_significativo && valor >= 9 && (flag_lp || flag_pi)) {
      nivel = "Significativo"; es_significativo = true;
    }
    return { valor, nivel, es_significativo };
  };

  const calcularIMA = (aspectosEmp, lastAnal) => {
    // C1 — Identificación de aspectos (ISO 14001 §6.1.2)
    const sig = aspectosEmp.filter(a =>
      calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi).es_significativo
    );
    const c1 = aspectosEmp.length === 0 ? 0 : sig.length === 0 ? 15 : 25;

    // C2 — Evaluación de cumplimiento legal (§6.1.3)
    let c2 = 0;
    if (lastAnal) {
      const meses = (Date.now() - new Date(lastAnal)) / (1000 * 60 * 60 * 24 * 30);
      c2 = meses <= 6 ? 25 : 12;
    }

    // C3 — Control de aspectos significativos (§8.1)
    let c3 = 0;
    if (sig.length > 0) {
      const conControl = sig.filter(
        a => a.descripcion_control?.trim() || a.plan_accion?.accion
      ).length;
      c3 = Math.round((conControl / sig.length) * 25);
    }

    // C4 — Efectividad de planes de acción (§10.1)
    const PESOS_ESTADO = { Pendiente: 0, "En curso": 0.5, Completado: 0.8, Verificado: 1.0 };
    const conPlan = aspectosEmp.filter(a => a.plan_accion?.accion);
    let c4 = 0;
    if (conPlan.length > 0) {
      const avg = conPlan.reduce(
        (sum, a) => sum + (PESOS_ESTADO[a.plan_accion.estado] ?? 0), 0
      ) / conPlan.length;
      c4 = Math.round(avg * 25);
    }

    const total = c1 + c2 + c3 + c4;
    const nota  = total >= 85 ? "A" : total >= 65 ? "B" : total >= 45 ? "C" : "D";
    const color = total >= 85 ? "#16a34a" : total >= 65 ? "#2A7FFF" : total >= 45 ? "#d97706" : "#dc2626";
    return { total, nota, color, c1, c2, c3, c4 };
  };

  const guardarAspectos = (lista) => {
    localStorage.setItem(STORAGE_ASPECTOS, JSON.stringify(lista));
    setAspectosState(lista);
    subirDatos(STORAGE_ASPECTOS);
  };

  // eslint-disable-next-line no-unused-vars
  const guardarObjetivos = (lista) => {
    localStorage.setItem("alqos_consultor_objetivos", JSON.stringify(lista));
    setObjetivos(lista);
    subirDatos("alqos_consultor_objetivos");
  };

  // eslint-disable-next-line no-unused-vars
  const ariaSupgerirAspectos = async () => {
    if (!empresaSel) return;
    setAspectoCargando(true);
    const empresa = empresaSel;
    if (!empresa) { setAspectoCargando(false); return; }
    try {
      const resp = await fetch("/api/aria", {
        method: "POST",
        headers: { ...(await authHeader()), "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "claude-sonnet-4-6",
          max_tokens: 3000,
          system: "Sos un experto en ISO 14001:2015 y gestión ambiental para la industria gráfica argentina. Respondés siempre en español con JSON válido.",
          messages: [{ role: "user", content:
            `Empresa: ${empresa.nombre}, Rubro: ${empresa.rubro || "Gráfica / Imprenta"}, Actividades: ${empresa.actividades || "no especificadas"}.

Identificá 8 aspectos ambientales significativos típicos para esta empresa, cubriendo distintas etapas del ciclo de vida (pre-prensa, impresión, acabados, mantenimiento, etc.).

Devolvé SOLO un JSON array con este esquema por objeto:
{"etapa":"string","aspecto":"string","impacto":"string","tipo":"Negativo"|"Positivo","recurso":"string","probabilidad":1-5,"consecuencia":1-5,"flag_lp":true|false,"flag_pi":false,"flag_en":false,"condicion":"Normal"|"Anormal"|"Emergencia","descripcion_control":"string"}`
          }],
        }),
      });
      const data = await resp.json();
      const content = data.content?.[0]?.text || "";
      const match = content.match(/\[[\s\S]*\]/);
      if (!match) throw new Error("Sin JSON en respuesta");
      const sugeridos = JSON.parse(match[0]);
      const existentes = new Set(aspectos.map(a => a.aspecto?.toLowerCase()));
      const nuevos = sugeridos
        .filter(s => !existentes.has(s.aspecto?.toLowerCase()))
        .map((s, i) => ({ ...s, id: Math.floor(Date.now()) + i, empresa_id: empresaSel.id, fecha_creacion: new Date().toISOString().slice(0, 10) }));
      if (nuevos.length) guardarAspectos([...aspectos, ...nuevos]);
    } catch (e) { console.error("ariaSupgerirAspectos:", e); }
    setAspectoCargando(false);
  };

  // eslint-disable-next-line no-unused-vars
  const exportarAspectosExcel = async (lista, empresa) => {
    const wb = new ExcelJS.Workbook();
    wb.creator = "ALQOS"; wb.created = new Date();

    const COLS = ["Etapa ciclo de vida","Aspecto ambiental","Impacto ambiental","Tipo","Recurso afectado","Probabilidad","Consecuencia","Valor P×C","Significancia","LP","PI","EN","Condición","Control existente"];
    const filaDesde = (a) => {
      const { valor, nivel } = calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi);
      return [a.etapa, a.aspecto, a.impacto, a.tipo, a.recurso, a.probabilidad, a.consecuencia, valor, nivel, a.flag_lp?"✓":"", a.flag_pi?"✓":"", a.flag_en?"✓":"", a.condicion, a.descripcion_control];
    };
    const colorNivel = (n) => n === "Significativo" ? "FFCCCC" : n === "Moderado" ? "FFEEBB" : "CCFFCC";

    const agregarHoja = (nombre, filas) => {
      const ws = wb.addWorksheet(nombre);
      const hr = ws.addRow(COLS);
      hr.font = { bold:true, color:{ argb:"FFFFFFFF" } };
      hr.fill = { type:"pattern", pattern:"solid", fgColor:{ argb:"FF09184D" } };
      filas.forEach(f => {
        const row = ws.addRow(f);
        const nivel = f[8];
        row.getCell(9).fill = { type:"pattern", pattern:"solid", fgColor:{ argb:"FF" + colorNivel(nivel) } };
      });
      COLS.forEach((_, i) => { ws.getColumn(i + 1).width = 22; });
    };

    const todasFilas = lista.map(filaDesde);
    agregarHoja("Matriz completa", todasFilas);
    agregarHoja("Significativos", todasFilas.filter(f => f[8] === "Significativo"));

    const wsEtapa = wb.addWorksheet("Por etapa");
    [...new Set(lista.map(a => a.etapa))].forEach(etapa => {
      wsEtapa.addRow([`── ${etapa} ──`]).font = { bold:true, color:{ argb:"FF7B5BF2" } };
      lista.filter(a => a.etapa === etapa).map(filaDesde).forEach(f => wsEtapa.addRow(f));
      wsEtapa.addRow([]);
    });
    COLS.forEach((_, i) => { wsEtapa.getColumn(i + 1).width = 22; });

    const wsRes = wb.addWorksheet("Resumen");
    const sig = lista.filter(a => calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi).es_significativo).length;
    const mod = lista.filter(a => { const r = calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi); return !r.es_significativo && r.valor > 6; }).length;
    const tol = lista.length - sig - mod;
    wsRes.addRow(["Resumen de Aspectos Ambientales"]).font = { bold:true, size:14 };
    wsRes.addRow([]);
    wsRes.addRow(["Empresa", empresa?.nombre || ""]);
    wsRes.addRow(["Fecha", new Date().toLocaleDateString("es-AR")]);
    wsRes.addRow([]);
    wsRes.addRow(["Nivel", "Cantidad"]).font = { bold:true };
    wsRes.addRow(["Significativo", sig]);
    wsRes.addRow(["Moderado", mod]);
    wsRes.addRow(["Tolerable", tol]);
    wsRes.addRow(["TOTAL", lista.length]).font = { bold:true };
    wsRes.getColumn(1).width = 20; wsRes.getColumn(2).width = 14;

    const conPlan = lista.filter(a => a.plan_accion?.accion);
    if (conPlan.length) {
      const wsPlan = wb.addWorksheet("Plan de Acción");
      const hrPlan = wsPlan.addRow(["Etapa","Aspecto","Nivel","Acción","Responsable","Plazo","Estado","Evidencia","Observaciones"]);
      hrPlan.font = { bold:true, color:{ argb:"FFFFFFFF" } };
      hrPlan.fill = { type:"pattern", pattern:"solid", fgColor:{ argb:"FF7B5BF2" } };
      conPlan.forEach(a => {
        const { nivel } = calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi);
        const pa = a.plan_accion;
        const row = wsPlan.addRow([a.etapa, a.aspecto, nivel, pa.accion, pa.responsable, pa.plazo, pa.estado, pa.evidencia, pa.observaciones]);
        row.getCell(3).fill = { type:"pattern", pattern:"solid", fgColor:{ argb:"FF" + colorNivel(nivel) } };
      });
      [20,28,14,36,18,14,14,24,28].forEach((w,i) => { wsPlan.getColumn(i+1).width = w; });
    }

    const buf = await wb.xlsx.writeBuffer();
    const blob = new Blob([buf], { type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ALQOS_AspectosAmbientales_${(empresa?.nombre||"empresa").replace(/\s+/g,"_")}_${new Date().getFullYear()}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const exportarAspectosWord = async (lista, empresa, normativasJson) => {
    const AZUL_W  = "1C3FAA";
    const VERDE_W = "166534";
    const GRIS_W  = "64748B";

    const h1  = (t) => new Paragraph({ text: t, heading: HeadingLevel.HEADING_1, spacing: { before: 400, after: 150 } });
    const h2  = (t) => new Paragraph({ text: t, heading: HeadingLevel.HEADING_2, spacing: { before: 250, after: 100 } });
    const ln  = (t, opts = {}) => new Paragraph({ children: [new TextRun({ text: String(t ?? ""), ...opts })], spacing: { after: 80 } });
    const bala = (t) => new Paragraph({ text: `• ${t}`, spacing: { after: 60 } });
    const cH  = (texto, w) => new TableCell({
      width: w ? { size: w, type: WidthType.PERCENTAGE } : undefined,
      children: [new Paragraph({ children: [new TextRun({ text: texto, bold: true, color: "FFFFFF" })] })],
      shading: { fill: AZUL_W, type: ShadingType.CLEAR, color: "auto" },
    });
    const cD  = (texto, shade) => new TableCell({
      children: [new Paragraph({ text: String(texto ?? ""), spacing: { after: 40 } })],
      shading: shade ? { fill: shade, type: ShadingType.CLEAR, color: "auto" } : undefined,
    });
    const tblW = (headers, rows) => new Table({
      width: { size: 100, type: WidthType.PERCENTAGE },
      rows: [
        new TableRow({ children: headers.map(([t, w]) => cH(t, w)) }),
        ...rows.map(row => new TableRow({ children: row.map(([t, sh]) => cD(t, sh)) })),
      ],
    });
    const shNivel = (n) => n === "Significativo" ? "FFCCCC" : n === "Moderado" ? "FFEEBB" : "CCFFCC";

    let norm = null;
    try { norm = normativasJson ? JSON.parse(normativasJson) : null; } catch {}

    const sigL = lista.filter(a => calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi).es_significativo);
    const modL = lista.filter(a => { const r = calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi); return !r.es_significativo && r.valor > 6; });
    const tolL = lista.filter(a => { const r = calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi); return r.valor <= 6; });

    const ch = [];

    // ── Carátula ──────────────────────────────────────────────────
    ch.push(new Paragraph({ children: [new TextRun({ text: "ALQOS™", bold: true, size: 52, color: AZUL_W })], spacing: { after: 60 } }));
    ch.push(new Paragraph({ children: [new TextRun({ text: "Sistema de Gestión Ambiental · ISO 14001:2015/2026", size: 22, color: GRIS_W })], spacing: { after: 240 } }));
    ch.push(new Paragraph({ children: [new TextRun({ text: "INFORME DE ASPECTOS AMBIENTALES", bold: true, size: 38, color: VERDE_W })], spacing: { after: 300 } }));
    ch.push(ln(""));
    [["Empresa", empresa?.nombre], ["CUIT", empresa?.cuit || "—"], ["Rubro", empresa?.rubro || "—"],
     ["Localidad", `${empresa?.municipio || empresa?.localidad || "—"}, ${empresa?.provincia || "—"}`],
     ["Fecha de emisión", new Date().toLocaleDateString("es-AR", { day: "2-digit", month: "long", year: "numeric" })]
    ].forEach(([k, v]) => ch.push(new Paragraph({ children: [new TextRun({ text: `${k}: `, bold: true }), new TextRun({ text: String(v ?? "—") })], spacing: { after: 80 } })));
    ch.push(ln(""));

    // IMA
    const imaW     = calcularIMA(lista, normativaAmbientalHistorial[0]?.fecha_analisis || null);
    const imaDescW = imaW.nota === "A" ? "Listo para auditoría"
                   : imaW.nota === "B" ? "En camino, ajustes menores"
                   : imaW.nota === "C" ? "Brechas importantes"
                   : "Implementación inicial";
    const shIma  = (pts) => pts >= 20 ? "CCFFCC" : pts >= 12 ? "FFEEBB" : "FFCCCC";
    const icoIma = (pts) => pts >= 20 ? "✓" : pts >= 12 ? "⚠" : "✗";
    ch.push(tblW(
      [["Índice de Madurez Ambiental (IMA)", 70], ["Puntaje / Nota", 30]],
      [
        [["IMA Total — " + imaDescW,                 undefined],       [`${imaW.total}/100 · Nota: ${imaW.nota}`, undefined]],
        [["C1 · Identificación de aspectos  §6.1.2", shIma(imaW.c1)], [`${imaW.c1}/25 ${icoIma(imaW.c1)}`,      shIma(imaW.c1)]],
        [["C2 · Cumplimiento legal          §6.1.3", shIma(imaW.c2)], [`${imaW.c2}/25 ${icoIma(imaW.c2)}`,      shIma(imaW.c2)]],
        [["C3 · Control de significativos   §8.1",   shIma(imaW.c3)], [`${imaW.c3}/25 ${icoIma(imaW.c3)}`,      shIma(imaW.c3)]],
        [["C4 · Efectividad de planes       §10.1",  shIma(imaW.c4)], [`${imaW.c4}/25 ${icoIma(imaW.c4)}`,      shIma(imaW.c4)]],
      ]
    ));
    ch.push(ln(""));

    ch.push(new Paragraph({ children: [new TextRun({ text: "Confidencial — Para uso exclusivo del cliente", italic: true, color: GRIS_W, size: 18 })] }));

    // ── 1. Resumen ejecutivo ──────────────────────────────────────
    ch.push(h1("1. Resumen Ejecutivo"));
    ch.push(tblW(
      [["Nivel de Significancia", 45], ["Cantidad", 25], ["% del Total", 30]],
      [
        [["Significativo", "FFCCCC"], [String(sigL.length), "FFCCCC"], [`${lista.length ? Math.round(sigL.length * 100 / lista.length) : 0}%`, "FFCCCC"]],
        [["Moderado",      "FFEEBB"], [String(modL.length), "FFEEBB"], [`${lista.length ? Math.round(modL.length * 100 / lista.length) : 0}%`, "FFEEBB"]],
        [["Tolerable",     "CCFFCC"], [String(tolL.length), "CCFFCC"], [`${lista.length ? Math.round(tolL.length * 100 / lista.length) : 0}%`, "CCFFCC"]],
        [["TOTAL", undefined], [String(lista.length), undefined], ["100%", undefined]],
      ]
    ));
    if (norm?.resumen_ejecutivo) { ch.push(ln("")); ch.push(ln(norm.resumen_ejecutivo)); }

    // ── 2. Objetivos Ambientales §6.2 ────────────────────────────
    ch.push(h1("2. Objetivos Ambientales (§6.2)"));
    const objsW = objetivos.filter(o => o.empresa_id === empresa?.id);
    if (!objsW.length) {
      ch.push(ln("No se registran objetivos ambientales formales en esta evaluación."));
    } else {
      const shObjW = (est) => est === "Alcanzado" ? "CCFFCC" : est === "En curso" ? "DBEAFE" : est === "Abandonado" ? "FFCCCC" : "F1F5F9";
      ch.push(tblW(
        [["Objetivo", 28], ["Indicador / Unidad", 20], ["Base → Meta", 14], ["Responsable", 14], ["Plazo", 10], ["Estado", 14]],
        objsW.map(o => {
          const vb = o.valor_base !== "" ? String(o.valor_base) : "—";
          const mt = o.meta !== "" ? String(o.meta) : "—";
          const redPct = (o.valor_base && o.meta) ? ` (-${Math.round((1-Number(o.meta)/Number(o.valor_base))*100)}%)` : "";
          const sh = shObjW(o.estado);
          return [
            [o.titulo || "—", sh],
            [`${o.indicador||"—"}${o.unidad ? ` (${o.unidad})` : ""}`, sh],
            [`${vb} → ${mt}${redPct}`, sh],
            [o.responsable || "—", sh],
            [o.plazo || "—", sh],
            [o.estado || "Planificado", sh],
          ];
        })
      ));
      objsW.forEach(o => {
        const meds = o.mediciones || [];
        if (!meds.length) return;
        ch.push(h2(`Mediciones: ${o.titulo}`));
        ch.push(tblW(
          [["Mes/Año", 25], ["Valor", 25], ["Observaciones", 50]],
          meds.map(m => [[m.fecha||"—", undefined], [String(m.valor??"—"), undefined], [m.observaciones||"—", undefined]])
        ));
      });
    }

    // ── 3. Aspectos significativos ────────────────────────────────
    ch.push(h1("3. Aspectos Ambientales Significativos"));
    if (!sigL.length) {
      ch.push(ln("No se registran aspectos significativos en esta evaluación."));
    } else {
      ch.push(tblW(
        [["Etapa", 15], ["Aspecto", 19], ["Impacto", 17], ["Tipo", 8], ["Recurso", 13], ["P×C", 8], ["Flags", 9], ["Control", 11]],
        sigL.map(a => {
          const { valor } = calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi);
          const flags = [a.flag_lp && "LP", a.flag_pi && "PI", a.flag_en && "EN"].filter(Boolean).join(" ") || "—";
          return [
            [a.etapa || "—", "FFCCCC"], [a.aspecto || "—", "FFCCCC"], [a.impacto || "—", "FFCCCC"],
            [a.tipo || "—", "FFCCCC"], [a.recurso || "—", "FFCCCC"],
            [`${a.probabilidad}×${a.consecuencia}=${valor}`, "FFCCCC"],
            [flags, "FFCCCC"], [a.descripcion_control || "—", "FFCCCC"],
          ];
        })
      ));
    }

    // ── 3. Matriz completa ────────────────────────────────────────
    ch.push(h1("4. Matriz Completa de Aspectos e Impactos"));
    ch.push(tblW(
      [["Etapa", 13], ["Aspecto", 15], ["Impacto", 13], ["Tipo", 7], ["Recurso", 10], ["P", 4], ["C", 4], ["P×C", 5], ["Nivel", 11], ["Cond.", 7], ["LP/PI/EN", 7], ["Control", 4]],
      lista.map(a => {
        const { valor, nivel } = calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi);
        const sh    = shNivel(nivel);
        const flags = [a.flag_lp && "LP", a.flag_pi && "PI", a.flag_en && "EN"].filter(Boolean).join(" ") || "—";
        return [
          [a.etapa || "—", undefined], [a.aspecto || "—", undefined], [a.impacto || "—", undefined],
          [a.tipo || "—", undefined],  [a.recurso || "—", undefined],
          [String(a.probabilidad), undefined], [String(a.consecuencia), undefined],
          [String(valor), sh], [nivel, sh], [a.condicion || "Normal", undefined],
          [flags, undefined], [a.descripcion_control || "—", undefined],
        ];
      })
    ));

    // ── 4. Normativa ambiental aplicable ─────────────────────────
    ch.push(h1("5. Normativa Ambiental Aplicable"));
    if (!norm) {
      ch.push(ln("Sin análisis de normativa ambiental. Ejecute el análisis en la sub-sección correspondiente."));
    } else {
      [["4.1 Normativa Nacional",   norm.normativa_nacional],
       ["4.2 Normativa Provincial", norm.normativa_provincial],
       ["4.3 Normativa Municipal",  norm.normativa_municipal],
      ].forEach(([titulo, listaN]) => {
        if (!listaN?.length) return;
        ch.push(h2(titulo));
        ch.push(tblW(
          [["Código", 11], ["Nombre", 27], ["Aplica", 11], ["Riesgo", 8], ["Obligaciones concretas", 43]],
          listaN.map(n => [
            [n.codigo || "—", undefined],
            [n.nombre  || "—", undefined],
            [n.aplicabilidad || "APLICA",
              n.aplicabilidad === "NO APLICA" ? "FFEEEE" : n.aplicabilidad === "APLICA PARCIALMENTE" ? "FFEEBB" : undefined],
            [n.riesgo || "—",
              n.riesgo === "CRITICO" ? "FFCCCC" : n.riesgo === "ALTO" ? "FFEEBB" : undefined],
            [n.obligaciones_concretas || n.descripcion || "—", undefined],
          ])
        ));
      });
      if (norm.actualizaciones_recientes?.length) {
        ch.push(h2("4.4 Actualizaciones Recientes"));
        norm.actualizaciones_recientes.forEach(u => ch.push(bala(`${u.norma} (${u.fecha || "—"}): ${u.descripcion || ""}`)));
      }
    }

    // ── 5. Checklist de cumplimiento ─────────────────────────────
    ch.push(h1("6. Checklist de Cumplimiento ISO 14001"));
    const checkl = norm?.checklist_ambiental || [];
    if (!checkl.length) {
      ch.push(ln("Sin checklist disponible. Ejecute primero el análisis de normativa ambiental."));
    } else {
      ch.push(tblW(
        [["Prioridad", 11], ["Ítem a verificar", 61], ["Normativa de referencia", 28]],
        checkl.map(item => [
          [item.prioridad || "—", item.prioridad === "ALTA" ? "FFCCCC" : item.prioridad === "MEDIA" ? "FFEEBB" : "CCFFCC"],
          [item.item      || "—", undefined],
          [item.normativa || "—", undefined],
        ])
      ));
    }

    // ── 6. Obligaciones operativas / Recomendaciones ──────────────
    ch.push(h1("7. Obligaciones Operativas y Recomendaciones"));
    const obligs = norm?.obligaciones_operativas || [];
    if (!obligs.length) {
      ch.push(ln("Sin obligaciones operativas disponibles."));
    } else {
      ch.push(tblW(
        [["Aspecto", 16], ["Obligación", 44], ["Normativa", 22], ["Frecuencia", 18]],
        obligs.map(o => [
          [o.aspecto    || "—", undefined], [o.obligacion  || "—", undefined],
          [o.normativa  || "—", undefined], [o.frecuencia  || "—", undefined],
        ])
      ));
    }

    // ── 7. Plan de acción ─────────────────────────────────────────
    ch.push(h1("8. Plan de Acción para Aspectos Significativos"));
    const conPlanW = lista.filter(a => a.plan_accion?.accion);
    if (!conPlanW.length) {
      ch.push(ln("Sin planes de acción registrados. Use el botón 📋 en cada aspecto significativo para cargar un plan."));
    } else {
      ch.push(tblW(
        [["Aspecto", 22], ["Nivel", 11], ["Acción", 27], ["Responsable", 13], ["Plazo", 9], ["Estado", 10], ["Evidencia", 8]],
        conPlanW.map(a => {
          const { nivel } = calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi);
          const pa = a.plan_accion;
          const PA_SH = { Pendiente:"FFEEBB", "En curso":"DBEAFE", Completado:"DCFCE7", Verificado:"EDE9FE" };
          return [
            [a.aspecto || "—", undefined], [nivel, shNivel(nivel)],
            [pa.accion || "—", undefined], [pa.responsable || "—", undefined],
            [pa.plazo || "—", undefined],
            [pa.estado || "—", PA_SH[pa.estado] || undefined],
            [pa.evidencia || "—", undefined],
          ];
        })
      ));
    }

    // ── Firma ─────────────────────────────────────────────────────
    ch.push(ln(""));
    ch.push(ln(""));
    ch.push(new Paragraph({ children: [new TextRun({ text: "Consultor responsable: ______________________________", bold: true })], spacing: { before: 400, after: 100 } }));
    ch.push(ln("Firma: ____________________________        Fecha: _______________"));
    ch.push(ln(""));
    ch.push(new Paragraph({ children: [new TextRun({ text: "Generado por ALQOS™ · Sistema de Gestión Ambiental", italic: true, color: GRIS_W, size: 18 })] }));

    const doc  = new Document({ sections: [{ children: ch }] });
    const blob = await Packer.toBlob(doc);
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement("a");
    a.href     = url;
    a.download = `ALQOS_InformeAmbiental_${(empresa?.nombre || "empresa").replace(/\s+/g, "_")}_${new Date().getFullYear()}.docx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // ── NAV ──
  const Nav = ({ titulo, onBack, extra }) => (
    <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100, marginBottom:"1.5rem" }}>
      <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
        <button onClick={onBack} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
        <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>{titulo}</span>
        {syncing && <span style={{ fontSize:"10px", color:"#86efac" }}>🔄</span>}
      </div>
      {extra}
    </div>
  );

  // ── FORM NUEVA EMPRESA ──
  if (vista === "nueva_empresa") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Nav titulo={editandoEmpresa ? "Editar Empresa" : "Nueva Empresa Cliente"} onBack={() => { setEditandoEmpresa(null); setFormEmpresa({ rubro:"Gráfica / Imprenta" }); setVista("dashboard"); }} />
      <div style={{ padding:"0 1.5rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={card}>
          {[
            { k:"nombre",    label:"Razón social / Nombre" },
            { k:"cuit",      label:"CUIT" },
            { k:"rubro",     label:"Rubro", select:rubros },
            { k:"direccion", label:"Dirección" },
            { k:"localidad", label:"Localidad" },
            { k:"municipio", label:"Municipio / Partido" },
            { k:"provincia", label:"Provincia", select:["Buenos Aires","CABA","Córdoba","Santa Fe","Otro"] },
            { k:"empleados", label:"Cantidad de empleados" },
            { k:"art",       label:"ART contratada" },
            { k:"contacto",  label:"Contacto (nombre y cargo)" },
            { k:"telefono",  label:"Teléfono" },
            { k:"email",     label:"Email" },
            { k:"observaciones", label:"Observaciones iniciales", multi:true },
          ].map(({ k, label, select, multi }) => (
            <div key={k}>
              <span style={lbl}>{label}</span>
              {select
                ? <select value={formEmpresa[k]||""} onChange={e=>setFormEmpresa(f=>({...f,[k]:e.target.value}))} style={inp}>
                    <option value="">Seleccionar...</option>
                    {select.map(o=><option key={o}>{o}</option>)}
                  </select>
                : multi
                  ? <textarea rows={2} value={formEmpresa[k]||""} onChange={e=>setFormEmpresa(f=>({...f,[k]:e.target.value}))} style={{...inp,resize:"none"}}/>
                  : <input type="text" value={formEmpresa[k]||""} onChange={e=>setFormEmpresa(f=>({...f,[k]:e.target.value}))} style={inp}/>
              }
            </div>
          ))}
          {/* ── SITIOS ── */}
          <div style={{ marginTop:"20px", paddingTop:"16px", borderTop:`1px solid ${borde}` }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"10px" }}>
              <span style={{ fontSize:"12px", color:subtexto, fontWeight:"600" }}>📍 Sitios / Plantas</span>
              {(formEmpresa.sitios||[]).length < 5 && (
                <button type="button" onClick={() => setFormEmpresa(f => ({ ...f, sitios:[...(f.sitios||[]), {nombre:"", municipio:"", provincia:"Buenos Aires"}] }))}
                  style={{ padding:"4px 12px", background:"#7B5BF222", border:"1px solid #7B5BF2", borderRadius:"6px", fontSize:"11px", fontWeight:"600", color:"#7B5BF2", cursor:"pointer" }}>
                  + Agregar sitio
                </button>
              )}
            </div>
            {(formEmpresa.sitios||[]).length === 0 && (
              <p style={{ fontSize:"11px", color:subtexto, fontStyle:"italic" }}>Sin sitios adicionales. La empresa opera en la ubicación principal.</p>
            )}
            {(formEmpresa.sitios||[]).map((sitio, idx) => (
              <div key={idx} style={{ background:oscuro?"#091840":"#f8f7ff", borderRadius:"10px", padding:"12px", marginBottom:"8px", border:`1px solid ${borde}` }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"8px" }}>
                  <span style={{ fontSize:"11px", fontWeight:"700", color:"#7B5BF2" }}>Sitio {idx + 1}</span>
                  <button type="button" onClick={() => setFormEmpresa(f => ({ ...f, sitios:(f.sitios||[]).filter((_,i) => i !== idx) }))}
                    style={{ background:"none", border:"none", cursor:"pointer", fontSize:"14px", color:"#e63946" }}>✕</button>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"8px" }}>
                  <div>
                    <span style={{ fontSize:"11px", color:subtexto, fontWeight:"600" }}>Nombre del sitio</span>
                    <input value={sitio.nombre||""} placeholder="Ej: Planta Don Torcuato"
                      onChange={e => setFormEmpresa(f => ({ ...f, sitios:(f.sitios||[]).map((s,i) => i===idx ? {...s, nombre:e.target.value} : s) }))}
                      style={{...inp, marginTop:"3px"}} />
                  </div>
                  <div>
                    <span style={{ fontSize:"11px", color:subtexto, fontWeight:"600" }}>Municipio / Partido</span>
                    <input value={sitio.municipio||""} placeholder="Ej: Tigre"
                      onChange={e => setFormEmpresa(f => ({ ...f, sitios:(f.sitios||[]).map((s,i) => i===idx ? {...s, municipio:e.target.value} : s) }))}
                      style={{...inp, marginTop:"3px"}} />
                  </div>
                  <div>
                    <span style={{ fontSize:"11px", color:subtexto, fontWeight:"600" }}>Provincia</span>
                    <select value={sitio.provincia||"Buenos Aires"}
                      onChange={e => setFormEmpresa(f => ({ ...f, sitios:(f.sitios||[]).map((s,i) => i===idx ? {...s, provincia:e.target.value} : s) }))}
                      style={{...inp, marginTop:"3px"}}>
                      {["Buenos Aires","CABA","Córdoba","Santa Fe","Mendoza","Tucumán","Salta","Otro"].map(p => <option key={p}>{p}</option>)}
                    </select>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop:"16px" }}>
            <span style={{ fontSize:"12px", color:subtexto, fontWeight:"600", display:"block", marginBottom:"8px" }}>Normativas aplicables</span>
            <div style={{ display:"flex", flexWrap:"wrap", gap:"6px" }}>
              {normativas.map(n => (
                <button key={n.key} onClick={() => setFormEmpresa(f => ({ ...f, [n.key]: !f[n.key] }))}
                  style={{ padding:"5px 10px", borderRadius:"8px", fontSize:"10px", cursor:"pointer", fontWeight:"600", border:formEmpresa[n.key]?"2px solid #7B5BF2":"1px solid "+borde, background:formEmpresa[n.key]?"rgba(123,91,242,.15)":cardBg, color:formEmpresa[n.key]?"#7B5BF2":subtexto }}>
                  {n.label}
                </button>
              ))}
            </div>
          </div>
          <div style={{ marginTop:"16px" }}>
            <span style={{ fontSize:"12px", color:subtexto, fontWeight:"600", display:"block", marginBottom:"8px" }}>⚠️ Aspectos de riesgo (marcá lo que aplique)</span>
            <div style={{ display:"flex", flexWrap:"wrap", gap:"6px" }}>
              {ASPECTOS_RIESGO.map(a => {
                const activo = !!(formEmpresa.aspectosRiesgo || {})[a.key];
                return (
                  <button key={a.key} type="button"
                    onClick={() => setFormEmpresa(f => ({ ...f, aspectosRiesgo: { ...(f.aspectosRiesgo||{}), [a.key]: !activo } }))}
                    style={{ padding:"6px 12px", borderRadius:"20px", fontSize:"11px", cursor:"pointer", fontWeight:"600",
                      border:activo?"2px solid #7B5BF2":`1px solid ${borde}`,
                      background:activo?"rgba(123,91,242,.12)":cardBg,
                      color:activo?"#7B5BF2":subtexto }}>
                    {a.label}
                  </button>
                );
              })}
            </div>
          </div>
          <button onClick={() => {
            if (editandoEmpresa) {
              guardarEmpresas(empresas.map(e => e.id === editandoEmpresa ? { ...e, ...formEmpresa } : e));
              setEditandoEmpresa(null);
            } else {
              const orgIdAuto = (usuario?.rol !== "Administrador" && orgIdsUsuario?.length === 1) ? orgIdsUsuario[0] : null;
              const nueva = { ...formEmpresa, id:Math.floor(Date.now()), codigo:generarCod("CLI",empresas), creadoPor:usuario?.nombre||"Sistema", fechaAlta:fechaHoy(), organizacion_id:orgIdAuto };
              guardarEmpresas([...empresas, nueva]);
            }
            setFormEmpresa({ rubro:"Gráfica / Imprenta" });
            setVista("dashboard");
          }} style={{ width:"100%", padding:"13px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"10px", fontSize:"14px", fontWeight:"600", cursor:"pointer", marginTop:"1.5rem" }}>
            {editandoEmpresa ? "Guardar cambios" : "Agregar Empresa"}
          </button>
        </div>
      </div>
    </div>
  );

  // ── FICHA EMPRESA ──
  if (vista === "empresa" && empresaSel) {
    const visitasEmp = visitasEmpresa(empresaSel.id).sort((a,b) => new Date(b.fecha)-new Date(a.fecha));
    const ultimaVisita = visitasEmp[0];
    const puntajeUltima = ultimaVisita ? puntajeVisita(ultimaVisita.id) : null;
    const normAplicables = normativas.filter(n => empresaSel[n.key]);

    return (
      <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
        <Nav titulo={empresaSel.nombre} onBack={() => { setEmpresaSel(null); setVista("dashboard"); }}
          extra={
            <button onClick={() => {
              setFormVisita({ fecha:fechaHoy(), estado:"planificada", empresaId:empresaSel.id });
              setVista("nueva_visita");
            }} style={{ padding:"7px 14px", background:"#2A7FFF", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>
              + Nueva visita
            </button>
          }
        />
        <div style={{ padding:"0 1.5rem 2rem", maxWidth:"800px", margin:"0 auto" }}>

          {/* KPIs empresa */}
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
            {[
              ["Visitas totales", visitasEmp.length, "#7B5BF2"],
              ["Último puntaje", puntajeUltima !== null ? puntajeUltima+"%" : "—", puntajeUltima>=80?"#22c55e":puntajeUltima>=60?"#f59e0b":"#e63946"],
              ["Hallazgos críticos", hallazgos.filter(h=>h.empresaId===empresaSel.id&&h.estado==="critico").length, "#e63946"],
              ["Normativas", normAplicables.length, "#3b82f6"],
            ].map(([lab,val,col]) => (
              <div key={lab} style={{ background:cardBg, borderRadius:"12px", padding:"1rem", border:`1px solid ${borde}`, textAlign:"center" }}>
                <p style={{ fontSize:"20px", fontWeight:"700", color:col, margin:0 }}>{val}</p>
                <p style={{ fontSize:"10px", color:subtexto, margin:"4px 0 0", lineHeight:"1.3" }}>{lab}</p>
              </div>
            ))}
          </div>

          {/* Tabs */}
          <div style={{ display:"flex", gap:"6px", marginBottom:"1rem", overflowX:"auto", WebkitOverflowScrolling:"touch", paddingBottom:"4px" }}>
            {[["visitas","📋 Visitas"],["perfil","🏭 Perfil"],["normativas","📜 Normativas"],["hallazgos","🚨 Hallazgos"],["normaria","🤖 Análisis Legal"],["aspectos","🌿 Aspectos Amb."],["programa","📅 Prog. Anual"],["objetivos","🎯 Objetivos"]]
              .filter(([key]) => usuario?.tabsConsultorHS?.[key] ?? true)
              .map(([t,l]) => (
              <button key={t} onClick={()=>setTabEmpresa(t)}
                style={{ padding:"6px 14px", borderRadius:"20px", fontSize:"11px", cursor:"pointer", fontWeight:"600", border:tabEmpresa===t?"2px solid #7B5BF2":`1px solid ${borde}`, background:tabEmpresa===t?"rgba(123,91,242,.1)":cardBg, color:tabEmpresa===t?"#7B5BF2":subtexto }}>
                {l}
              </button>
            ))}
          </div>

          {/* Tab visitas */}
          {tabEmpresa === "visitas" && (
            visitasEmp.length === 0
              ? <div style={{ textAlign:"center", padding:"3rem" }}><p style={{ fontSize:"32px" }}>📋</p><p style={{ color:subtexto, marginTop:"8px" }}>Sin visitas registradas</p></div>
              : visitasEmp.map(v => {
                  const pts = puntajeVisita(v.id);
                  const hvCount = hallazgosVisita(v.id).length;
                  return (
                    <div key={v.id} onClick={() => { setVisitaSel(v); setCheckItems(v.checkItems||{}); setVista("visita"); }}
                      style={{ ...card, cursor:"pointer" }}
                      onMouseEnter={e=>e.currentTarget.style.boxShadow="0 4px 16px rgba(123,91,242,0.15)"}
                      onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                        <div>
                          <span style={{ fontWeight:"700", color:texto, fontSize:"13px" }}>{v.codigo}</span>
                          <span style={{ marginLeft:"8px", fontSize:"11px", color:estadosVisita[v.estado]?.color, fontWeight:"600" }}>{estadosVisita[v.estado]?.label}</span>
                          <p style={{ fontSize:"12px", color:subtexto, marginTop:"3px" }}>📅 {v.fecha} · 🔍 {hvCount} hallazgos · {v.objetivo?.slice(0,50)||"Sin objetivo"}</p>
                        </div>
                        {pts !== null && (
                          <div style={{ textAlign:"center", background:pts>=80?"#dcfce7":pts>=60?"#fef3c7":"#fee2e2", borderRadius:"10px", padding:"8px 14px" }}>
                            <p style={{ fontSize:"18px", fontWeight:"700", color:pts>=80?"#16a34a":pts>=60?"#d97706":"#dc2626", margin:0 }}>{pts}%</p>
                            <p style={{ fontSize:"9px", color:subtexto, margin:0 }}>cumplimiento</p>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
          )}

          {/* Tab perfil */}
          {tabEmpresa === "perfil" && (
            <div style={card}>
              {[["Código",empresaSel.codigo],["CUIT",empresaSel.cuit],["Rubro",empresaSel.rubro],["Dirección",empresaSel.direccion],["Localidad",empresaSel.localidad],["Provincia",empresaSel.provincia],["Empleados",empresaSel.empleados],["ART",empresaSel.art],["Contacto",empresaSel.contacto],["Teléfono",empresaSel.telefono],["Email",empresaSel.email],["Fecha alta",empresaSel.fechaAlta]].map(([k,v]) => v && (
                <div key={k} style={{ display:"flex", justifyContent:"space-between", fontSize:"13px", padding:"5px 0", borderBottom:`0.5px solid ${borde}` }}>
                  <span style={{ color:subtexto }}>{k}</span>
                  <span style={{ color:texto, fontWeight:"500" }}>{v}</span>
                </div>
              ))}
              {empresaSel.sitios && empresaSel.sitios.length > 0 && (
                <div style={{ marginTop:"10px" }}>
                  <p style={{ fontSize:"12px", fontWeight:"700", color:subtexto, margin:"0 0 6px" }}>Sitios</p>
                  {empresaSel.sitios.map((s, idx) => (
                    <div key={idx} style={{ display:"flex", justifyContent:"space-between", fontSize:"13px", padding:"5px 0", borderBottom:`0.5px solid ${borde}` }}>
                      <span style={{ color:subtexto }}>{s.nombre}</span>
                      <span style={{ color:texto, fontWeight:"500" }}>{s.municipio}, {s.provincia}</span>
                    </div>
                  ))}
                </div>
              )}
              {empresaSel.observaciones && <p style={{ fontSize:"12px", color:subtexto, marginTop:"10px" }}>{empresaSel.observaciones}</p>}
            </div>
          )}

          {/* Tab análisis legal ARIA */}
          {tabEmpresa === "normaria" && (() => { if (normativaHistorial.length === 0) { cargarHistorialNormativa(empresaSel.id); contarUsoAriaMes(empresaSel.id).then(setUsoAriaMes); } return null; })()}
          {tabEmpresa === "normaria" && (
            <div>
              <div style={{ ...card, border:"1.5px solid #7B5BF2" }}>
                <p style={{ fontSize:"13px", fontWeight:"700", color:"#7B5BF2", margin:"0 0 6px" }}>🤖 Análisis normativo con búsqueda web</p>
                <span style={{ display:"inline-block", fontSize:"11px", fontWeight:"700", color:"#7B5BF2", background:"#f5f3ff", border:"1px solid #ddd6fe", borderRadius:"20px", padding:"3px 10px", marginBottom:"8px" }}>
                  🤖 {usoAriaMes}/{(empresaSel.limite_mensual_aria ?? 5) === -1 ? "∞" : (empresaSel.limite_mensual_aria ?? 5)} este mes
                </span>
                <p style={{ fontSize:"12px", color:subtexto, margin:"0 0 12px" }}>ARIA busca en InfoLEG, Boletín Oficial, SRT y sitios oficiales la normativa nacional, provincial ({empresaSel.provincia||"—"}) y municipal ({empresaSel.municipio||empresaSel.localidad||"—"}) aplicable, incluyendo actualizaciones de los últimos 12 meses.</p>
                <button onClick={() => analizarNormativa(empresaSel)} disabled={normativaCargando}
                  style={{ width:"100%", padding:"11px", background:normativaCargando?"#9ca3af":"#7B5BF2", color:"white", border:"none", borderRadius:"10px", cursor:normativaCargando?"not-allowed":"pointer", fontSize:"13px", fontWeight:"600" }}>
                  {normativaCargando?"🔍 Buscando en fuentes oficiales...":"🔍 Analizar marco normativo"}
                </button>
                <button onClick={() => generarMatrizDesdeBase(empresaSel)}
                  style={{ width:"100%", marginTop:"8px", padding:"9px", background:"none", color:"#7B5BF2", border:"1.5px solid #7B5BF2", borderRadius:"10px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>
                  📋 Matriz desde base
                </button>
              </div>

              {normasBaseVerif.length > 0 && (
                <div style={card}>
                  <p style={{ fontSize:"12px", fontWeight:"700", color:"#09184D", margin:"0 0 4px", textTransform:"uppercase", letterSpacing:".1em", borderBottom:"2px solid #1C3FAA", paddingBottom:"6px" }}>
                    📖 Normas de la base · {normasBaseVerif.length}
                  </p>
                  <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 12px" }}>Verificá acá la vigencia de cada norma para que deje de figurar como pendiente en el reporte mensual.</p>
                  {normasBaseVerif.map(n => {
                    const haceSeisMeses = new Date();
                    haceSeisMeses.setMonth(haceSeisMeses.getMonth() - 6);
                    const verificadaAlDia = n.ultima_verificacion && new Date(n.ultima_verificacion) >= haceSeisMeses;
                    return (
                      <div key={n.id} style={{ display:"flex", gap:"10px", alignItems:"flex-start", padding:"7px 0", borderBottom:`0.5px solid ${borde}` }}>
                        <div style={{ flex:1 }}>
                          <p style={{ fontSize:"12px", fontWeight:"700", color:"#1C3FAA", margin:"0 0 1px" }}>{n.codigo}</p>
                          <p style={{ fontSize:"11px", color:subtexto, margin:0 }}>{(n.descripcion||"").slice(0,90)}{(n.descripcion||"").length>90?"...":""} · {n.jurisdiccion}</p>
                        </div>
                        {verificadaAlDia ? (
                          <span style={{ fontSize:"10px", fontWeight:"700", color:"#16a34a", background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:"6px", padding:"4px 8px", flexShrink:0, whiteSpace:"nowrap" }}>
                            ✓ Verificada el {new Date(n.ultima_verificacion).toLocaleDateString("es-AR")}
                          </span>
                        ) : (
                          <button onClick={() => marcarNormaVerificada(n.id)} disabled={normaVerificando===n.id}
                            style={{ fontSize:"10px", fontWeight:"700", color:"white", background:normaVerificando===n.id?"#9ca3af":"#7B5BF2", border:"none", borderRadius:"6px", padding:"5px 9px", cursor:normaVerificando===n.id?"not-allowed":"pointer", flexShrink:0, whiteSpace:"nowrap" }}>
                            {normaVerificando===n.id ? "..." : "✓ Marcar como verificada"}
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {usuario?.rol === "Administrador" && (
                <div style={{ ...card, padding:"10px 14px", display:"flex", alignItems:"center", gap:"8px" }}>
                  <span style={{ fontSize:"11px", color:subtexto }}>Límite mensual ARIA para {empresaSel.nombre} (admin):</span>
                  <select value={empresaSel.limite_mensual_aria ?? 5}
                    onChange={e => {
                      const nuevoLimite = parseInt(e.target.value);
                      const empAct = empresas.map(emp => emp.id===empresaSel.id ? { ...emp, limite_mensual_aria:nuevoLimite } : emp);
                      guardarEmpresas(empAct);
                      setEmpresaSel(prev => ({ ...prev, limite_mensual_aria:nuevoLimite }));
                    }}
                    style={{ fontSize:"11px", padding:"3px 6px", borderRadius:"6px", border:"1px solid " + borde, background:cardBg, color:texto }}>
                    <option value={3}>3/mes</option>
                    <option value={5}>5/mes</option>
                    <option value={10}>10/mes</option>
                    <option value={20}>20/mes</option>
                    <option value={-1}>Ilimitado</option>
                  </select>
                </div>
              )}

              {normativaAria && (() => {
                let data = null;
                try { data = JSON.parse(normativaAria); } catch {}
                if (!data) return (
                  <div style={card}>
                    <pre style={{ fontSize:"12px", color:texto, lineHeight:"1.7", whiteSpace:"pre-wrap", fontFamily:"sans-serif", margin:0 }}>{normativaAria}</pre>
                  </div>
                );


                
                return (
                  <div id="normativa-pdf">
                    {/* Header informe */}
                    <div style={{ background:"linear-gradient(135deg,#09184D,#1C3FAA)", borderRadius:"14px", padding:"1.5rem", marginBottom:"16px", color:"white" }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                        <div>
                          <p style={{ fontSize:"10px", letterSpacing:".2em", opacity:.6, margin:"0 0 4px", textTransform:"uppercase" }}>ALQOS™ — Análisis Normativo</p>
                          <h2 style={{ fontSize:"18px", fontWeight:"800", margin:"0 0 4px" }}>{data.empresa}</h2>
                          <p style={{ fontSize:"12px", opacity:.7, margin:0 }}>{empresaSel.rubro} · {empresaSel.municipio||empresaSel.localidad}, {empresaSel.provincia}</p>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          <p style={{ fontSize:"10px", opacity:.6, margin:"0 0 4px" }}>{data.fecha}</p>
                          <div style={{ display:"flex", gap:"6px" }}>
                            <button onClick={() => {
                              const el = document.getElementById("normativa-pdf");
                              const ventana = window.open("", "_blank");
                              ventana.document.write(`<!DOCTYPE html><html><head><title>Análisis Normativo - ${empresaSel.nombre}</title>
                                <style>body{font-family:sans-serif;padding:20px;color:#2F3E2E;} *{box-sizing:border-box;}</style>
                              </head><body>${el.innerHTML}</body></html>`);
                              ventana.document.close();
                              ventana.focus();
                            }} style={{ padding:"6px 14px", background:"rgba(255,255,255,.15)", border:"1px solid rgba(255,255,255,.3)", borderRadius:"8px", color:"white", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                              🖨️ PDF
                            </button>
                            <button onClick={() => exportarMatrizExcel(data, empresaSel)} style={{ padding:"6px 14px", background:"#22c55e", border:"none", borderRadius:"8px", color:"white", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                              ⬇️ Excel
                            </button>
                          </div>
                        </div>
                      </div>
                      {data.resumen_ejecutivo && <p style={{ fontSize:"12px", opacity:.85, margin:"12px 0 0", lineHeight:"1.6", background:"rgba(255,255,255,.08)", borderRadius:"8px", padding:"10px" }}>{data.resumen_ejecutivo}</p>}
                    </div>

                    {/* Actualizaciones recientes */}
                    {data.actualizaciones_recientes?.length > 0 && (
                      <div style={{ background:"#fff7ed", border:"1.5px solid #f97316", borderRadius:"12px", padding:"14px 18px", marginBottom:"14px" }}>
                        <p style={{ fontSize:"12px", fontWeight:"700", color:"#ea580c", margin:"0 0 10px" }}>⚠️ Actualizaciones recientes</p>
                        {data.actualizaciones_recientes.map((a,i) => (
                          <div key={i} style={{ display:"flex", gap:"10px", alignItems:"flex-start", padding:"6px 0", borderBottom:"0.5px solid #fed7aa" }}>
                            <span style={{ background:a.impacto==="alto"?"#e63946":a.impacto==="medio"?"#f59e0b":"#22c55e", color:"white", borderRadius:"6px", padding:"2px 7px", fontSize:"9px", fontWeight:"700", flexShrink:0, marginTop:"2px" }}>{(a.impacto||"").toUpperCase()}</span>
                            <div>
                              <p style={{ fontSize:"12px", fontWeight:"600", color:"#1c1917", margin:"0 0 2px" }}>{a.norma}</p>
                              <p style={{ fontSize:"11px", color:"#78716c", margin:0 }}>{a.descripcion} {a.fecha && <span style={{ color:"#ea580c" }}>· {a.fecha}</span>}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Matriz legal */}
                    {matrizEstado?.length > 0 && (
                      <div style={card}>
                        <p style={{ fontSize:"12px", fontWeight:"700", color:"#09184D", margin:"0 0 4px", textTransform:"uppercase", letterSpacing:".1em", borderBottom:"2px solid #1C3FAA", paddingBottom:"6px" }}>
                          📋 Matriz de Requisitos Legales · {matrizEstado.length} requisitos
                        </p>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 12px" }}>Descargá el Excel para la versión completa con formato profesional. Vista previa:</p>
                        {(() => {
                          const aspectosFiltrados = [...new Set(matrizEstado.map(m => m.aspecto).filter(Boolean))];
                          return aspectosFiltrados.map(asp => (
                            <div key={asp} style={{ marginBottom:"14px" }}>
                              <p style={{ fontSize:"11px", fontWeight:"700", color:"#7B5BF2", textTransform:"uppercase", letterSpacing:".08em", margin:"0 0 6px", paddingBottom:"4px", borderBottom:"1px solid #e0e7ff" }}>{asp}</p>
                              {matrizEstado.filter(m => m.aspecto === asp).map((m, i) => (
                                <div key={i} style={{ padding:"7px 0", borderBottom:`0.5px solid ${borde}` }}>
                                <div style={{ display:"flex", gap:"10px", alignItems:"flex-start" }}>
                                  <span style={{ background:m.estado==="NC"?"#fee2e2":"#dcfce7", color:m.estado==="NC"?"#b91c1c":"#065f46", borderRadius:"6px", padding:"2px 8px", fontSize:"9px", fontWeight:"700", flexShrink:0, minWidth:"28px", textAlign:"center" }}>{m.estado||"C"}</span>
                                  <div style={{ flex:1 }}>
                                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                                      <p style={{ fontSize:"12px", fontWeight:"700", color:"#1C3FAA", margin:"0 0 1px" }}>{m.norma}</p>
                                      <span style={{ fontSize:"9px", color:subtexto, flexShrink:0, marginLeft:"8px" }}>{m.frecuencia}</span>
                                    </div>
                                    <p style={{ fontSize:"11px", color:texto, margin:"1px 0 2px", lineHeight:"1.4" }}>{m.requisito}</p>
                                    <div style={{ display:"flex", gap:"6px", flexWrap:"wrap", alignItems:"center" }}>
                                      <span style={{ fontSize:"9px", color:"#7B5BF2", background:"#f5f3ff", borderRadius:"4px", padding:"1px 5px" }}>{m.area_responsable}</span>
                                      <span style={{ fontSize:"9px", color:subtexto, background:"#f3f4f6", borderRadius:"4px", padding:"1px 5px" }}>{m.evidencia}</span>
                                      {m.link && <a href={m.link} target="_blank" rel="noreferrer" style={{ fontSize:"9px", color:"#2A7FFF", textDecoration:"none" }}>Ver norma ↗</a>}
                                      <button onClick={() => ncMatrizAbierto===m.norma ? setNcMatrizAbierto(null) : abrirFormNCMatriz(m)}
                                        style={{ fontSize:"9px", fontWeight:"700", color:"#e63946", background:"#fff5f5", border:"1px solid #fca5a5", borderRadius:"5px", padding:"2px 7px", cursor:"pointer", marginLeft:"auto" }}>
                                        {ncMatrizAbierto===m.norma ? "✕ Cerrar" : "🚨 Generar NC"}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                {ncMatrizAbierto===m.norma && (
                                  <div style={{ marginTop:"8px", marginLeft:"38px", background:oscuro?"#0a1f5c":"#fff5f5", border:"1px solid #fca5a5", borderRadius:"8px", padding:"10px 12px" }}>
                                    <div style={{ display:"flex", gap:"8px", marginBottom:"8px", flexWrap:"wrap" }}>
                                      <select value={ncMatrizForm.visitaId} onChange={e=>setNcMatrizForm(f=>({...f,visitaId:e.target.value}))}
                                        style={{ fontSize:"11px", padding:"4px 6px", borderRadius:"6px", border:"1px solid "+borde, background:cardBg, color:texto }}>
                                        <option value="">Sin visita (a nivel empresa)</option>
                                        {visitasEmpresa(empresaSel.id).map(v => <option key={v.id} value={v.id}>{v.codigo} — {v.fecha}</option>)}
                                      </select>
                                      <select value={ncMatrizForm.severidad} onChange={e=>setNcMatrizForm(f=>({...f,severidad:e.target.value}))}
                                        style={{ fontSize:"11px", padding:"4px 6px", borderRadius:"6px", border:"1px solid "+borde, background:cardBg, color:texto }}>
                                        <option value="critico">🚨 Crítico</option>
                                        <option value="mayor">⚠️ Mayor</option>
                                        <option value="menor">🔵 Menor</option>
                                      </select>
                                      <button onClick={() => ariaProponeObservacionMatriz(m)} disabled={ncMatrizCargando}
                                        style={{ fontSize:"11px", fontWeight:"600", color:"white", background:ncMatrizCargando?"#9ca3af":"#7B5BF2", border:"none", borderRadius:"6px", padding:"4px 10px", cursor:ncMatrizCargando?"not-allowed":"pointer" }}>
                                        {ncMatrizCargando ? "✍️ Redactando..." : "🤖 ARIA propone"}
                                      </button>
                                    </div>
                                    <textarea rows={3} placeholder="Observación del hallazgo..." value={ncMatrizForm.observacion}
                                      onChange={e=>setNcMatrizForm(f=>({...f,observacion:e.target.value}))}
                                      style={{ width:"100%", padding:"7px 9px", borderRadius:"6px", border:"1px solid "+borde, fontSize:"11px", resize:"none", background:cardBg, color:texto, boxSizing:"border-box" }}/>
                                    <button onClick={() => guardarNCDesdeMatriz(m)} disabled={!ncMatrizForm.observacion.trim()}
                                      style={{ marginTop:"8px", width:"100%", padding:"7px", background:!ncMatrizForm.observacion.trim()?"#9ca3af":"#e63946", color:"white", border:"none", borderRadius:"7px", cursor:!ncMatrizForm.observacion.trim()?"not-allowed":"pointer", fontSize:"12px", fontWeight:"600" }}>
                                      Guardar NC
                                    </button>
                                  </div>
                                )}
                                </div>
                              ))}
                            </div>
                          ));
                        })()}
                      </div>
                    )}

                    <p style={{ fontSize:"10px", color:subtexto, textAlign:"center", marginTop:"8px" }}>{guardandoAnalisis ? "Guardando..." : "✓ Guardado en historial · " + new Date().toLocaleDateString("es-AR")}</p>
                  </div>
                );
              })()}
              {normativaHistorial.length > 0 && (
                <div style={card}>
                  <p style={{ fontSize:"12px", fontWeight:"700", color:subtexto, margin:"0 0 10px", textTransform:"uppercase", letterSpacing:".1em" }}>Historial de análisis</p>
                  {normativaHistorial.map(h => (
                    <div key={h.id} style={{ padding:"8px 0", borderBottom:`0.5px solid ${borde}`, cursor:"pointer" }}
                      onClick={() => setNormativaAria(h.analisis)}>
                      <p style={{ fontSize:"12px", fontWeight:"600", color:texto, margin:"0 0 2px" }}>
                        {new Date(h.fecha_analisis).toLocaleDateString("es-AR")}
                      </p>
                      <p style={{ fontSize:"11px", color:subtexto, margin:0 }}>{h.analisis.slice(0,80)}...</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {tabEmpresa === "programa" && (() => { if (programaAnualLoadedFor !== empresaSel.id && !programaCargando) { cargarProgramaAnual(empresaSel.id); } return null; })()}
          {/* Tab programa anual */}
          {tabEmpresa === "programa" && (
            <div>
              <div style={{ ...card, border:"1.5px solid #22c55e" }}>
                <p style={{ fontSize:"13px", fontWeight:"700", color:"#16a34a", margin:"0 0 6px" }}>📅 Generador de Programa Anual H&S</p>
                <p style={{ fontSize:"12px", color:subtexto, margin:"0 0 12px" }}>ARIA genera el Programa Anual con formato ejecutivo: objetivos, cronograma mensual, responsables, indicadores, presupuesto y plan de acción para hallazgos críticos.</p>
                <button onClick={() => generarProgramaAnual(empresaSel)} disabled={programaCargando}
                  style={{ width:"100%", padding:"11px", background:programaCargando?"#9ca3af":"#22c55e", color:"white", border:"none", borderRadius:"10px", cursor:programaCargando?"not-allowed":"pointer", fontSize:"13px", fontWeight:"600" }}>
                  {programaCargando ? "⏳ Generando programa..." : "📅 Generar Programa Anual"}
                </button>
              </div>

              {programaAnualTexto && !programaAnualData && (
                <div style={card}>
                  <pre style={{ fontSize:"12px", color:texto, lineHeight:"1.7", whiteSpace:"pre-wrap", fontFamily:"sans-serif", margin:0 }}>{programaAnualTexto}</pre>
                </div>
              )}

              {programaAnualData && (
                <div id="programa-anual-pdf">
                  <div style={{ background:"linear-gradient(135deg,#09184D,#1C3FAA)", borderRadius:"14px", padding:"1.5rem", marginBottom:"16px", color:"white" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                      <div>
                        <p style={{ fontSize:"10px", letterSpacing:".2em", opacity:.6, margin:"0 0 4px", textTransform:"uppercase" }}>ALQOS™ — Programa Anual H&S</p>
                        <h2 style={{ fontSize:"18px", fontWeight:"800", margin:"0 0 4px" }}>{programaAnualData.empresa} · {programaAnualData.anio}</h2>
                        <p style={{ fontSize:"12px", opacity:.7, margin:0 }}>{empresaSel.rubro} · {empresaSel.municipio||empresaSel.localidad}, {empresaSel.provincia}</p>
                      </div>
                      <div style={{ display:"flex", gap:"6px" }}>
                        <button onClick={() => {
                          const el = document.getElementById("programa-anual-pdf");
                          const ventana = window.open("", "_blank");
                          ventana.document.write(`<!DOCTYPE html><html><head><title>Programa Anual H&S - ${empresaSel.nombre}</title>
                            <style>body{font-family:sans-serif;padding:20px;color:#2F3E2E;} table{width:100%;border-collapse:collapse;margin-bottom:16px;} td,th{border:1px solid #ddd;padding:6px;font-size:11px;text-align:left;} *{box-sizing:border-box;}</style>
                          </head><body>${el.innerHTML}</body></html>`);
                          ventana.document.close();
                          ventana.focus();
                          setTimeout(()=>ventana.print(), 400);
                        }} style={{ padding:"6px 14px", background:"rgba(255,255,255,.15)", border:"1px solid rgba(255,255,255,.3)", borderRadius:"8px", color:"white", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                          🖨️ PDF
                        </button>
                        <button onClick={() => exportarProgramaExcel(programaAnualData, empresaSel)} style={{ padding:"6px 14px", background:"#22c55e", border:"none", borderRadius:"8px", color:"white", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                          ⬇️ Excel
                        </button>
                        <button onClick={() => exportarProgramaWord(programaAnualData, empresaSel)} style={{ padding:"6px 14px", background:"#2A7FFF", border:"none", borderRadius:"8px", color:"white", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                          📄 Word
                        </button>
                      </div>
                    </div>
                  </div>

                  <div style={card}>
                    <p style={{ fontSize:"12px", fontWeight:"700", color:"#09184D", margin:"0 0 8px", textTransform:"uppercase", letterSpacing:".1em" }}>🎯 Objetivos generales</p>
                    {(programaAnualData.objetivos_generales||[]).map((o,i) => <p key={i} style={{ fontSize:"12px", color:texto, margin:"4px 0" }}>• {o}</p>)}
                    <p style={{ fontSize:"12px", fontWeight:"700", color:"#09184D", margin:"14px 0 8px", textTransform:"uppercase", letterSpacing:".1em" }}>🎯 Objetivos específicos</p>
                    {(programaAnualData.objetivos_especificos||[]).map((o,i) => <p key={i} style={{ fontSize:"12px", color:texto, margin:"4px 0" }}>• {o}</p>)}
                  </div>

                  <div style={card}>
                    <p style={{ fontSize:"12px", fontWeight:"700", color:"#09184D", margin:"0 0 10px", textTransform:"uppercase", letterSpacing:".1em" }}>📅 Cronograma mensual</p>
                    <div style={{ overflowX:"auto" }}>
                      <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"11px" }}>
                        <thead><tr>{["Mes","Actividad","Tipo","Responsable"].map(h => <th key={h} style={{ textAlign:"left", padding:"6px 8px", borderBottom:`2px solid ${borde}`, color:subtexto, fontWeight:700 }}>{h}</th>)}</tr></thead>
                        <tbody>
                          {(programaAnualData.cronograma||[]).map((c,i) => (
                            <tr key={i} style={{ borderBottom:`0.5px solid ${borde}` }}>
                              <td style={{ padding:"6px 8px", fontWeight:700, color:"#1C3FAA" }}>{c.mes}</td>
                              <td style={{ padding:"6px 8px", color:texto }}>{c.actividad}</td>
                              <td style={{ padding:"6px 8px", color:subtexto }}>{c.tipo}</td>
                              <td style={{ padding:"6px 8px", color:subtexto }}>{c.responsable}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div style={card}>
                    <p style={{ fontSize:"12px", fontWeight:"700", color:"#09184D", margin:"0 0 10px", textTransform:"uppercase", letterSpacing:".1em" }}>👥 Responsables por área</p>
                    <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"11px" }}>
                      <thead><tr>{["Área","Responsable","Función"].map(h => <th key={h} style={{ textAlign:"left", padding:"6px 8px", borderBottom:`2px solid ${borde}`, color:subtexto, fontWeight:700 }}>{h}</th>)}</tr></thead>
                      <tbody>
                        {(programaAnualData.responsables||[]).map((r,i) => (
                          <tr key={i} style={{ borderBottom:`0.5px solid ${borde}` }}>
                            <td style={{ padding:"6px 8px", fontWeight:700, color:"#1C3FAA" }}>{r.area}</td>
                            <td style={{ padding:"6px 8px", color:texto }}>{r.responsable}</td>
                            <td style={{ padding:"6px 8px", color:subtexto }}>{r.funcion}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div style={card}>
                    <p style={{ fontSize:"12px", fontWeight:"700", color:"#09184D", margin:"0 0 10px", textTransform:"uppercase", letterSpacing:".1em" }}>📊 Indicadores de seguimiento</p>
                    <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"11px" }}>
                      <thead><tr>{["Indicador","Meta","Frecuencia"].map(h => <th key={h} style={{ textAlign:"left", padding:"6px 8px", borderBottom:`2px solid ${borde}`, color:subtexto, fontWeight:700 }}>{h}</th>)}</tr></thead>
                      <tbody>
                        {(programaAnualData.indicadores||[]).map((ind,i) => (
                          <tr key={i} style={{ borderBottom:`0.5px solid ${borde}` }}>
                            <td style={{ padding:"6px 8px", fontWeight:700, color:"#1C3FAA" }}>{ind.indicador}</td>
                            <td style={{ padding:"6px 8px", color:texto }}>{ind.meta}</td>
                            <td style={{ padding:"6px 8px", color:subtexto }}>{ind.frecuencia}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div style={card}>
                    <p style={{ fontSize:"12px", fontWeight:"700", color:"#09184D", margin:"0 0 10px", textTransform:"uppercase", letterSpacing:".1em" }}>💰 Presupuesto estimado</p>
                    <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"11px" }}>
                      <thead><tr>{["Ítem","Rango estimado (ARS)","Categoría"].map(h => <th key={h} style={{ textAlign:"left", padding:"6px 8px", borderBottom:`2px solid ${borde}`, color:subtexto, fontWeight:700 }}>{h}</th>)}</tr></thead>
                      <tbody>
                        {(programaAnualData.presupuesto||[]).map((p,i) => (
                          <tr key={i} style={{ borderBottom:`0.5px solid ${borde}` }}>
                            <td style={{ padding:"6px 8px", fontWeight:700, color:"#1C3FAA" }}>{p.item}</td>
                            <td style={{ padding:"6px 8px", color:texto }}>{p.rango_estimado_ars}</td>
                            <td style={{ padding:"6px 8px", color:subtexto }}>{p.categoria}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div style={card}>
                    <p style={{ fontSize:"12px", fontWeight:"700", color:"#e63946", margin:"0 0 10px", textTransform:"uppercase", letterSpacing:".1em" }}>🚨 Plan de acción — hallazgos críticos</p>
                    {(programaAnualData.plan_accion_criticos||[]).length === 0
                      ? <p style={{ fontSize:"12px", color:subtexto }}>✅ Sin hallazgos críticos pendientes.</p>
                      : (
                        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"11px" }}>
                          <thead><tr>{["Hallazgo","Acción correctiva","Plazo","Responsable"].map(h => <th key={h} style={{ textAlign:"left", padding:"6px 8px", borderBottom:`2px solid ${borde}`, color:subtexto, fontWeight:700 }}>{h}</th>)}</tr></thead>
                          <tbody>
                            {programaAnualData.plan_accion_criticos.map((p,i) => (
                              <tr key={i} style={{ borderBottom:`0.5px solid ${borde}` }}>
                                <td style={{ padding:"6px 8px", fontWeight:700, color:"#e63946" }}>{p.hallazgo}</td>
                                <td style={{ padding:"6px 8px", color:texto }}>{p.accion_correctiva}</td>
                                <td style={{ padding:"6px 8px", color:subtexto }}>{p.plazo}</td>
                                <td style={{ padding:"6px 8px", color:subtexto }}>{p.responsable}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )
                    }
                  </div>

                  <p style={{ fontSize:"10px", color:subtexto, textAlign:"center", marginTop:"8px" }}>Generado el {new Date().toLocaleDateString("es-AR")} · Firma Responsable H&S: ______________________ · Aprobado por Dirección: ______________________</p>
                </div>
              )}
            </div>
          )}

          {/* Tab objetivos */}
          {tabEmpresa === "objetivos" && (() => {
            const objsEmp = objetivos.filter(o => o.empresa_id === empresaSel.id);
            const sigAspEmp = aspectos.filter(a => a.empresa_id === empresaSel.id &&
              calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi).es_significativo
            );
            const ESTADOS_OBJ = {
              Planificado: { c:"#6b7280", bg:"#f1f5f9" },
              "En curso":  { c:"#2A7FFF", bg:"#dbeafe" },
              Alcanzado:   { c:"#16a34a", bg:"#dcfce7" },
              Abandonado:  { c:"#dc2626", bg:"#fee2e2" },
            };
            const OBJ_FORM_VACIO = {
              titulo:"", descripcion:"", aspecto_id:"", indicador:"", unidad:"",
              valor_base:"", valor_base_fecha:"", meta:"", responsable:"",
              recursos:"", plazo:"", estado:"Planificado",
            };
            const abrirNuevo  = () => { setObjForm(OBJ_FORM_VACIO); setObjEditId(null); setObjFormAbierto(true); };
            const abrirEditar = (o) => { setObjForm({...o}); setObjEditId(o.id); setObjFormAbierto(true); };
            const guardarForm = () => {
              if (!objForm.titulo?.trim()) return;
              if (objEditId) {
                guardarObjetivos(objetivos.map(o => o.id === objEditId
                  ? { ...objForm, id:objEditId, empresa_id:empresaSel.id, fecha_actualizacion:fechaHoy() }
                  : o));
              } else {
                guardarObjetivos([...objetivos, { ...objForm, id:Math.floor(Date.now()), empresa_id:empresaSel.id,
                  mediciones:[], fecha_creacion:fechaHoy(), fecha_actualizacion:fechaHoy() }]);
              }
              setObjFormAbierto(false); setObjEditId(null);
            };
            const agregarMedicion = (objId) => {
              if (!objMedForm.fecha || objMedForm.valor === "") return;
              guardarObjetivos(objetivos.map(o => o.id === objId
                ? { ...o, mediciones:[...(o.mediciones||[]), { ...objMedForm, valor:Number(objMedForm.valor) }]
                      .sort((a,b)=>a.fecha.localeCompare(b.fecha)), fecha_actualizacion:fechaHoy() }
                : o
              ));
              setObjMedAbierto(null); setObjMedForm({ fecha:"", valor:"", observaciones:"" });
            };
            return (
              <div>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"1rem" }}>
                  <div>
                    <p style={{ fontSize:"14px", fontWeight:"700", color:texto, margin:0 }}>🎯 Objetivos Ambientales</p>
                    <p style={{ fontSize:"11px", color:subtexto, margin:"2px 0 0" }}>ISO 14001 §6.2 · {objsEmp.length} registrados</p>
                  </div>
                  <button onClick={abrirNuevo}
                    style={{ padding:"7px 14px", background:"#16a34a", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>
                    + Nuevo objetivo
                  </button>
                </div>

                {objFormAbierto && (
                  <div style={{ ...card, border:"2px solid #16a34a", marginBottom:"1rem" }}>
                    <p style={{ fontSize:"13px", fontWeight:"700", color:"#16a34a", margin:"0 0 14px" }}>{objEditId ? "✏️ Editar objetivo" : "➕ Nuevo objetivo"}</p>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px 14px" }}>
                      <div style={{ gridColumn:"1/-1" }}>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Título *</p>
                        <input value={objForm.titulo||""} onChange={e=>setObjForm(f=>({...f,titulo:e.target.value}))}
                          placeholder="Ej: Reducir consumo de agua en proceso de impresión"
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px", boxSizing:"border-box" }} />
                      </div>
                      <div>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Aspecto significativo vinculado</p>
                        <select value={objForm.aspecto_id||""} onChange={e=>setObjForm(f=>({...f,aspecto_id:e.target.value}))}
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px" }}>
                          <option value="">— Sin vincular —</option>
                          {sigAspEmp.map(a => <option key={a.id} value={a.id}>{(a.aspecto||"").slice(0,50)}</option>)}
                        </select>
                      </div>
                      <div>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Estado</p>
                        <select value={objForm.estado||"Planificado"} onChange={e=>setObjForm(f=>({...f,estado:e.target.value}))}
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px" }}>
                          {["Planificado","En curso","Alcanzado","Abandonado"].map(s => <option key={s}>{s}</option>)}
                        </select>
                      </div>
                      <div>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Indicador</p>
                        <input value={objForm.indicador||""} onChange={e=>setObjForm(f=>({...f,indicador:e.target.value}))}
                          placeholder="Ej: Litros de agua por tonelada impresa"
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px", boxSizing:"border-box" }} />
                      </div>
                      <div>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Unidad</p>
                        <input value={objForm.unidad||""} onChange={e=>setObjForm(f=>({...f,unidad:e.target.value}))}
                          placeholder="L/t, kg, kWh, %..."
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px", boxSizing:"border-box" }} />
                      </div>
                      <div>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Valor base</p>
                        <input type="number" value={objForm.valor_base||""} onChange={e=>setObjForm(f=>({...f,valor_base:e.target.value}))}
                          placeholder="850"
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px", boxSizing:"border-box" }} />
                      </div>
                      <div>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Fecha base (mes/año)</p>
                        <input type="month" value={objForm.valor_base_fecha||""} onChange={e=>setObjForm(f=>({...f,valor_base_fecha:e.target.value}))}
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px", boxSizing:"border-box" }} />
                      </div>
                      <div>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Meta</p>
                        <input type="number" value={objForm.meta||""} onChange={e=>setObjForm(f=>({...f,meta:e.target.value}))}
                          placeholder="680"
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px", boxSizing:"border-box" }} />
                      </div>
                      <div>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Plazo (mes/año)</p>
                        <input type="month" value={objForm.plazo||""} onChange={e=>setObjForm(f=>({...f,plazo:e.target.value}))}
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px", boxSizing:"border-box" }} />
                      </div>
                      <div>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Responsable</p>
                        <input value={objForm.responsable||""} onChange={e=>setObjForm(f=>({...f,responsable:e.target.value}))}
                          placeholder="Jefe de Producción"
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px", boxSizing:"border-box" }} />
                      </div>
                      <div>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Recursos necesarios</p>
                        <input value={objForm.recursos||""} onChange={e=>setObjForm(f=>({...f,recursos:e.target.value}))}
                          placeholder="Caudalímetros, $15.000"
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px", boxSizing:"border-box" }} />
                      </div>
                      <div style={{ gridColumn:"1/-1" }}>
                        <p style={{ fontSize:"10px", color:subtexto, margin:"0 0 3px", fontWeight:"600" }}>Descripción / observaciones</p>
                        <textarea value={objForm.descripcion||""} onChange={e=>setObjForm(f=>({...f,descripcion:e.target.value}))}
                          rows={2} placeholder="Detalle adicional..."
                          style={{ width:"100%", padding:"7px 10px", borderRadius:"7px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"12px", resize:"vertical", boxSizing:"border-box" }} />
                      </div>
                    </div>
                    <div style={{ display:"flex", gap:"8px", marginTop:"14px" }}>
                      <button onClick={guardarForm}
                        style={{ padding:"8px 20px", background:"#16a34a", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>
                        💾 Guardar
                      </button>
                      <button onClick={() => { setObjFormAbierto(false); setObjEditId(null); }}
                        style={{ padding:"8px 14px", background:"transparent", color:subtexto, border:`1px solid ${borde}`, borderRadius:"8px", cursor:"pointer", fontSize:"12px" }}>
                        Cancelar
                      </button>
                    </div>
                  </div>
                )}

                {objsEmp.length === 0 && !objFormAbierto && (
                  <div style={{ ...card, textAlign:"center", padding:"2rem" }}>
                    <p style={{ fontSize:"32px", margin:"0 0 8px" }}>🎯</p>
                    <p style={{ fontSize:"13px", color:texto, fontWeight:"600", margin:"0 0 4px" }}>Sin objetivos registrados</p>
                    <p style={{ fontSize:"11px", color:subtexto, margin:0 }}>ISO 14001 §6.2 exige objetivos medibles vinculados a aspectos significativos.</p>
                  </div>
                )}

                {objsEmp.map(o => {
                  const asp = aspectos.find(a => a.id === o.aspecto_id);
                  const est = ESTADOS_OBJ[o.estado] || ESTADOS_OBJ.Planificado;
                  const meds = o.mediciones || [];
                  const ultimoVal = meds.length ? meds[meds.length-1].valor : null;
                  const vb = Number(o.valor_base); const mt = Number(o.meta);
                  const reducPct = vb && mt ? Math.round((1 - mt/vb)*100) : null;
                  const progPct = (vb && mt && ultimoVal !== null)
                    ? Math.min(100, Math.max(0, Math.round(Math.abs((ultimoVal-vb)/(mt-vb))*100))) : null;
                  const medAbierta = objMedAbierto === o.id;
                  return (
                    <div key={o.id} style={{ ...card, marginBottom:"12px" }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"10px" }}>
                        <div style={{ flex:1, marginRight:"10px" }}>
                          <div style={{ display:"flex", alignItems:"center", gap:"8px", flexWrap:"wrap", marginBottom:"4px" }}>
                            <span style={{ fontSize:"13px", fontWeight:"700", color:texto }}>{o.titulo}</span>
                            <span style={{ fontSize:"10px", fontWeight:"700", color:est.c, background:est.bg, borderRadius:"6px", padding:"2px 7px" }}>{o.estado}</span>
                          </div>
                          {asp && <span style={{ fontSize:"10px", color:"#7B5BF2", background:"#ede9fe", borderRadius:"5px", padding:"2px 7px" }}>🔗 {(asp.aspecto||"").slice(0,40)}</span>}
                        </div>
                        <div style={{ display:"flex", gap:"6px", flexShrink:0 }}>
                          <button onClick={() => abrirEditar(o)}
                            style={{ padding:"4px 10px", background:cardBg, border:`1px solid ${borde}`, borderRadius:"6px", cursor:"pointer", color:subtexto, fontSize:"11px" }}>✏️</button>
                          <button onClick={() => { if(window.confirm("¿Eliminar este objetivo?")) { guardarObjetivos(objetivos.filter(x => x.id !== o.id)); eliminarDato("alqos_consultor_objetivos", o.id); } }}
                            style={{ padding:"4px 10px", background:"#fee2e2", border:"1px solid #dc2626", borderRadius:"6px", cursor:"pointer", color:"#dc2626", fontSize:"11px" }}>🗑</button>
                        </div>
                      </div>
                      {o.indicador && (
                        <div style={{ marginBottom:"10px" }}>
                          <div style={{ display:"flex", justifyContent:"space-between", marginBottom:"4px" }}>
                            <span style={{ fontSize:"11px", color:subtexto }}>{o.indicador}{o.unidad ? ` (${o.unidad})` : ""}</span>
                            {reducPct !== null && <span style={{ fontSize:"10px", fontWeight:"700", color:"#16a34a" }}>Meta: -{reducPct}%</span>}
                          </div>
                          <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                            <span style={{ fontSize:"10px", color:subtexto, whiteSpace:"nowrap" }}>{vb||"—"}</span>
                            <div style={{ flex:1, height:"6px", background:oscuro?"#1e3a8a":"#e5e7eb", borderRadius:"3px", overflow:"hidden" }}>
                              {progPct !== null && <div style={{ height:"100%", width:`${progPct}%`, background:"#16a34a", borderRadius:"3px" }} />}
                            </div>
                            <span style={{ fontSize:"10px", fontWeight:"700", color:"#16a34a", whiteSpace:"nowrap" }}>
                              {ultimoVal !== null ? `${ultimoVal} → ` : ""}{mt||"—"}
                            </span>
                          </div>
                        </div>
                      )}
                      <div style={{ display:"flex", gap:"12px", flexWrap:"wrap", fontSize:"10px", color:subtexto, marginBottom:"10px" }}>
                        {o.responsable && <span>👤 {o.responsable}</span>}
                        {o.plazo && <span>📅 Plazo: {o.plazo}</span>}
                        {o.recursos && <span>🔧 {o.recursos}</span>}
                      </div>
                      {meds.length > 0 && (
                        <div style={{ background:oscuro?"#091840":"#f9fafb", borderRadius:"8px", padding:"8px 10px", marginBottom:"10px" }}>
                          <p style={{ fontSize:"9px", fontWeight:"700", color:subtexto, margin:"0 0 6px", textTransform:"uppercase" }}>Mediciones</p>
                          {meds.slice().reverse().map((m,i) => (
                            <div key={i} style={{ display:"flex", gap:"8px", alignItems:"center", fontSize:"10px", padding:"2px 0" }}>
                              <span style={{ color:subtexto, minWidth:"52px" }}>{m.fecha}</span>
                              <span style={{ fontWeight:"700", color:texto }}>{m.valor} {o.unidad}</span>
                              {m.observaciones && <span style={{ color:subtexto }}>· {m.observaciones}</span>}
                            </div>
                          ))}
                        </div>
                      )}
                      <button onClick={() => { setObjMedAbierto(medAbierta ? null : o.id); setObjMedForm({ fecha:"", valor:"", observaciones:"" }); }}
                        style={{ padding:"5px 12px", background:"#2A7FFF22", border:"1px solid #2A7FFF", borderRadius:"6px", cursor:"pointer", color:"#2A7FFF", fontSize:"10px", fontWeight:"600" }}>
                        {medAbierta ? "✕ Cancelar" : "📏 + Medición"}
                      </button>
                      {medAbierta && (
                        <div style={{ marginTop:"10px", display:"flex", gap:"8px", flexWrap:"wrap", alignItems:"flex-end" }}>
                          <div>
                            <p style={{ fontSize:"9px", color:subtexto, margin:"0 0 2px" }}>Mes/Año</p>
                            <input type="month" value={objMedForm.fecha} onChange={e=>setObjMedForm(f=>({...f,fecha:e.target.value}))}
                              style={{ padding:"5px 8px", borderRadius:"6px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"11px" }} />
                          </div>
                          <div>
                            <p style={{ fontSize:"9px", color:subtexto, margin:"0 0 2px" }}>Valor ({o.unidad||"—"})</p>
                            <input type="number" value={objMedForm.valor} onChange={e=>setObjMedForm(f=>({...f,valor:e.target.value}))}
                              placeholder="—"
                              style={{ width:"80px", padding:"5px 8px", borderRadius:"6px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"11px" }} />
                          </div>
                          <div>
                            <p style={{ fontSize:"9px", color:subtexto, margin:"0 0 2px" }}>Observaciones</p>
                            <input value={objMedForm.observaciones} onChange={e=>setObjMedForm(f=>({...f,observaciones:e.target.value}))}
                              placeholder="Opcional"
                              style={{ width:"140px", padding:"5px 8px", borderRadius:"6px", border:`1px solid ${borde}`, background:cardBg, color:texto, fontSize:"11px" }} />
                          </div>
                          <button onClick={() => agregarMedicion(o.id)}
                            style={{ padding:"5px 12px", background:"#2A7FFF", color:"white", border:"none", borderRadius:"6px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                            Guardar
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })()}

          {/* Tab normativas */}
          {tabEmpresa === "normativas" && (
            <div>
              {normAplicables.length === 0
                ? <p style={{ color:subtexto, textAlign:"center", padding:"2rem" }}>Sin normativas asignadas</p>
                : normAplicables.map(n => (
                  <div key={n.key} style={{ ...card, borderLeft:"4px solid #7B5BF2" }}>
                    <p style={{ fontSize:"13px", fontWeight:"700", color:texto, margin:"0 0 3px" }}>{n.label}</p>
                    <p style={{ fontSize:"12px", color:subtexto, margin:0 }}>{n.desc}</p>
                  </div>
                ))
              }
            </div>
          )}

          {/* Tab hallazgos */}
          {tabEmpresa === "hallazgos" && (() => {
            const hallazgosEmpresa = hallazgos.filter(h => h.empresaId === empresaSel.id)
              .sort((a, b) => (a.estado === "ok") - (b.estado === "ok"));
            return (
              <div>
                {hallazgosEmpresa.length === 0
                  ? <div style={{ textAlign:"center", padding:"3rem" }}><p style={{ fontSize:"32px" }}>✅</p><p style={{ color:subtexto, marginTop:"8px" }}>Sin hallazgos registrados</p></div>
                  : hallazgosEmpresa.map(h => {
                      const visitaRel = h.visitaId ? visitas.find(v => v.id === h.visitaId) : null;
                      const est = estadosHallazgo[h.estado] || estadosHallazgo.menor;
                      return (
                        <div key={h.id} style={{ ...card, borderLeft:`4px solid ${est.color}`, opacity:h.estado==="ok"?0.6:1 }}>
                          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:"10px" }}>
                            <div style={{ flex:1 }}>
                              <div style={{ display:"flex", gap:"8px", alignItems:"center", marginBottom:"4px" }}>
                                <span style={{ fontSize:"10px", fontWeight:"700", color:est.color, background:est.bg, borderRadius:"6px", padding:"2px 8px" }}>{est.label}</span>
                                {h.norma_base && <span style={{ fontSize:"10px", fontWeight:"700", color:"#1C3FAA" }}>{h.norma_base}</span>}
                              </div>
                              <p style={{ fontSize:"12px", color:texto, margin:"0 0 4px", lineHeight:"1.5" }}>{h.observacion}</p>
                              <p style={{ fontSize:"10px", color:subtexto, margin:0 }}>
                                {visitaRel ? `📋 ${visitaRel.codigo} — ${visitaRel.fecha}` : "🏭 Sin visita (a nivel empresa)"}
                                {h.referencia && ` · ${h.referencia}`}
                                {h.fecha && ` · ${h.fecha}`}
                              </p>
                            </div>
                            {h.estado !== "ok" && (
                              <button onClick={() => resolverHallazgo(h.id)}
                                style={{ padding:"6px 12px", background:"#22c55e", color:"white", border:"none", borderRadius:"7px", cursor:"pointer", fontSize:"11px", fontWeight:"600", flexShrink:0 }}>
                                ✅ Resolver
                              </button>
                            )}
                          </div>
                        </div>
                      );
                    })
                }
              </div>
            );
          })()}

          {/* Tab aspectos ambientales */}
          {tabEmpresa === "aspectos" && (() => { if (normativaAmbientalHistorial.length === 0 && (empresaSel.iso14001 || empresaSel.iso14001_2026)) { cargarHistorialNormativaAmbiental(empresaSel.id); } return null; })()}
          {tabEmpresa === "aspectos" && (() => {
            const aspectosEmp = aspectos.filter(a => a.empresa_id === empresaSel.id);
            const filtrados = filtroSignificancia === "todos"
              ? aspectosEmp
              : aspectosEmp.filter(a => calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi).nivel === filtroSignificancia);
            const colSig = (n) => n === "Significativo"
              ? { color:"#dc2626", bg:"#fee2e2", bdr:"#dc2626" }
              : n === "Moderado"
              ? { color:"#d97706", bg:"#fef3c7", bdr:"#d97706" }
              : { color:"#16a34a", bg:"#dcfce7", bdr:"#16a34a" };
            const sigN = aspectosEmp.filter(a => calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi).es_significativo).length;
            const modN = aspectosEmp.filter(a => { const r = calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi); return !r.es_significativo && r.valor > 6; }).length;
            const tolN = aspectosEmp.length - sigN - modN;
            return (
              <div>
                {/* Stats */}
                <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:"8px", marginBottom:"1rem" }}>
                  {[["Total",aspectosEmp.length,"#7B5BF2"],["Significativos",sigN,"#dc2626"],["Moderados",modN,"#d97706"],["Tolerables",tolN,"#16a34a"]].map(([l,v,c]) => (
                    <div key={l} style={{ background:cardBg, borderRadius:"10px", padding:".8rem", border:`1px solid ${borde}`, textAlign:"center" }}>
                      <p style={{ fontSize:"20px", fontWeight:"700", color:c, margin:0 }}>{v}</p>
                      <p style={{ fontSize:"9px", color:subtexto, margin:"3px 0 0" }}>{l}</p>
                    </div>
                  ))}
                </div>

                {/* IMA */}
                {(() => {
                  const lastAnal = normativaAmbientalHistorial[0]?.fecha_analisis || null;
                  const ima = calcularIMA(aspectosEmp, lastAnal);
                  const FILAS = [
                    ["C1","Identificación de aspectos", ima.c1,"§6.1.2"],
                    ["C2","Cumplimiento legal",          ima.c2,"§6.1.3"],
                    ["C3","Control de significativos",   ima.c3,"§8.1"],
                    ["C4","Efectividad de planes",       ima.c4,"§10.1"],
                  ];
                  return (
                    <div style={{ background:cardBg, borderRadius:"12px", border:`2px solid ${ima.color}44`, marginBottom:"1rem", padding:"14px 16px" }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"10px" }}>
                        <div>
                          <p style={{ fontSize:"10px", fontWeight:"700", color:subtexto, margin:"0 0 2px", textTransform:"uppercase", letterSpacing:".08em" }}>Índice de Madurez Ambiental</p>
                          <p style={{ fontSize:"11px", color:subtexto, margin:0 }}>ISO 14001 · 4 criterios</p>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          <span style={{ fontSize:"28px", fontWeight:"800", color:ima.color, lineHeight:1 }}>{ima.total}</span>
                          <span style={{ fontSize:"12px", color:subtexto }}>/100 </span>
                          <span style={{ fontSize:"14px", fontWeight:"800", background:ima.color+"22", color:ima.color, borderRadius:"6px", padding:"2px 8px", marginLeft:"4px" }}>{ima.nota}</span>
                        </div>
                      </div>
                      <div style={{ height:"8px", background:oscuro?"#1e3a8a":"#e5e7eb", borderRadius:"4px", marginBottom:"12px", overflow:"hidden" }}>
                        <div style={{ height:"100%", width:`${ima.total}%`, background:ima.color, borderRadius:"4px" }} />
                      </div>
                      <div style={{ display:"flex", flexDirection:"column", gap:"6px" }}>
                        {FILAS.map(([cod, label, pts, ref]) => (
                          <div key={cod} style={{ display:"grid", gridTemplateColumns:"24px 1fr 52px 28px", alignItems:"center", gap:"6px" }}>
                            <span style={{ fontSize:"9px", fontWeight:"700", color:subtexto }}>{cod}</span>
                            <div>
                              <div style={{ height:"5px", background:oscuro?"#1e3a8a":"#e5e7eb", borderRadius:"3px", overflow:"hidden" }}>
                                <div style={{ height:"100%", width:`${(pts/25)*100}%`, background:pts>=20?"#16a34a":pts>=12?"#d97706":"#dc2626", borderRadius:"3px" }} />
                              </div>
                              <p style={{ fontSize:"9px", color:subtexto, margin:"2px 0 0" }}>{label} <span style={{ opacity:.6 }}>{ref}</span></p>
                            </div>
                            <span style={{ fontSize:"10px", fontWeight:"700", color:pts>=20?"#16a34a":pts>=12?"#d97706":"#dc2626", textAlign:"right" }}>{pts}/25</span>
                            <span style={{ fontSize:"13px", textAlign:"center" }}>{pts>=20?"✓":pts>=12?"⚠":"✗"}</span>
                          </div>
                        ))}
                      </div>
                      {(empresaSel.ima_historial?.length > 0) && (
                        <div style={{ marginTop:"12px", borderTop:`1px solid ${borde}`, paddingTop:"10px" }}>
                          <p style={{ fontSize:"10px", fontWeight:"700", color:subtexto, margin:"0 0 8px", textTransform:"uppercase", letterSpacing:".06em" }}>📈 Evolución IMA</p>
                          <div style={{ display:"grid", gridTemplateColumns:"90px 44px 28px 28px 28px 28px 28px", gap:"0 4px", marginBottom:"4px" }}>
                            {["Fecha","IMA","N","C1","C2","C3","C4"].map(h => (
                              <span key={h} style={{ fontSize:"9px", fontWeight:"700", color:subtexto }}>{h}</span>
                            ))}
                          </div>
                          {(empresaSel.ima_historial || []).map((s, i) => {
                            const cN = s.total>=85?"#16a34a":s.total>=65?"#2A7FFF":s.total>=45?"#d97706":"#dc2626";
                            return (
                              <div key={i} style={{ display:"grid", gridTemplateColumns:"90px 44px 28px 28px 28px 28px 28px", gap:"0 4px", padding:"2px 0" }}>
                                <span style={{ fontSize:"9px", color:subtexto }}>{new Date(s.fecha+"T00:00:00").toLocaleDateString("es-AR")}</span>
                                <span style={{ fontSize:"9px", fontWeight:"700", color:cN }}>{s.total}</span>
                                <span style={{ fontSize:"9px", fontWeight:"700", color:cN }}>{s.nota}</span>
                                {[s.c1,s.c2,s.c3,s.c4].map((v,j) => (
                                  <span key={j} style={{ fontSize:"9px", color:v>=20?"#16a34a":v>=12?"#d97706":"#dc2626" }}>{v}</span>
                                ))}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })()}

                {/* Acciones */}
                <div style={{ display:"flex", gap:"8px", marginBottom:"1rem", flexWrap:"wrap" }}>
                  <button onClick={() => ariaSupgerirAspectos()} disabled={aspectoCargando}
                    style={{ padding:"7px 14px", background:"#7B5BF222", border:"1px solid #7B5BF2", borderRadius:"8px", cursor:"pointer", color:"#7B5BF2", fontSize:"11px", fontWeight:"600", opacity:aspectoCargando?0.7:1 }}>
                    {aspectoCargando ? "⏳ Sugiriendo..." : "🤖 ARIA Sugerir"}
                  </button>
                  {aspectosEmp.length > 0 && (
                    <button onClick={() => exportarAspectosExcel(aspectosEmp, empresaSel)}
                      style={{ padding:"7px 14px", background:"#22c55e22", border:"1px solid #22c55e", borderRadius:"8px", cursor:"pointer", color:"#16a34a", fontSize:"11px", fontWeight:"600" }}>
                      📊 Exportar Excel
                    </button>
                  )}
                  {aspectosEmp.length > 0 && (
                    <button onClick={() => {
                      const lastAnal = normativaAmbientalHistorial[0]?.fecha_analisis || null;
                      const snap = { ...calcularIMA(aspectosEmp, lastAnal), fecha: new Date().toISOString().split("T")[0] };
                      const nuevo = [snap, ...(empresaSel.ima_historial || [])].slice(0, 12);
                      const empAct = { ...empresaSel, ima_historial: nuevo };
                      guardarEmpresas(empresas.map(e => e.id === empresaSel.id ? empAct : e));
                      setEmpresaSel(empAct);
                      exportarAspectosWord(aspectosEmp, empAct, normativasAmbientales);
                    }}
                      style={{ padding:"7px 14px", background:"#2A7FFF22", border:"1px solid #2A7FFF", borderRadius:"8px", cursor:"pointer", color:"#2A7FFF", fontSize:"11px", fontWeight:"600" }}>
                      📄 Informe Word
                    </button>
                  )}
                  <button onClick={() => setShowAspectoForm(f => !f)}
                    style={{ padding:"7px 14px", background:showAspectoForm?"#09184D":"#2A7FFF", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                    {showAspectoForm ? "✕ Cancelar" : "+ Nuevo"}
                  </button>
                </div>

                {/* Formulario nuevo aspecto */}
                {showAspectoForm && (
                  <div style={{ ...card, border:"2px solid #7B5BF2", marginBottom:"1rem" }}>
                    <p style={{ fontSize:"13px", fontWeight:"700", color:"#7B5BF2", margin:"0 0 12px" }}>Nuevo aspecto ambiental</p>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px" }}>
                      <div>
                        <span style={lbl}>Etapa del ciclo de vida</span>
                        <select value={aspectoForm.etapa} onChange={e => setAspectoForm(f=>({...f,etapa:e.target.value}))} style={inp}>
                          <option value="">Seleccionar...</option>
                          {ETAPAS_CICLO_VIDA.map(e => <option key={e}>{e}</option>)}
                        </select>
                      </div>
                      <div>
                        <span style={lbl}>Recurso afectado</span>
                        <select value={aspectoForm.recurso} onChange={e => setAspectoForm(f=>({...f,recurso:e.target.value}))} style={inp}>
                          <option value="">Seleccionar...</option>
                          {RECURSOS_AFECTADOS.map(r => <option key={r}>{r}</option>)}
                        </select>
                      </div>
                    </div>
                    <span style={lbl}>Aspecto ambiental</span>
                    <input value={aspectoForm.aspecto} onChange={e => setAspectoForm(f=>({...f,aspecto:e.target.value}))} placeholder="Ej: Generación de residuos de tintas" style={inp}/>
                    <span style={lbl}>Impacto ambiental</span>
                    <input value={aspectoForm.impacto} onChange={e => setAspectoForm(f=>({...f,impacto:e.target.value}))} placeholder="Ej: Contaminación del suelo" style={inp}/>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"10px", marginTop:"12px" }}>
                      <div>
                        <span style={lbl}>Tipo</span>
                        <div style={{ display:"flex", gap:"6px", marginTop:"4px" }}>
                          {["Negativo","Positivo"].map(t => (
                            <button key={t} onClick={() => setAspectoForm(f=>({...f,tipo:t}))}
                              style={{ flex:1, padding:"6px", borderRadius:"8px", border:`1.5px solid ${aspectoForm.tipo===t?"#7B5BF2":borde}`, background:aspectoForm.tipo===t?"rgba(123,91,242,.1)":cardBg, color:aspectoForm.tipo===t?"#7B5BF2":subtexto, fontSize:"11px", cursor:"pointer", fontWeight:"600" }}>
                              {t}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div>
                        <span style={lbl}>Condición</span>
                        <select value={aspectoForm.condicion} onChange={e => setAspectoForm(f=>({...f,condicion:e.target.value}))} style={{...inp,marginTop:"4px"}}>
                          {["Normal","Anormal","Emergencia"].map(c => <option key={c}>{c}</option>)}
                        </select>
                      </div>
                      <div>
                        <span style={lbl}>Flags</span>
                        <div style={{ display:"flex", gap:"4px", marginTop:"4px" }}>
                          {[["flag_lp","LP"],["flag_pi","PI"],["flag_en","EN"]].map(([k,l]) => (
                            <button key={k} onClick={() => setAspectoForm(f=>({...f,[k]:!f[k]}))}
                              style={{ flex:1, padding:"4px 6px", borderRadius:"6px", fontSize:"10px", fontWeight:"700", cursor:"pointer", border:`1.5px solid ${aspectoForm[k]?"#7B5BF2":borde}`, background:aspectoForm[k]?"rgba(123,91,242,.1)":cardBg, color:aspectoForm[k]?"#7B5BF2":subtexto }}>
                              {l}
                            </button>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px", marginTop:"12px" }}>
                      {[["probabilidad","Probabilidad (P)"],["consecuencia","Consecuencia (C)"]].map(([campo,titulo]) => (
                        <div key={campo}>
                          <span style={lbl}>{titulo}</span>
                          <div style={{ display:"flex", gap:"4px", marginTop:"4px" }}>
                            {ESCALA_PC.map(({valor,label}) => (
                              <button key={valor} title={TOOLTIPS_PC[campo]?.[valor]} onClick={() => setAspectoForm(f=>({...f,[campo]:valor}))}
                                style={{ flex:1, padding:"6px 2px", borderRadius:"6px", fontSize:"10px", fontWeight:"700", cursor:"pointer", textAlign:"center",
                                  border:`1.5px solid ${aspectoForm[campo]===valor?"#7B5BF2":borde}`,
                                  background:aspectoForm[campo]===valor?"rgba(123,91,242,.15)":cardBg,
                                  color:aspectoForm[campo]===valor?"#7B5BF2":subtexto }}>
                                {valor}<br/><span style={{fontSize:"7px",fontWeight:"400"}}>{label}</span>
                              </button>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                    {(() => {
                      const { valor, nivel } = calcularSignificancia(aspectoForm.probabilidad, aspectoForm.consecuencia, aspectoForm.flag_lp, aspectoForm.flag_pi);
                      const cs = colSig(nivel);
                      return (
                        <div style={{ marginTop:"12px", padding:"10px 14px", borderRadius:"10px", background:cs.bg, border:`1.5px solid ${cs.bdr}`, display:"flex", alignItems:"center", gap:"12px" }}>
                          <span style={{ fontSize:"22px", fontWeight:"700", color:cs.color }}>{valor}</span>
                          <div>
                            <p style={{ fontSize:"12px", fontWeight:"700", color:cs.color, margin:0 }}>{nivel}</p>
                            <p style={{ fontSize:"10px", color:subtexto, margin:"2px 0 0" }}>P={aspectoForm.probabilidad} × C={aspectoForm.consecuencia}</p>
                          </div>
                        </div>
                      );
                    })()}
                    <span style={lbl}>Control existente</span>
                    <textarea rows={2} value={aspectoForm.descripcion_control} onChange={e => setAspectoForm(f=>({...f,descripcion_control:e.target.value}))} placeholder="Medida de control o mitigación existente..." style={{...inp,resize:"none"}}/>
                    <button onClick={() => {
                      if (!aspectoForm.aspecto?.trim() || !aspectoForm.etapa) return;
                      guardarAspectos([...aspectos, { ...aspectoForm, id:Math.floor(Date.now()), empresa_id:empresaSel.id, fecha_creacion:fechaHoy() }]);
                      setAspectoForm({ etapa:"", aspecto:"", impacto:"", tipo:"Negativo", recurso:"", probabilidad:1, consecuencia:1, flag_lp:false, flag_pi:false, flag_en:false, condicion:"Normal", descripcion_control:"" });
                      setShowAspectoForm(false);
                    }} style={{ marginTop:"12px", width:"100%", padding:"10px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"13px", fontWeight:"600" }}>
                      💾 Guardar aspecto
                    </button>
                  </div>
                )}

                {/* Filtros */}
                <div style={{ display:"flex", gap:"6px", marginBottom:"1rem", flexWrap:"wrap" }}>
                  {[["todos","Todos",aspectosEmp.length],["Significativo","🔴 Significativos",sigN],["Moderado","🟡 Moderados",modN],["Tolerable","🟢 Tolerables",tolN]].map(([key,label,count]) => (
                    <button key={key} onClick={() => setFiltroSignificancia(key)}
                      style={{ padding:"5px 12px", borderRadius:"20px", fontSize:"11px", cursor:"pointer", fontWeight:"600",
                        border:filtroSignificancia===key?"2px solid #7B5BF2":`1px solid ${borde}`,
                        background:filtroSignificancia===key?"rgba(123,91,242,.1)":cardBg,
                        color:filtroSignificancia===key?"#7B5BF2":subtexto }}>
                      {label} ({count})
                    </button>
                  ))}
                </div>

                {/* Lista de aspectos */}
                {filtrados.length === 0
                  ? <div style={{ textAlign:"center", padding:"3rem" }}>
                      <p style={{ fontSize:"32px" }}>🌿</p>
                      <p style={{ color:subtexto, marginTop:"8px" }}>
                        {aspectosEmp.length === 0 ? "Sin aspectos registrados. Usá ARIA para sugerir o agregá uno manualmente." : "Sin aspectos con este filtro."}
                      </p>
                    </div>
                  : filtrados.map(a => {
                      const { valor, nivel } = calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi);
                      const cs = colSig(nivel);
                      return (
                        <div key={a.id} style={{ ...card, borderLeft:`4px solid ${cs.bdr}` }}>
                          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:"10px" }}>
                            <div style={{ flex:1 }}>
                              <div style={{ display:"flex", gap:"6px", alignItems:"center", flexWrap:"wrap", marginBottom:"4px" }}>
                                <span style={{ fontSize:"11px", fontWeight:"700", color:cs.color, background:cs.bg, borderRadius:"6px", padding:"2px 10px", border:`1px solid ${cs.bdr}` }}>
                                  {valor} — {nivel}
                                </span>
                                {a.etapa && <span style={{ fontSize:"9px", color:subtexto, background:oscuro?"#1e3a8a":"#f0eeff", borderRadius:"6px", padding:"2px 8px" }}>{a.etapa}</span>}
                                {a.tipo === "Positivo" && <span style={{ fontSize:"9px", fontWeight:"700", color:"#16a34a", background:"#dcfce7", borderRadius:"6px", padding:"2px 8px" }}>+ Positivo</span>}
                                {a.flag_lp && <span style={{ fontSize:"9px", fontWeight:"700", color:"#1d4ed8", background:"#dbeafe", borderRadius:"6px", padding:"2px 6px" }}>LP</span>}
                                {a.flag_pi && <span style={{ fontSize:"9px", fontWeight:"700", color:"#7c3aed", background:"#ede9fe", borderRadius:"6px", padding:"2px 6px" }}>PI</span>}
                                {a.flag_en && <span style={{ fontSize:"9px", fontWeight:"700", color:"#b45309", background:"#fef3c7", borderRadius:"6px", padding:"2px 6px" }}>EN ⚠</span>}
                              </div>
                              <p style={{ fontSize:"13px", fontWeight:"600", color:texto, margin:"0 0 2px" }}>{a.aspecto}</p>
                              <p style={{ fontSize:"11px", color:subtexto, margin:"0 0 3px" }}>Impacto: {a.impacto||"—"} · Recurso: {a.recurso||"—"} · {a.condicion}</p>
                              {a.descripcion_control && <p style={{ fontSize:"10px", color:subtexto, margin:0, fontStyle:"italic" }}>🛡 {a.descripcion_control}</p>}
                              {a.plan_accion?.accion && (() => {
                                const PA_ESTADOS = { Pendiente:{c:"#d97706",bg:"#fef3c7"}, "En curso":{c:"#2A7FFF",bg:"#dbeafe"}, Completado:{c:"#16a34a",bg:"#dcfce7"}, Verificado:{c:"#7B5BF2",bg:"#ede9fe"} };
                                const est = PA_ESTADOS[a.plan_accion.estado] || PA_ESTADOS.Pendiente;
                                return <span style={{ fontSize:"9px", fontWeight:"700", color:est.c, background:est.bg, borderRadius:"6px", padding:"2px 8px", display:"inline-block", marginTop:"4px" }}>📋 {a.plan_accion.estado || "Pendiente"}</span>;
                              })()}
                              {(() => {
                                const objCount = objetivos.filter(o => o.aspecto_id === a.id).length;
                                if (!objCount) return null;
                                return (
                                  <span onClick={() => setTabEmpresa("objetivos")}
                                    title="Ver objetivos vinculados"
                                    style={{ fontSize:"9px", fontWeight:"700", color:"#16a34a", background:"#dcfce7", borderRadius:"6px", padding:"2px 8px", display:"inline-block", marginTop:"4px", marginLeft:"4px", cursor:"pointer" }}>
                                    🎯 {objCount} objetivo{objCount > 1 ? "s" : ""}
                                  </span>
                                );
                              })()}
                            </div>
                            <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:"4px", flexShrink:0 }}>
                              <div style={{ textAlign:"center", background:cs.bg, borderRadius:"8px", padding:"4px 12px", border:`1px solid ${cs.bdr}` }}>
                                <p style={{ fontSize:"9px", color:subtexto, margin:0 }}>P×C</p>
                                <p style={{ fontSize:"20px", fontWeight:"700", color:cs.color, margin:0 }}>{valor}</p>
                              </div>
                              {nivel === "Significativo" && (
                                <button onClick={() => {
                                  if (planAccionAbierto === a.id) { setPlanAccionAbierto(null); return; }
                                  setPlanAccionAbierto(a.id);
                                  setPlanAccionForm(a.plan_accion || { accion:"", responsable:"", plazo:"", estado:"Pendiente", evidencia:"", observaciones:"" });
                                }}
                                  style={{ padding:"4px 8px", background:planAccionAbierto===a.id?"#7B5BF2":"#7B5BF222", border:"1px solid #7B5BF2", borderRadius:"6px", cursor:"pointer", color:planAccionAbierto===a.id?"white":"#7B5BF2", fontSize:"10px", fontWeight:"600" }}>
                                  📋
                                </button>
                              )}
                              <button onClick={() => { guardarAspectos(aspectos.filter(x => x.id !== a.id)); eliminarDato(STORAGE_ASPECTOS, a.id); }}
                                style={{ padding:"4px 8px", background:"none", border:`1px solid ${borde}`, borderRadius:"6px", cursor:"pointer", color:"#e63946", fontSize:"10px" }}>
                                🗑
                              </button>
                            </div>
                          </div>
                          {planAccionAbierto === a.id && (
                            <div style={{ borderTop:`1px solid ${borde}`, marginTop:"12px", paddingTop:"12px" }}>
                              <p style={{ fontSize:"12px", fontWeight:"700", color:"#7B5BF2", margin:"0 0 10px" }}>📋 Plan de acción — {a.aspecto}</p>
                              <span style={lbl}>Acción correctiva / preventiva</span>
                              <textarea rows={2} value={planAccionForm.accion||""} onChange={e=>setPlanAccionForm(f=>({...f,accion:e.target.value}))} placeholder="Describir la acción a implementar..." style={{...inp,resize:"none"}}/>
                              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px", marginTop:"8px" }}>
                                <div><span style={lbl}>Responsable</span><input value={planAccionForm.responsable||""} onChange={e=>setPlanAccionForm(f=>({...f,responsable:e.target.value}))} placeholder="Nombre / área" style={inp}/></div>
                                <div><span style={lbl}>Plazo</span><input type="date" value={planAccionForm.plazo||""} onChange={e=>setPlanAccionForm(f=>({...f,plazo:e.target.value}))} style={inp}/></div>
                              </div>
                              <span style={{...lbl, marginTop:"8px"}}>Estado</span>
                              <div style={{ display:"flex", gap:"6px", marginTop:"4px", flexWrap:"wrap" }}>
                                {["Pendiente","En curso","Completado","Verificado"].map(st => (
                                  <button key={st} onClick={()=>setPlanAccionForm(f=>({...f,estado:st}))}
                                    style={{ padding:"5px 10px", borderRadius:"8px", fontSize:"11px", fontWeight:"600", cursor:"pointer",
                                      border:`1.5px solid ${planAccionForm.estado===st?"#7B5BF2":borde}`,
                                      background:planAccionForm.estado===st?"rgba(123,91,242,.12)":cardBg,
                                      color:planAccionForm.estado===st?"#7B5BF2":subtexto }}>
                                    {st}
                                  </button>
                                ))}
                              </div>
                              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px", marginTop:"8px" }}>
                                <div><span style={lbl}>Evidencia</span><input value={planAccionForm.evidencia||""} onChange={e=>setPlanAccionForm(f=>({...f,evidencia:e.target.value}))} placeholder="Registro, foto, acta..." style={inp}/></div>
                                <div><span style={lbl}>Observaciones</span><input value={planAccionForm.observaciones||""} onChange={e=>setPlanAccionForm(f=>({...f,observaciones:e.target.value}))} placeholder="Notas adicionales..." style={inp}/></div>
                              </div>
                              <div style={{ display:"flex", gap:"8px", marginTop:"10px" }}>
                                <button onClick={()=>{ guardarAspectos(aspectos.map(x=>x.id===a.id?{...x,plan_accion:planAccionForm}:x)); setPlanAccionAbierto(null); }}
                                  style={{ flex:1, padding:"8px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>
                                  💾 Guardar plan
                                </button>
                                <button onClick={()=>setPlanAccionAbierto(null)}
                                  style={{ padding:"8px 14px", background:"none", border:`1px solid ${borde}`, borderRadius:"8px", cursor:"pointer", color:subtexto, fontSize:"12px" }}>
                                  ✕
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })
                }

                {/* ── Sub-sección Normativa Ambiental Aplicable ── */}
                {(empresaSel.iso14001 || empresaSel.iso14001_2026) && (
                  <div style={{ marginTop:"2rem" }}>
                    <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:"1rem", flexWrap:"wrap", gap:"8px" }}>
                      <p style={{ fontSize:"14px", fontWeight:"700", color:texto, margin:0 }}>📋 Normativa Ambiental Aplicable</p>
                      <div style={{ display:"flex", gap:"8px" }}>
                        <button onClick={() => analizarNormativaAmbiental(empresaSel)}
                          disabled={normativaAmbientalCargando || guardandoAnalisisAmb}
                          style={{ padding:"7px 14px", background:"#22c55e22", border:"1px solid #22c55e", borderRadius:"8px", cursor:"pointer", color:"#16a34a", fontSize:"11px", fontWeight:"600", opacity:(normativaAmbientalCargando||guardandoAnalisisAmb)?0.6:1 }}>
                          {normativaAmbientalCargando ? "⏳ Analizando..." : guardandoAnalisisAmb ? "💾 Guardando..." : "🌿 Analizar normativa ambiental"}
                        </button>
                        <button onClick={() => generarMatrizAgente(empresaSel)}
                          disabled={generandoMatrizAgente}
                          style={{ padding:"7px 14px", background:"none", border:"1.5px solid #7B5BF2", borderRadius:"8px", cursor:generandoMatrizAgente?"not-allowed":"pointer", color:"#7B5BF2", fontSize:"11px", fontWeight:"600", opacity:generandoMatrizAgente?0.6:1 }}>
                          {generandoMatrizAgente ? "⏳ Analizando..." : "🤖 Agente Normativo"}
                        </button>
                        {progresoAgente && (
                          <span style={{ fontSize:"11px", color:"#7B5BF2", fontWeight:"600", alignSelf:"center" }}>{progresoAgente}</span>
                        )}
                        <button onClick={() => generarMatrizDesdeBase(empresaSel)}
                          style={{ padding:"7px 14px", background:"none", border:"1.5px solid #7B5BF2", borderRadius:"8px", cursor:"pointer", color:"#7B5BF2", fontSize:"11px", fontWeight:"600" }}>
                          📋 Matriz desde base
                        </button>
                        {normativasAmbientales && (() => {
                          let parsedAmb = null;
                          try { parsedAmb = JSON.parse(normativasAmbientales); } catch {}
                          if (!parsedAmb) return null;
                          return (
                            <button onClick={() => exportarMatrizExcel(parsedAmb, empresaSel)}
                              style={{ padding:"7px 14px", background:"#22c55e", border:"none", borderRadius:"8px", cursor:"pointer", color:"white", fontSize:"11px", fontWeight:"600" }}>
                              ⬇️ Excel
                            </button>
                          );
                        })()}
                      </div>
                    </div>

                    {normativaAmbientalHistorial.length > 0 && (
                      <div style={{ marginBottom:"1rem" }}>
                        <p style={{ fontSize:"11px", color:subtexto, margin:"0 0 6px", fontWeight:"600" }}>Últimos análisis</p>
                        <div style={{ display:"flex", gap:"6px", flexWrap:"wrap" }}>
                          {normativaAmbientalHistorial.map((h, i) => (
                            <button key={h.id} onClick={() => setNormativasAmbientales(h.analisis || "")}
                              style={{ padding:"4px 10px", borderRadius:"8px", fontSize:"10px", cursor:"pointer", fontWeight:"600",
                                border:`1px solid ${borde}`, background:i===0?"rgba(34,197,94,.1)":cardBg, color:i===0?"#16a34a":subtexto }}>
                              {new Date(h.fecha_analisis).toLocaleDateString("es-AR")}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {normativasAmbientales && (() => {
                      let parsed = null;
                      try { parsed = JSON.parse(normativasAmbientales); } catch {}
                      if (!parsed) return <p style={{ color:subtexto, fontSize:"12px" }}>{normativasAmbientales}</p>;
                      return (
                        <div>
                          {parsed.resumen_ejecutivo && (
                            <div style={{ ...card, borderLeft:"4px solid #22c55e", marginBottom:"1rem" }}>
                              <p style={{ fontSize:"11px", fontWeight:"700", color:"#16a34a", margin:"0 0 6px" }}>Resumen ejecutivo</p>
                              <p style={{ fontSize:"12px", color:texto, margin:0, lineHeight:"1.6" }}>{parsed.resumen_ejecutivo}</p>
                            </div>
                          )}
                          {[
                            ["normativa_nacional",       "🇦🇷 Nacional"],
                            ["normativa_provincial",     "🏛 Provincial"],
                            ["normativa_municipal",      "🏙 Municipal"],
                            ["actualizaciones_recientes","🔔 Actualizaciones"],
                            ["obligaciones_operativas",  "⚙️ Obligaciones operativas"],
                            ["checklist_ambiental",      "✅ Checklist auditoría"],
                          ].map(([key, titulo]) => {
                            const items = parsed[key];
                            if (!items?.length) return null;
                            return (
                              <div key={key} style={{ marginBottom:"1rem" }}>
                                <p style={{ fontSize:"12px", fontWeight:"700", color:texto, margin:"0 0 8px" }}>{titulo} ({items.length})</p>
                                {items.map((item, idx) => {
                                  const isNorma = item.codigo || item.nombre;
                                  const rColor = item.riesgo === "CRITICO" ? "#e63946" : item.riesgo === "ALTO" ? "#f97316" : item.riesgo === "MEDIO" ? "#f59e0b" : "#6b7280";
                                  return (
                                    <div key={idx} style={{ ...card, padding:"10px 14px", marginBottom:"6px", borderLeft:`3px solid ${isNorma ? rColor : "#22c55e"}` }}>
                                      {isNorma ? (
                                        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:"8px" }}>
                                          <div style={{ flex:1 }}>
                                            <div style={{ display:"flex", gap:"6px", alignItems:"center", flexWrap:"wrap", marginBottom:"3px" }}>
                                              <span style={{ fontSize:"10px", fontWeight:"700", color:"#16a34a" }}>{item.codigo}</span>
                                              {item.riesgo && <span style={{ fontSize:"9px", fontWeight:"700", color:rColor, background:`${rColor}22`, borderRadius:"4px", padding:"1px 6px" }}>{item.riesgo}</span>}
                                              {item.aplicabilidad && item.aplicabilidad !== "APLICA" && <span style={{ fontSize:"9px", color:subtexto, background:oscuro?"#1e3a8a":"#f5f5f5", borderRadius:"4px", padding:"1px 6px" }}>{item.aplicabilidad}</span>}
                                            </div>
                                            <p style={{ fontSize:"12px", fontWeight:"600", color:texto, margin:"0 0 2px" }}>{item.nombre}</p>
                                            <p style={{ fontSize:"11px", color:subtexto, margin:"0 0 3px", lineHeight:"1.4" }}>{item.obligaciones_concretas || item.descripcion}</p>
                                            {item.iso_clausula && <p style={{ fontSize:"9px", color:"#7B5BF2", margin:0, fontWeight:"600" }}>ISO: {item.iso_clausula}</p>}
                                          </div>
                                          <div style={{ textAlign:"right", flexShrink:0 }}>
                                            <p style={{ fontSize:"9px", color:subtexto, margin:0 }}>{item.frecuencia}</p>
                                            <p style={{ fontSize:"9px", color:subtexto, margin:"2px 0 0" }}>{item.area_responsable}</p>
                                          </div>
                                        </div>
                                      ) : (
                                        <p style={{ fontSize:"12px", color:texto, margin:0, lineHeight:"1.5" }}>
                                          {item.norma && <span style={{ fontWeight:"700", color:"#16a34a", marginRight:"6px" }}>{item.norma}</span>}
                                          {item.obligacion || item.descripcion || item.item}
                                          {item.impacto && <span style={{ fontSize:"9px", color:subtexto, marginLeft:"6px" }}>[{item.impacto}]</span>}
                                          {item.prioridad && <span style={{ fontSize:"9px", fontWeight:"700", color:item.prioridad==="ALTA"?"#e63946":item.prioridad==="MEDIA"?"#f59e0b":"#6b7280", marginLeft:"6px" }}>{item.prioridad}</span>}
                                        </p>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}

                    {!normativasAmbientales && normativaAmbientalHistorial.length === 0 && (
                      <p style={{ color:subtexto, fontSize:"12px", textAlign:"center", padding:"1.5rem 0" }}>
                        Sin análisis previos. Presioná "🌿 Analizar normativa ambiental" para ejecutar el primer análisis.
                      </p>
                    )}
                  </div>
                )}
                {usuario?.rol === "Administrador" && (
                  <div style={{ marginTop:"2rem", display:"flex", gap:"8px", flexWrap:"wrap" }}>
                    <button onClick={() => {
                        const input = document.createElement('input');
                        input.type = 'file';
                        input.accept = '.xlsx';
                        input.onchange = (e) => {
                          const archivo = e.target.files[0];
                          if (archivo) actualizarMatrizDesdeArchivo(empresaSel, archivo);
                        };
                        input.click();
                      }}
                      disabled={actualizandoMatriz}
                      style={{ padding:"7px 14px", background:"none", border:"1.5px solid #1C3FAA", borderRadius:"8px", cursor:actualizandoMatriz?"not-allowed":"pointer", color:"#1C3FAA", fontSize:"11px", fontWeight:"600", opacity:actualizandoMatriz?0.6:1 }}>
                      {actualizandoMatriz ? "⏳ Actualizando..." : "📂 Actualizar matriz existente"}
                    </button>
                    <button onClick={() => generarMatrizAgente(empresaSel)}
                      disabled={generandoMatrizAgente}
                      style={{ padding:"7px 14px", background:"none", border:"1.5px solid #1C3FAA", borderRadius:"8px", cursor:generandoMatrizAgente?"not-allowed":"pointer", color:"#1C3FAA", fontSize:"11px", fontWeight:"600", opacity:generandoMatrizAgente?0.6:1 }}>
                      {generandoMatrizAgente ? "⏳ Analizando..." : "🆕 Generar matriz nueva"}
                    </button>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      </div>
    );
  }

  // ── NUEVA VISITA ──
  if (vista === "nueva_visita") return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <Nav titulo="Nueva Visita de Inspección" onBack={() => setVista("empresa")} />
      <div style={{ padding:"0 1.5rem 2rem", maxWidth:"700px", margin:"0 auto" }}>
        <div style={card}>
          {[
            { k:"fecha",     label:"Fecha",           type:"date" },
            { k:"objetivo",  label:"Objetivo de la visita", multi:true },
            { k:"inspector", label:"Inspector responsable" },
          ].map(({ k, label, type, multi }) => (
            <div key={k}>
              <span style={lbl}>{label}</span>
              {multi
                ? <textarea rows={2} value={formVisita[k]||""} onChange={e=>setFormVisita(f=>({...f,[k]:e.target.value}))} style={{...inp,resize:"none"}}/>
                : <input type={type||"text"} value={formVisita[k]||""} onChange={e=>setFormVisita(f=>({...f,[k]:e.target.value}))} style={inp}/>
              }
            </div>
          ))}
          <button onClick={() => {
            const nueva = { ...formVisita, id:Math.floor(Date.now()), codigo:generarCod("VIS",visitas), empresaId:empresaSel.id, estado:"en_curso", checkItems:{}, creadoPor:usuario?.nombre||"Sistema", fechaCreacion:new Date().toISOString() };
            guardarVisitas([...visitas, nueva]);
            setVisitaSel(nueva);
            setCheckItems({});
            setFormVisita({ fecha:fechaHoy(), estado:"planificada" });
            setVista("visita");
          }} style={{ width:"100%", padding:"13px", background:"#2A7FFF", color:"white", border:"none", borderRadius:"10px", fontSize:"14px", fontWeight:"600", cursor:"pointer", marginTop:"1.5rem" }}>
            Iniciar Inspección
          </button>
        </div>
      </div>
    </div>
  );

  // ── VISITA / INSPECCIÓN ──
  if (vista === "visita" && visitaSel) {
    const empresa = empresas.find(e => e.id === visitaSel.empresaId);
    const hv = hallazgosVisita(visitaSel.id);
    // Categorías filtradas según normativas de la empresa
    const normativasEmpresa = empresa ? Object.keys(NORMA_CATEGORIAS).filter(k => empresa[k]) : [];
    const categoriasPermitidas = normativasEmpresa.length > 0
      ? [...new Set(normativasEmpresa.flatMap(k => NORMA_CATEGORIAS[k] || []))]
      : [...new Set(itemsChecklist.map(i => i.categoria))];
    // Ítems custom de la empresa
    const itemsCustom = (empresa?.itemsCustom || []);
    const todosItems = [...itemsChecklist, ...itemsCustom];
    const categorias = [...new Set(todosItems.filter(i => categoriasPermitidas.includes(i.categoria)).map(i => i.categoria))];
    const puntaje = puntajeVisita(visitaSel.id);



    return (
      <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
        <Nav titulo={`${visitaSel.codigo} — ${empresa?.nombre||""}`}
          onBack={() => { setVisitaSel(null); setVista("empresa"); }}
          extra={
            <div style={{ display:"flex", gap:"8px" }}>
              <button onClick={generarInforme} disabled={ariaCargando}
                style={{ padding:"6px 12px", background:ariaCargando?"#9ca3af":"#7B5BF2", color:"white", border:"none", borderRadius:"8px", cursor:ariaCargando?"not-allowed":"pointer", fontSize:"11px", fontWeight:"600" }}>
                {ariaCargando?"Generando...":"🤖 Generar informe"}
              </button>
              {visitaSel.estado !== "cerrada" && (
                <button onClick={() => { const act=visitas.map(v=>v.id===visitaSel.id?{...v,estado:"cerrada",fechaCierre:fechaHoy()}:v); guardarVisitas(act); setVisitaSel(p=>({...p,estado:"cerrada"})); }}
                  style={{ padding:"6px 12px", background:"#22c55e", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"11px", fontWeight:"600" }}>
                  ✅ Cerrar visita
                </button>
              )}
            </div>
          }
        />
        <div style={{ padding:"0 1.5rem 2rem", maxWidth:"800px", margin:"0 auto" }}>

          {/* Puntaje */}
          {puntaje !== null && (
            <div style={{ ...card, background:puntaje>=80?"#dcfce7":puntaje>=60?"#fef3c7":"#fee2e2", border:`1px solid ${puntaje>=80?"#86efac":puntaje>=60?"#fde68a":"#fca5a5"}`, textAlign:"center", marginBottom:"1rem" }}>
              <p style={{ fontSize:"28px", fontWeight:"800", color:puntaje>=80?"#16a34a":puntaje>=60?"#d97706":"#dc2626", margin:"0 0 4px" }}>{puntaje}%</p>
              <p style={{ fontSize:"12px", color:subtexto, margin:0 }}>Cumplimiento · {hv.filter(h=>h.estado==="critico").length} críticos · {hv.filter(h=>h.estado==="mayor").length} mayores · {hv.filter(h=>h.estado==="menor").length} menores</p>
            </div>
          )}

          {/* Informe ARIA */}
          {ariaRespuesta && (
            <div style={{ ...card, border:"1.5px solid #7B5BF2", background:oscuro?"#0a1f5c":"#f5f3ff" }}>
              <h3 style={{ fontSize:"13px", fontWeight:"700", color:"#7B5BF2", marginBottom:"10px" }}>🤖 Informe ARIA</h3>
              <pre style={{ fontSize:"12px", color:texto, lineHeight:"1.7", whiteSpace:"pre-wrap", fontFamily:"sans-serif", margin:0 }}>{ariaRespuesta}</pre>
            </div>
          )}

          {/* Checklist por categoría */}
          {categorias.map(cat => (
            <div key={cat} style={{ marginBottom:"16px" }}>
              <h3 style={{ fontSize:"12px", fontWeight:"700", color:"#7B5BF2", textTransform:"uppercase", letterSpacing:".1em", marginBottom:"8px", padding:"6px 0", borderBottom:`1px solid ${borde}` }}>{cat}</h3>
              {todosItems.filter(i => i.categoria === cat && categoriasPermitidas.includes(i.categoria)).map(item => {
                const check = checkItems[item.id];
                return (
                  <div key={item.id} style={{ ...card, padding:"10px 14px", marginBottom:"8px", borderLeft:`3px solid ${check ? estadosHallazgo[check.estado]?.color||"#22c55e" : borde}` }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:"10px" }}>
                      <div style={{ flex:1 }}>
                        <p style={{ fontSize:"12px", fontWeight:"600", color:texto, margin:"0 0 2px" }}>{item.texto}</p>
                        <p style={{ fontSize:"10px", color:"#7B5BF2", margin:0 }}>{item.ref}</p>
                      </div>
                      <div style={{ display:"flex", gap:"4px", flexShrink:0 }}>
                        {Object.entries(estadosHallazgo).map(([val,{label,color,bg}]) => (
                          <button key={val} onClick={() => marcarItem(item.id, val, check?.observacion)}
                            style={{ padding:"4px 8px", borderRadius:"6px", fontSize:"9px", cursor:"pointer", fontWeight:"700", border:check?.estado===val?`2px solid ${color}`:"1px solid "+borde, background:check?.estado===val?bg:cardBg, color:check?.estado===val?color:subtexto }}>
                            {label.split(" ")[0]}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div style={{ marginTop:"8px" }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"4px" }}>
                        <span style={{ fontSize:"10px", color:subtexto }}>Observación</span>
                        {check && check.estado && check.estado !== "ok" && (
                          <button onClick={() => ariaRedactarObservacion(item, check.estado)} disabled={ariaItemCargando===item.id}
                            style={{ padding:"3px 9px", background:ariaItemCargando===item.id?"#9ca3af":"#7B5BF2", color:"white", border:"none", borderRadius:"6px", cursor:ariaItemCargando===item.id?"not-allowed":"pointer", fontSize:"10px", fontWeight:"600" }}>
                            {ariaItemCargando===item.id?"✍️ Redactando...":"🤖 ARIA redacta"}
                          </button>
                        )}
                      </div>
                      <textarea rows={2} placeholder="Observación / nota sobre este ítem..."
                        value={check?.observacion||""} onChange={e => marcarItem(item.id, check?.estado||"ok", e.target.value)}
                        style={{ ...inp, resize:"none", fontSize:"11px" }}/>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        {/* Agregar ítem custom */}
        <div style={{ background:cardBg, borderRadius:"12px", border:`1px dashed ${borde}`, padding:"14px 18px", marginBottom:"16px" }}>
          <p style={{ fontSize:"12px", fontWeight:"700", color:"#7B5BF2", margin:"0 0 10px" }}>➕ Agregar ítem personalizado</p>
          <input placeholder="Descripción del ítem..."
            value={customItemTexto} onChange={e=>setCustomItemTexto(e.target.value)}
            style={{ ...inp, marginBottom:"8px" }}/>
          <div style={{ display:"flex", gap:"8px" }}>
            <input placeholder="Referencia normativa (ej: Dec. 351/79 Art. 42)"
              value={customItemRef} onChange={e=>setCustomItemRef(e.target.value)}
              style={{ ...inp, flex:1 }}/>
            <select value={customItemCat} onChange={e=>setCustomItemCat(e.target.value)}
              style={{ ...inp, width:"auto" }}>
              {[...new Set(itemsChecklist.map(i=>i.categoria))].map(cat=>(
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>
          <button onClick={() => {
            const texto = customItemTexto.trim();
            if (!texto) return;
            const nuevoItem = { id:`custom_${Date.now()}`, categoria:customItemCat||"Documentación", texto, ref:customItemRef||"Personalizado", custom:true };
            const empresa = empresas.find(e => e.id === visitaSel.empresaId);
            if (!empresa) return;
            const empAct = { ...empresa, itemsCustom:[...(empresa.itemsCustom||[]), nuevoItem] };
            guardarEmpresas(empresas.map(e => e.id===empAct.id ? empAct : e));
            setCustomItemTexto('');
            setCustomItemRef('');
          }} style={{ width:"100%", padding:"9px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600", marginTop:"10px" }}>
            Agregar ítem
          </button>
        </div>
        </div>
      </div>
    );
  }

  // ── DASHBOARD AMBIENTAL ──
  if (vista === "dashboard_ambiental") {
    const rojos  = dashboardAmbData.filter(r => r.semaforo === "🔴").length;
    const amaris = dashboardAmbData.filter(r => r.semaforo === "🟡").length;
    const verdes = dashboardAmbData.filter(r => r.semaforo === "🟢").length;
    return (
      <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
        <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100 }}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
            <button onClick={() => setVista("dashboard")} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
            <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>📊 Dashboard Ambiental</span>
          </div>
        </div>
        <div style={{ padding:"1rem 1.5rem" }}>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
            {[["Empresas", empresas.length, "#7B5BF2"], ["🔴 Críticas", rojos, rojos>0?"#e63946":"#6b7280"], ["🟡 Atención", amaris, amaris>0?"#d97706":"#6b7280"], ["🟢 OK", verdes, "#16a34a"]].map(([l,v,c]) => (
              <div key={l} style={{ background:cardBg, borderRadius:"12px", padding:"1rem", border:`1px solid ${borde}`, textAlign:"center" }}>
                <p style={{ fontSize:"22px", fontWeight:"700", color:c, margin:0 }}>{v}</p>
                <p style={{ fontSize:"10px", color:subtexto, margin:"4px 0 0" }}>{l}</p>
              </div>
            ))}
          </div>
          {dashboardAmbCargando
            ? <p style={{ color:subtexto, textAlign:"center", padding:"3rem" }}>⏳ Cargando datos...</p>
            : (() => {
                const hoy   = new Date(); hoy.setHours(0,0,0,0);
                const hoy14 = new Date(hoy); hoy14.setDate(hoy14.getDate() + 14);
                const urgentes = [];
                aspectos.forEach(a => {
                  if (!calcularSignificancia(a.probabilidad, a.consecuencia, a.flag_lp, a.flag_pi).es_significativo) return;
                  const emp = empresas.find(e => e.id === a.empresa_id);
                  if (!emp) return;
                  if (!a.plan_accion?.accion) { urgentes.push({ tipo:"sin_plan", a, emp }); return; }
                  const est = a.plan_accion.estado;
                  if (est === "Completado" || est === "Verificado") return;
                  if (!a.plan_accion.plazo) return;
                  const plazo = new Date(a.plan_accion.plazo);
                  if (plazo < hoy)         urgentes.push({ tipo:"vencido",  a, emp });
                  else if (plazo <= hoy14) urgentes.push({ tipo:"proximo",  a, emp });
                });
                urgentes.sort((x, y) => {
                  const ord = { vencido:0, proximo:1, sin_plan:2 };
                  if (ord[x.tipo] !== ord[y.tipo]) return ord[x.tipo] - ord[y.tipo];
                  if (x.tipo !== "sin_plan") return new Date(x.a.plan_accion.plazo) - new Date(y.a.plan_accion.plazo);
                  return x.emp.nombre.localeCompare(y.emp.nombre);
                });
                const venc  = urgentes.filter(u => u.tipo === "vencido").length;
                const prox  = urgentes.filter(u => u.tipo === "proximo").length;
                const sinPl = urgentes.filter(u => u.tipo === "sin_plan").length;
                const chipUrg = {
                  vencido:  { label:"🔴 Vencido",  c:"#dc2626", bg:"#fee2e2" },
                  proximo:  { label:"🟡 Próximo",  c:"#d97706", bg:"#fef3c7" },
                  sin_plan: { label:"⚪ Sin plan", c:"#6b7280", bg:oscuro?"#1e293b":"#f1f5f9" },
                };
                return (
                  <>
                    {urgentes.length > 0 && (
                      <div style={{ background:cardBg, borderRadius:"12px", border:`1px solid ${venc>0?"#dc2626":borde}`, marginBottom:"1.5rem", overflow:"hidden" }}>
                        <button onClick={() => setAccionesUrgPanel(v => !v)}
                          style={{ width:"100%", padding:"10px 14px", background:venc>0?"#fee2e240":oscuro?"#0d2160":"#fef9ee", border:"none", cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center", borderBottom:accionesUrgPanel?`1px solid ${borde}`:"none" }}>
                          <span style={{ fontSize:"13px", fontWeight:"700", color:venc>0?"#dc2626":"#d97706" }}>
                            ⚡ Acciones urgentes
                            {venc>0  && <span style={{ marginLeft:"8px", fontSize:"11px", background:"#dc2626", color:"white", borderRadius:"10px", padding:"1px 7px" }}>{venc} vencida{venc>1?"s":""}</span>}
                            {prox>0  && <span style={{ marginLeft:"6px", fontSize:"11px", background:"#d97706", color:"white", borderRadius:"10px", padding:"1px 7px" }}>{prox} próxima{prox>1?"s":""}</span>}
                            {sinPl>0 && <span style={{ marginLeft:"6px", fontSize:"11px", background:"#6b7280", color:"white", borderRadius:"10px", padding:"1px 7px" }}>{sinPl} sin plan</span>}
                          </span>
                          <span style={{ fontSize:"11px", color:subtexto }}>{accionesUrgPanel ? "▲" : "▼"}</span>
                        </button>
                        {accionesUrgPanel && (
                          <div style={{ maxHeight:"420px", overflowY:"auto" }}>
                            {urgentes.map((u, i) => {
                              const chip     = chipUrg[u.tipo];
                              const pa       = u.a.plan_accion || {};
                              const plazoFmt = pa.plazo ? new Date(pa.plazo + "T00:00:00").toLocaleDateString("es-AR") : "—";
                              const plazoCol = u.tipo === "vencido" ? "#dc2626" : u.tipo === "proximo" ? "#d97706" : subtexto;
                              const aspTxt   = (u.a.aspecto || "—").length > 45 ? (u.a.aspecto || "").slice(0,44) + "…" : (u.a.aspecto || "—");
                              return (
                                <div key={u.a.id} style={{ display:"grid", gridTemplateColumns:"100px 1fr 1fr 90px 90px 62px", padding:"9px 14px", borderBottom:i<urgentes.length-1?`1px solid ${borde}`:"none", alignItems:"center" }}>
                                  <span style={{ fontSize:"10px", fontWeight:"700", color:chip.c, background:chip.bg, borderRadius:"6px", padding:"2px 7px", display:"inline-block", whiteSpace:"nowrap" }}>{chip.label}</span>
                                  <div style={{ paddingLeft:"8px" }}>
                                    <p style={{ fontSize:"12px", fontWeight:"600", color:texto, margin:0 }}>{u.emp.nombre}</p>
                                    <p style={{ fontSize:"10px", color:subtexto, margin:"1px 0 0" }}>{u.emp.rubro}</p>
                                  </div>
                                  <p title={u.a.aspecto} style={{ fontSize:"11px", color:texto, margin:0, paddingLeft:"8px" }}>{aspTxt}</p>
                                  <p style={{ fontSize:"11px", color:subtexto, margin:0, paddingLeft:"4px" }}>{pa.responsable || "—"}</p>
                                  <p style={{ fontSize:"11px", fontWeight:"600", color:plazoCol, margin:0, paddingLeft:"4px" }}>{plazoFmt}</p>
                                  <button onClick={() => { setEmpresaSel(u.emp); setTabEmpresa("aspectos"); setPlanAccionAbierto(u.a.id); setPlanAccionForm(u.a.plan_accion || { accion:"", responsable:"", plazo:"", estado:"Pendiente", evidencia:"", observaciones:"" }); setNormativaAria(""); setNormativaHistorial([]); setVista("empresa"); }}
                                    style={{ padding:"5px 8px", background:"#2A7FFF22", border:"1px solid #2A7FFF", borderRadius:"6px", cursor:"pointer", color:"#2A7FFF", fontSize:"10px", fontWeight:"600" }}>
                                    Ver →
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}

                    {dashboardAmbData.length === 0
                      ? <p style={{ color:subtexto, textAlign:"center", padding:"3rem" }}>Sin empresas registradas.</p>
                      : (
                          <div style={{ background:cardBg, borderRadius:"12px", border:`1px solid ${borde}`, overflow:"hidden" }}>
                            <div style={{ display:"grid", gridTemplateColumns:"40px 1fr 70px 70px 110px 120px 80px 70px", background:navBg, padding:"8px 12px" }}>
                              {["","Empresa","Sig.","Sin ctrl","Última visita","Último análisis","IMA",""].map((h,i) => (
                                <span key={i} style={{ fontSize:"10px", fontWeight:"700", color:"rgba(255,255,255,0.7)", padding:"0 4px", textAlign:h==="IMA"?"center":"left" }}>{h}</span>
                              ))}
                            </div>
                            {dashboardAmbData.map(row => (
                              <div key={row.empresa.id} style={{ display:"grid", gridTemplateColumns:"40px 1fr 70px 70px 110px 120px 80px 70px", padding:"10px 12px", borderBottom:`1px solid ${borde}`, alignItems:"center" }}>
                                <span style={{ fontSize:"18px", textAlign:"center" }}>{row.semaforo}</span>
                                <div>
                                  <p style={{ fontSize:"13px", fontWeight:"600", color:texto, margin:0 }}>{row.empresa.nombre}</p>
                                  <p style={{ fontSize:"10px", color:subtexto, margin:"2px 0 0" }}>{row.empresa.rubro}</p>
                                </div>
                                <span style={{ fontSize:"13px", fontWeight:"700", color:row.sigCount>0?"#dc2626":"#16a34a", textAlign:"center", paddingLeft:"8px" }}>{row.sigCount}</span>
                                <span style={{ fontSize:"13px", fontWeight:"700", color:row.sinControl>0?"#dc2626":"#16a34a", textAlign:"center", paddingLeft:"8px" }}>{row.sinControl}</span>
                                <span style={{ fontSize:"11px", color:subtexto, paddingLeft:"4px" }}>{row.lastVisita || "—"}</span>
                                <span style={{ fontSize:"11px", paddingLeft:"4px", color: row.lastAnal ? ((Date.now()-new Date(row.lastAnal))/(1000*60*60*24*30)>6 ? "#d97706" : "#16a34a") : "#e63946" }}>
                                  {row.lastAnal ? new Date(row.lastAnal).toLocaleDateString("es-AR") : "Sin análisis"}
                                </span>
                                {(() => {
                                  const ima = calcularIMA(aspectos.filter(a => a.empresa_id === row.empresa.id), row.lastAnal);
                                  return (
                                    <div style={{ paddingLeft:"4px", textAlign:"center" }}>
                                      <span style={{ fontSize:"14px", fontWeight:"800", color:ima.color }}>{ima.total}</span>
                                      <span style={{ marginLeft:"4px", fontSize:"11px", fontWeight:"700", background:ima.color+"22", color:ima.color, borderRadius:"5px", padding:"1px 5px" }}>{ima.nota}</span>
                                    </div>
                                  );
                                })()}
                                <button onClick={() => { setEmpresaSel(row.empresa); setTabEmpresa("aspectos"); setNormativaAria(""); setNormativaHistorial([]); setVista("empresa"); }}
                                  style={{ padding:"5px 10px", background:"#2A7FFF22", border:"1px solid #2A7FFF", borderRadius:"6px", cursor:"pointer", color:"#2A7FFF", fontSize:"10px", fontWeight:"600" }}>
                                  Ver →
                                </button>
                              </div>
                            ))}
                          </div>
                        )
                    }
                  </>
                );
              })()
          }
        </div>
      </div>
    );
  }

  // ── DASHBOARD PRINCIPAL ──
  const totalCriticos = hallazgos.filter(h => h.estado === "critico").length;
  const totalVisitasMes = visitas.filter(v => v.fecha?.slice(0,7) === fechaHoy().slice(0,7)).length;

  return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
          <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Menú</button>
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>🔍 ALQOS Asesor</span>
          {syncing && <span style={{ fontSize:"10px", color:"#86efac" }}>🔄</span>}
        </div>
        <div style={{ display:"flex", gap:"8px", alignItems:"center" }}>
          {usuario?.rol === "Administrador" && (
            <button onClick={() => { cargarDashboardAmbiental(); setVista("dashboard_ambiental"); }}
              style={{ padding:"7px 14px", background:"rgba(255,255,255,0.1)", color:"white", border:"1px solid rgba(255,255,255,0.3)", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>
              📊 Dashboard
            </button>
          )}
          {usuario?.rol === "Administrador" && (
            <button onClick={enriquecerBaseNormativa} disabled={enriqueciendoBase}
              style={{ padding:"7px 14px", background:"rgba(255,255,255,0.1)", color:"white", border:"1px solid rgba(255,255,255,0.3)", borderRadius:"8px", cursor:enriqueciendoBase?"not-allowed":"pointer", fontSize:"12px", fontWeight:"600", opacity:enriqueciendoBase?0.6:1 }}>
              {enriqueciendoBase && progresoEnriquecer
                ? `🔄 Procesadas ${progresoEnriquecer.procesadas} / ${progresoEnriquecer.total ?? "…"}`
                : "🔄 Enriquecer base normativa"}
            </button>
          )}
          <button onClick={() => setVista("nueva_empresa")}
            style={{ padding:"7px 14px", background:"#7B5BF2", color:"white", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>
            + Nueva empresa
          </button>
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="consultor_hs" oscuro={oscuro} />}
        </div>
      </div>

      <div style={{ padding:"1rem 1.5rem" }}>

        {/* Panel lateral post-its + kanban */}
        <div style={{ display:'grid', gridTemplateColumns:'1fr 320px', gap:'16px', alignItems:'start' }}>
        <div>
        {/* KPIs globales */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))", gap:"10px", marginBottom:"1.5rem" }}>
          {[
            ["Empresas",        empresas.length,    "#7B5BF2"],
            ["Visitas este mes", totalVisitasMes,   "#3b82f6"],
            ["Total visitas",   visitas.length,     "#6b7280"],
            ["Hallazgos críticos", totalCriticos,   totalCriticos>0?"#e63946":"#22c55e"],
          ].map(([lab,val,col]) => (
            <div key={lab} style={{ background:cardBg, borderRadius:"12px", padding:"1rem", border:`1px solid ${borde}`, textAlign:"center" }}>
              <p style={{ fontSize:"20px", fontWeight:"700", color:col, margin:0 }}>{val}</p>
              <p style={{ fontSize:"10px", color:subtexto, margin:"4px 0 0", lineHeight:"1.3" }}>{lab}</p>
            </div>
          ))}
        </div>

        {/* Agenda de compliance */}
        <div style={{ marginBottom:"12px" }}>
          <button onClick={agendaVisible ? () => setAgendaVisible(false) : cargarAgenda}
            disabled={agendaCargando}
            style={{ width:"100%", padding:"10px 14px", background:agendaVisible?"#0d2160":"linear-gradient(135deg,#1C3FAA,#2A7FFF)", color:"white", border:"none", borderRadius:"10px", cursor:agendaCargando?"not-allowed":"pointer", fontSize:"13px", fontWeight:"600", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
            <span>📅 Agenda de Compliance {agendaCargando ? "— cargando..." : ""}</span>
            <span>{agendaVisible ? "▲ Cerrar" : "▼ Ver vencimientos"}</span>
          </button>
          {agendaVisible && !agendaCargando && (
            <div style={{ background:cardBg, borderRadius:"0 0 10px 10px", border:`1px solid ${borde}`, borderTop:"none", padding:"14px" }}>
              {Object.keys(agendaData).length === 0
                ? <p style={{ fontSize:"12px", color:subtexto, textAlign:"center", padding:"1rem" }}>✅ Sin vencimientos próximos en los próximos 60 días</p>
                : Object.values(agendaData).map(({ nombre, vencimientos }) => (
                  <div key={nombre} style={{ marginBottom:"14px" }}>
                    <p style={{ fontSize:"12px", fontWeight:"700", color:texto, margin:"0 0 8px", paddingBottom:"4px", borderBottom:`1px solid ${borde}` }}>🏭 {nombre}</p>
                    {vencimientos.map((v, i) => {
                      const urgente = v.diasRestantes <= 0;
                      const proximo = v.diasRestantes <= 15;
                      const color = urgente ? "#e63946" : proximo ? "#f59e0b" : "#3b82f6";
                      const bg = urgente ? "#fee2e2" : proximo ? "#fef3c7" : "#dbeafe";
                      return (
                        <div key={i} style={{ display:"flex", gap:"10px", alignItems:"center", padding:"6px 8px", borderRadius:"8px", background:bg, marginBottom:"5px" }}>
                          <span style={{ fontSize:"11px", fontWeight:"700", color, minWidth:"80px" }}>
                            {urgente ? "⚠️ VENCIDO" : proximo ? `⏰ ${v.diasRestantes}d` : `📅 ${v.diasRestantes}d`}
                          </span>
                          <div style={{ flex:1 }}>
                            <p style={{ fontSize:"11px", fontWeight:"600", color:texto, margin:0 }}>{v.norma}</p>
                            <p style={{ fontSize:"10px", color:subtexto, margin:0 }}>{v.titulo} · {v.frecuencia} · vence {v.fechaVence}</p>
                          </div>
                          <span style={{ fontSize:"10px", fontWeight:"700", color:v.estado==="NC"?"#e63946":"#22c55e", background:v.estado==="NC"?"#fee2e2":"#dcfce7", borderRadius:"6px", padding:"2px 6px" }}>{v.estado||"C"}</span>
                        </div>
                      );
                    })}
                  </div>
                ))
              }
            </div>
          )}
        </div>

        {/* Buscador de empresas */}
        <input
          value={busquedaEmp}
          onChange={e => setBusquedaEmp(e.target.value)}
          placeholder="🔍 Buscar empresa por nombre, rubro o localidad..."
          style={{ width:"100%", padding:"10px 14px", borderRadius:"10px", border:`1px solid ${borde}`, fontSize:"13px", boxSizing:"border-box", marginBottom:"12px", background:cardBg, color:texto }}
        />

        {/* Leyenda semáforo */}
        <div style={{ display:"flex", gap:"16px", alignItems:"center", background:cardBg, borderRadius:"10px", padding:"8px 14px", marginBottom:"12px", border:`1px solid ${borde}`, flexWrap:"wrap" }}>
          <span style={{ fontSize:"10px", fontWeight:"700", color:subtexto, textTransform:"uppercase", letterSpacing:".08em" }}>Referencias:</span>
          {[["🟢","OK — sin hallazgos, visita reciente, puntaje ≥80%"],["🟡","Atención — hallazgos mayores, puntaje <80% o >25 días sin visita"],["🔴","Crítico — hallazgos críticos, puntaje <60% o >45 días sin visita"],["⚪","Sin datos — sin visitas registradas"]].map(([e,l])=>(
            <div key={e} style={{ display:"flex", alignItems:"center", gap:"5px" }}>
              <span style={{ fontSize:"14px" }}>{e}</span>
              <span style={{ fontSize:"10px", color:subtexto }}>{l}</span>
            </div>
          ))}
        </div>

        {/* Agenda de compliance */}
        {(() => {
          const hoy = new Date();
          const alertas = [];
          empresas.forEach(e => {
            const vemp = visitas.filter(v => v.empresaId === e.id);
            const ultima = vemp.sort((a,b)=>new Date(b.fecha)-new Date(a.fecha))[0];
            if (ultima) {
              const diasDesde = Math.floor((hoy - new Date(ultima.fecha)) / 86400000);
              if (diasDesde > 30) alertas.push({ empresa:e.nombre, msg:`Sin visita hace ${diasDesde} días`, color:"#e63946", icon:"⚠️" });
              else if (diasDesde > 20) alertas.push({ empresa:e.nombre, msg:`Visita hace ${diasDesde} días`, color:"#f59e0b", icon:"🔔" });
            } else {
              alertas.push({ empresa:e.nombre, msg:"Sin visitas registradas", color:"#e63946", icon:"🚨" });
            }
            const criticos = hallazgos.filter(h=>h.empresaId===e.id&&h.estado==="critico").length;
            if (criticos > 0) alertas.push({ empresa:e.nombre, msg:`${criticos} hallazgo${criticos>1?"s":""} crítico${criticos>1?"s":""} sin resolver`, color:"#e63946", icon:"🚨" });
          });
          if (!alertas.length) return null;
          return (
            <div style={{ background:cardBg, borderRadius:"12px", border:`1.5px solid #fca5a5`, padding:"14px 18px", marginBottom:"16px" }}>
              <p style={{ fontSize:"12px", fontWeight:"700", color:"#e63946", margin:"0 0 10px", display:"flex", alignItems:"center", gap:"6px" }}>⚠️ Alertas de compliance</p>
              {alertas.slice(0,5).map((a,i) => (
                <div key={i} style={{ display:"flex", alignItems:"center", gap:"8px", padding:"5px 0", borderBottom:`0.5px solid ${borde}`, fontSize:"12px" }}>
                  <span>{a.icon}</span>
                  <span style={{ fontWeight:"600", color:texto }}>{a.empresa}</span>
                  <span style={{ color:a.color, marginLeft:"auto" }}>{a.msg}</span>
                </div>
              ))}
            </div>
          );
        })()}

        {/* Lista empresas */}
        {(() => {
          const esAdministrador = usuario?.rol === "Administrador";
          // empresas ya viene filtrada server-side por organizacion_id (ver sincronizar() arriba)
          const empresasFiltradas = empresas.filter(e => {
            const q = busquedaEmp.trim().toLowerCase();
            if (!q) return true;
            return (e.nombre||"").toLowerCase().includes(q)
                || (e.rubro||"").toLowerCase().includes(q)
                || (e.localidad||"").toLowerCase().includes(q)
                || (e.municipio||"").toLowerCase().includes(q)
                || (e.provincia||"").toLowerCase().includes(q);
          });
          if (empresasFiltradas.length === 0) return (
            <div style={{ textAlign:"center", padding:"4rem" }}>
              <p style={{ fontSize:"40px" }}>🏭</p>
              <p style={{ fontSize:"15px", color:texto, marginTop:"8px", fontWeight:"600" }}>Sin empresas clientes</p>
              <p style={{ fontSize:"13px", color:subtexto, marginTop:"4px" }}>{esAdministrador ? "Agregá tu primera empresa para comenzar" : "No tenés organizaciones asignadas todavía"}</p>
            </div>
          );
          return empresasFiltradas.map(e => {
              const vemp = visitasEmpresa(e.id);
              const ultima = vemp.sort((a,b)=>new Date(b.fecha)-new Date(a.fecha))[0];
              const pts = ultima ? puntajeVisita(ultima.id) : null;
              const criticos = hallazgos.filter(h=>h.empresaId===e.id&&h.estado==="critico").length;
              return (
                <div key={e.id} onClick={() => { setEmpresaSel(e); setTabEmpresa("visitas"); setVista("empresa"); setNormativaAria(""); setNormativaHistorial([]); }}
                  style={{ ...card, cursor:"pointer" }}
                  onMouseEnter={ev=>ev.currentTarget.style.boxShadow="0 4px 16px rgba(123,91,242,0.15)"}
                  onMouseLeave={ev=>ev.currentTarget.style.boxShadow="none"}>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                    <div>
                      <p style={{ fontSize:"14px", fontWeight:"700", color:texto, margin:"0 0 3px" }}>{e.nombre}</p>
                      <p style={{ fontSize:"12px", color:subtexto, margin:"0 0 2px" }}>{e.rubro} · {e.localidad}, {e.provincia}</p>
                      <p style={{ fontSize:"11px", color:subtexto }}>
                        {vemp.length} visita{vemp.length!==1?"s":""} · Última: {ultima?.fecha||"—"}
                        {criticos>0 && <span style={{ marginLeft:"8px", color:"#e63946", fontWeight:"700" }}>⚠️ {criticos} crítico{criticos!==1?"s":""}</span>}
                      </p>
                    </div>
                    <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                      {(() => {
                        const sem = calcularSemaforo(e);
                        return (
                          <div style={{ textAlign:"center", background:sem.bg, borderRadius:"10px", padding:"7px 12px", minWidth:"70px" }}>
                            <p style={{ fontSize:"20px", margin:"0 0 2px" }}>{sem.emoji}</p>
                            <p style={{ fontSize:"9px", color:sem.color, fontWeight:"700", margin:0 }}>{sem.label}</p>
                            {pts !== null && <p style={{ fontSize:"9px", color:subtexto, margin:0 }}>{pts}%</p>}
                          </div>
                        );
                      })()}
                      <span style={{ fontSize:"18px" }}>›</span>
                    </div>
                  </div>
                  <div style={{ display:"flex", gap:"6px", marginTop:"10px", borderTop:`0.5px solid ${borde}`, paddingTop:"8px" }}>
                    <button onClick={ev => { ev.stopPropagation(); setEditandoEmpresa(e.id); setFormEmpresa({...e}); setVista("nueva_empresa"); }}
                      style={{ flex:1, padding:"5px", background:"rgba(42,127,255,0.1)", border:"1px solid #2A7FFF", borderRadius:"7px", cursor:"pointer", fontSize:"11px", fontWeight:"600", color:"#2A7FFF" }}>
                      ✏️ Editar
                    </button>
                    <button onClick={ev => { ev.stopPropagation(); if(window.confirm(`Eliminar ${e.nombre}?`)) {
                      const visitasEliminadas = visitas.filter(v => v.empresaId === e.id);
                      const hallazgosEliminados = hallazgos.filter(h => h.empresaId === e.id);
                      guardarEmpresas(empresas.filter(x => x.id !== e.id));
                      guardarVisitas(visitas.filter(v => v.empresaId !== e.id));
                      guardarHallazgos(hallazgos.filter(h => h.empresaId !== e.id));
                      eliminarDato(STORAGE_EMPRESAS, e.id);
                      visitasEliminadas.forEach(v => eliminarDato(STORAGE_VISITAS, v.id));
                      hallazgosEliminados.forEach(h => eliminarDato(STORAGE_HALLAZGOS, h.id));
                    }}}
                      style={{ flex:1, padding:"5px", background:"rgba(230,57,70,0.1)", border:"1px solid #e63946", borderRadius:"7px", cursor:"pointer", fontSize:"11px", fontWeight:"600", color:"#e63946" }}>
                      🗑 Eliminar
                    </button>
                  </div>
                </div>
              );
            });
        })()}
      </div>

        {/* Panel derecho */}
        <div>
          {/* Tabs */}
          <div style={{ display:'flex', gap:'6px', marginBottom:'12px' }}>
            {[['notas','📌 Post-its'],['kanban','🗂 Tareas']].map(([t,l])=>(
              <button key={t} onClick={()=>setTabPanel(t)}
                style={{ padding:'5px 12px', borderRadius:'20px', fontSize:'11px', cursor:'pointer', fontWeight:'600', border:tabPanel===t?'2px solid #7B5BF2':'1px solid '+borde, background:tabPanel===t?'rgba(123,91,242,.1)':cardBg, color:tabPanel===t?'#7B5BF2':subtexto }}>
                {l}
              </button>
            ))}
          </div>

          {/* POST-ITS */}
          {tabPanel==='notas' && (
            <div>
              <button onClick={()=>setShowFormSticker(true)} style={{ width:'100%', padding:'8px', background:'#7B5BF2', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'12px', fontWeight:'600', marginBottom:'10px' }}>+ Nuevo post-it</button>
              {showFormSticker && (
                <div style={{ background:cardBg, borderRadius:'12px', border:'1px solid '+borde, padding:'12px', marginBottom:'10px' }}>
                  <div style={{ display:'flex', gap:'6px', marginBottom:'8px' }}>
                    {COLORES_STICKER.map(color=>(
                      <div key={color} onClick={()=>setStickerColor(color)}
                        style={{ width:'24px', height:'24px', borderRadius:'6px', background:color, border:stickerColor===color?'2px solid #7B5BF2':'2px solid transparent', cursor:'pointer' }}/>
                    ))}
                  </div>
                  <textarea rows={3} value={stickerTexto} onChange={e=>setStickerTexto(e.target.value)}
                    placeholder="Escribí el recordatorio..." style={{ width:'100%', padding:'8px', borderRadius:'8px', border:'1px solid '+borde, fontSize:'12px', resize:'none', background:stickerColor, boxSizing:'border-box' }}/>
                  <div style={{ display:'flex', gap:'6px', marginTop:'8px' }}>
                    <button onClick={agregarSticker} style={{ flex:1, padding:'7px', background:'#7B5BF2', color:'white', border:'none', borderRadius:'7px', cursor:'pointer', fontSize:'12px', fontWeight:'600' }}>Guardar</button>
                    <button onClick={()=>setShowFormSticker(false)} style={{ padding:'7px 12px', background:'none', border:'1px solid '+borde, borderRadius:'7px', cursor:'pointer', fontSize:'12px', color:texto }}>✕</button>
                  </div>
                </div>
              )}
              {stickers.length===0
                ? <p style={{ textAlign:'center', color:subtexto, fontSize:'12px', padding:'1rem' }}>Sin post-its</p>
                : stickers.map(s=>(
                  <div key={s.id} style={{ background:s.color, borderRadius:'10px', padding:'10px 12px', marginBottom:'8px', position:'relative' }}>
                    <p style={{ fontSize:'12px', color:'#374151', margin:'0 0 4px', lineHeight:'1.5' }}>{s.texto}</p>
                    <p style={{ fontSize:'10px', color:'#6b7280', margin:0 }}>{s.fecha} · {s.usuario}</p>
                    <button onClick={()=>{ guardarStickers(stickers.filter(x=>x.id!==s.id)); eliminarDato(STORAGE_STICKERS, s.id); }}
                      style={{ position:'absolute', top:'6px', right:'8px', background:'none', border:'none', cursor:'pointer', fontSize:'14px', color:'#9ca3af' }}>✕</button>
                  </div>
                ))
              }
            </div>
          )}

          {/* KANBAN */}
          {tabPanel==='kanban' && (
            <div>
              <button onClick={()=>setShowFormTarea(true)} style={{ width:'100%', padding:'8px', background:'#2A7FFF', color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'12px', fontWeight:'600', marginBottom:'10px' }}>+ Nueva tarea</button>
              {showFormTarea && (
                <div style={{ background:cardBg, borderRadius:'12px', border:'1px solid '+borde, padding:'12px', marginBottom:'10px' }}>
                  <input placeholder="Título de la tarea" value={formTarea.titulo||''} onChange={e=>setFormTarea(f=>({...f,titulo:e.target.value}))}
                    style={{ width:'100%', padding:'7px 10px', borderRadius:'7px', border:'1px solid '+borde, fontSize:'12px', background:cardBg, color:texto, boxSizing:'border-box', marginBottom:'6px' }}/>
                  <select value={formTarea.prioridad} onChange={e=>setFormTarea(f=>({...f,prioridad:e.target.value}))}
                    style={{ width:'100%', padding:'7px', borderRadius:'7px', border:'1px solid '+borde, fontSize:'12px', background:cardBg, color:texto, marginBottom:'6px' }}>
                    <option value="alta">🔴 Alta prioridad</option>
                    <option value="media">🟡 Media prioridad</option>
                    <option value="baja">🟢 Baja prioridad</option>
                  </select>
                  <div style={{ display:'flex', gap:'6px' }}>
                    <button onClick={agregarTarea} style={{ flex:1, padding:'7px', background:'#2A7FFF', color:'white', border:'none', borderRadius:'7px', cursor:'pointer', fontSize:'12px', fontWeight:'600' }}>Guardar</button>
                    <button onClick={()=>setShowFormTarea(false)} style={{ padding:'7px 12px', background:'none', border:'1px solid '+borde, borderRadius:'7px', cursor:'pointer', fontSize:'12px', color:texto }}>✕</button>
                  </div>
                </div>
              )}
              {COLUMNAS_KANBAN.map(col=>{
                const tareasCol = tareas.filter(t=>t.columna===col.key);
                return (
                  <div key={col.key}
                    onDragOver={e=>{e.preventDefault();setDragOver(col.key);}}
                    onDrop={()=>{if(dragId){moverTarea(dragId,col.key);setDragId(null);setDragOver(null);}}}
                    style={{ background:dragOver===col.key?col.bg:cardBg, borderRadius:'10px', border:`1.5px solid ${dragOver===col.key?col.color:borde}`, padding:'8px', marginBottom:'8px' }}>
                    <p style={{ fontSize:'11px', fontWeight:'700', color:col.color, margin:'0 0 6px', display:'flex', alignItems:'center', gap:'4px' }}>
                      {col.emoji} {col.label} <span style={{ marginLeft:'auto', background:col.bg, borderRadius:'10px', padding:'1px 6px', fontSize:'10px' }}>{tareasCol.length}</span>
                    </p>
                    {tareasCol.map(t=>(
                      <div key={t.id} draggable onDragStart={()=>setDragId(t.id)}
                        style={{ background:oscuro?'#0d2160':'#f9fafb', borderRadius:'7px', padding:'7px 9px', marginBottom:'5px', cursor:'grab', border:'1px solid '+borde }}>
                        <p style={{ fontSize:'11px', fontWeight:'600', color:texto, margin:'0 0 2px' }}>{t.titulo}</p>
                        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                          <span style={{ fontSize:'9px', color:t.prioridad==='alta'?'#dc2626':t.prioridad==='media'?'#d97706':'#16a34a', fontWeight:'600' }}>
                            {t.prioridad==='alta'?'🔴':t.prioridad==='media'?'🟡':'🟢'} {t.prioridad}
                          </span>
                          <button onClick={()=>{ guardarTareas(tareas.filter(x=>x.id!==t.id)); eliminarDato(STORAGE_TAREAS, t.id); }}
                            style={{ background:'none', border:'none', cursor:'pointer', fontSize:'12px', color:'#9ca3af' }}>✕</button>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        </div>{/* cierre grid */}
      </div>
    </div>
  );
}
